import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** A date string, such as 2007-12-03, compliant with the `full-date` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  Date: any;
  /** The javascript `Date` as string. Type represents date and time as the ISO Date string. */
  DateTime: any;
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: any;
  /** The `Upload` scalar type represents a file upload. */
  Upload: any;
};

export type AppProfessionalContext = {
  EHRCompatibility?: Maybe<Array<EhrCompatibility>>;
  availabilityMaxNumber?: Maybe<Scalars['Int']>;
  availabilityShifts?: Maybe<AvailabilityShifts>;
  availabilityStartAt?: Maybe<Scalars['DateTime']>;
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  degreeObtained?: Maybe<Scalars['String']>;
  employmentHistory?: Maybe<Scalars['String']>;
  employmentStatus?: Maybe<EmploymentStatus>;
  graduatingInstitution?: Maybe<Scalars['String']>;
  graduationYear?: Maybe<Scalars['Int']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  jobTypeSeeking?: Maybe<Array<Scalars['String']>>;
  lastFourSSN?: Maybe<Scalars['String']>;
  levelOfTraining?: Maybe<LevelOfTrainingApp>;
  npi?: Maybe<Scalars['String']>;
  professionalReferencesText?: Maybe<Scalars['String']>;
  specialty?: Maybe<Scalars['String']>;
  type: UserRole;
  yearLastPracticed?: Maybe<Scalars['String']>;
};

/** The actions we currently can record in Audits */
export enum ActionType {
  AssignRoles = 'AssignRoles',
  ChangeProviderType = 'ChangeProviderType',
  DeleteUser = 'DeleteUser',
  InvalidateAllTokens = 'InvalidateAllTokens',
  InvalidateToken = 'InvalidateToken',
  JobApplicationSharableProfileTokenCreated = 'JobApplicationSharableProfileTokenCreated',
  JobApplicationSharableProfileTokenDeleted = 'JobApplicationSharableProfileTokenDeleted',
  JobApplicationSharableProfileTokenEdited = 'JobApplicationSharableProfileTokenEdited',
  Login = 'Login',
  RetractRoles = 'RetractRoles',
  SetUserNetworkStatus = 'SetUserNetworkStatus',
  UserInvitationCreated = 'UserInvitationCreated',
  UserRegister = 'UserRegister'
}

export type AddAuthorizedUserToClinicInput = {
  email: Scalars['String'];
  id: Scalars['ID'];
};

export type AddClinicStaffMemberInput = {
  id: Scalars['ID'];
  unscopedRoles: Array<ClinicScopedRole>;
  userId: Scalars['String'];
};

export type AdminAssignClinicianAdvocateInput = {
  clinicianAdvocateId: Scalars['String'];
  userId: Scalars['String'];
};

export type AdminCreateUserNoteInput = {
  message: Scalars['String'];
  userId: Scalars['String'];
};

export type AdminDeleteUserNoteInput = {
  id: Scalars['String'];
};

export type AdminGenerateReportInput = {
  reportType?: InputMaybe<AdminReportType>;
};

export enum AdminReportType {
  UsersReport = 'UsersReport'
}

export type AdminUnassignClinicianAdvocateInput = {
  userId: Scalars['String'];
};

export type ApplyToJobInput = {
  jobId: Scalars['String'];
  utm?: InputMaybe<Scalars['JSON']>;
};

export type AuditAction = {
  actionType: ActionType;
  actorId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  payload: AuditPayload;
};

export type AuditActionsFilterInput = {
  actionType?: InputMaybe<Array<ActionType>>;
  actorId?: InputMaybe<Array<Scalars['String']>>;
};

/** The Fields you can sort the Audit Actions by. */
export enum AuditActionsSortBy {
  CreatedAt = 'CreatedAt'
}

export type AuditActionsSortInput = {
  direction?: InputMaybe<SortDirection>;
  sortBy?: InputMaybe<AuditActionsSortBy>;
};

export type AuditChangeProviderTypeActionPayload = AuditCommonActionPayload & {
  newContext: ProfessionalContext;
  newRole: UserRole;
  previousContext: ProfessionalContext;
  previousRole: UserRole;
  type: ActionType;
  userId: Scalars['String'];
};

export type AuditCommonActionPayload = {
  type: ActionType;
};

export type AuditDeleteUserActionPayload = AuditCommonActionPayload & {
  /** The email address of the user that was deleted. */
  email: Scalars['String'];
  /** The roles which the deleted user possessed at time of deletion. */
  roles: Array<Scalars['String']>;
  type: ActionType;
  /** The user ID of the user that was deleted. */
  userId: Scalars['String'];
};

export type AuditInvalidateAllTokensActionPayload = AuditCommonActionPayload & {
  type: ActionType;
};

export type AuditInvalidateTokenActionPayload = AuditCommonActionPayload & {
  ownerId: Scalars['String'];
  refreshToken: Scalars['String'];
  type: ActionType;
};

export type AuditJobApplicationSharableProfileTokenCreatedActionPayload = AuditCommonActionPayload & {
  clientDescription?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  expiresAt: Scalars['DateTime'];
  jobApplicationId: Scalars['String'];
  token: Scalars['String'];
  type: ActionType;
};

export type AuditJobApplicationSharableProfileTokenDeletedActionPayload = AuditCommonActionPayload & {
  clientDescription?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  expiresAt: Scalars['DateTime'];
  jobApplicationId: Scalars['String'];
  token: Scalars['String'];
  type: ActionType;
};

export type AuditJobApplicationSharableProfileTokenEditedActionPayload = AuditCommonActionPayload & {
  clientDescription?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  expiresAt: Scalars['DateTime'];
  jobApplicationId: Scalars['String'];
  token: Scalars['String'];
  type: ActionType;
};

export type AuditLoginActionPayload = AuditCommonActionPayload & {
  refreshToken: Scalars['String'];
  token: Scalars['String'];
  type: ActionType;
};

export type AuditManageRolesActionPayload = AuditCommonActionPayload & {
  roles: Array<Scalars['String']>;
  type: ActionType;
  userId: Scalars['String'];
};

export type AuditPayload = AuditChangeProviderTypeActionPayload | AuditDeleteUserActionPayload | AuditInvalidateAllTokensActionPayload | AuditInvalidateTokenActionPayload | AuditJobApplicationSharableProfileTokenCreatedActionPayload | AuditJobApplicationSharableProfileTokenDeletedActionPayload | AuditJobApplicationSharableProfileTokenEditedActionPayload | AuditLoginActionPayload | AuditManageRolesActionPayload | AuditSetUserNetworkStatusActionPayload | AuditUserInvitationCreatedActionPayload | AuditUserRegisterActionPayload;

export type AuditSetUserNetworkStatusActionPayload = AuditCommonActionPayload & {
  networkStatus: UserNetworkStatus;
  type: ActionType;
  userId: Scalars['String'];
};

export type AuditUserInvitationCreatedActionPayload = AuditCommonActionPayload & {
  clinicianAdvocateId: Scalars['String'];
  email: Scalars['String'];
  expiresAt: Scalars['DateTime'];
  token: Scalars['String'];
  type: ActionType;
};

export type AuditUserRegisterActionPayload = AuditCommonActionPayload & {
  method: Scalars['String'];
  pathway: Scalars['String'];
  token: Scalars['String'];
  type: ActionType;
};

export type AuthPayload = {
  token: Scalars['String'];
  userId: Scalars['String'];
};

export type AuthenticateClinicDrChronoIntegrationInput = {
  clinicId: Scalars['String'];
  code: Scalars['String'];
};

export type AvailabilityShifts = {
  fri?: Maybe<Array<Shift>>;
  mon?: Maybe<Array<Shift>>;
  sat?: Maybe<Array<Shift>>;
  sun?: Maybe<Array<Shift>>;
  thu?: Maybe<Array<Shift>>;
  tue?: Maybe<Array<Shift>>;
  wed?: Maybe<Array<Shift>>;
};

export type AvailabilityShiftsInput = {
  fri?: InputMaybe<Array<Shift>>;
  mon?: InputMaybe<Array<Shift>>;
  sat?: InputMaybe<Array<Shift>>;
  sun?: InputMaybe<Array<Shift>>;
  thu?: InputMaybe<Array<Shift>>;
  tue?: InputMaybe<Array<Shift>>;
  wed?: InputMaybe<Array<Shift>>;
};

export enum Certification {
  Acls = 'ACLS',
  Acnp = 'ACNP',
  Agacnp = 'AGACNP',
  Agpcnp = 'AGPCNP',
  Anp = 'ANP',
  Awhonn = 'AWHONN',
  Bls = 'BLS',
  Ccrn = 'CCRN',
  Dea = 'DEA',
  Enp = 'ENP',
  Fnp = 'FNP',
  Nihss = 'NIHSS',
  Nrp = 'NRP',
  Pals = 'PALS',
  Pmhnp = 'PMHNP',
  Ppcnp = 'PPCNP',
  Snp = 'SNP',
  Tncc = 'TNCC',
  Xwaiver = 'XWAIVER'
}

export type ChangeProviderTypeInput = {
  newProviderType: UserRole;
  userId: Scalars['String'];
};

export type City = {
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  image?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  slug: Scalars['String'];
  state: State;
  stateId: Scalars['String'];
};

export type Clinic = {
  accountManager?: Maybe<User>;
  accountManagerId?: Maybe<Scalars['String']>;
  amenities?: Maybe<Scalars['String']>;
  authorizedUser: Array<User>;
  authorizedUserIds: Array<Scalars['String']>;
  authorizedUsers: Array<User>;
  contacts?: Maybe<Array<ClinicContact>>;
  createdAt: Scalars['DateTime'];
  createdBy: Scalars['String'];
  id: Scalars['ID'];
  image?: Maybe<UserUploadedFile>;
  integrations?: Maybe<ClinicIntegrations>;
  jobApplicationTags?: Maybe<Array<JobApplicationTag>>;
  jobs: Array<Job>;
  name: Scalars['String'];
  numJobsActive?: Maybe<Scalars['Int']>;
  phone?: Maybe<Scalars['String']>;
  resources?: Maybe<Scalars['String']>;
  staffMembers: Array<User>;
  staffMembersIds: Array<Scalars['String']>;
  websiteUrl?: Maybe<Scalars['String']>;
  zohoUrl?: Maybe<Scalars['String']>;
};

export type ClinicContact = {
  clinicId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  createdBy: User;
  createdById: Scalars['String'];
  email?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isDeleted: Scalars['Boolean'];
  isPrimary: Scalars['Boolean'];
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type ClinicDrChronoAppointmentProfile = {
  duration: Scalars['Int'];
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type ClinicDrChronoIntegration = ClinicIntegration & {
  appointmentProfiles?: Maybe<Array<ClinicDrChronoAppointmentProfile>>;
  availableAppointments?: Maybe<Array<Scalars['DateTime']>>;
  config?: Maybe<ClinicDrChronoIntegrationConfig>;
  customization: ClinicDrChronoIntegrationCustomization;
  isActive: Scalars['Boolean'];
  offices?: Maybe<Array<ClinicDrChronoIntegrationOffice>>;
};


export type ClinicDrChronoIntegrationAppointmentProfilesArgs = {
  clinicId: Scalars['String'];
  officeId: Scalars['String'];
};


export type ClinicDrChronoIntegrationAvailableAppointmentsArgs = {
  appointmentProfileId: Scalars['String'];
  clinicId: Scalars['String'];
  filter: DrChronoAvailableAppointmentsFilter;
  officeId: Scalars['String'];
};


export type ClinicDrChronoIntegrationConfigArgs = {
  clinicId: Scalars['String'];
};


export type ClinicDrChronoIntegrationOfficesArgs = {
  clinicId: Scalars['String'];
};

export type ClinicDrChronoIntegrationConfig = {
  clientId?: Maybe<Scalars['String']>;
  clientSecret?: Maybe<Scalars['String']>;
  redirectUri?: Maybe<Scalars['String']>;
};

export type ClinicDrChronoIntegrationCustomization = {
  primaryButtonBgColor?: Maybe<Scalars['String']>;
};

export type ClinicDrChronoIntegrationOffice = {
  id: Scalars['String'];
  name: Scalars['String'];
};

export type ClinicIntegration = {
  isActive: Scalars['Boolean'];
};

export type ClinicIntegrations = {
  drChrono: ClinicDrChronoIntegration;
};

export type ClinicProfessionalContext = {
  type: UserRole;
};

export type ClinicPublic = {
  id: Scalars['ID'];
  image?: Maybe<UserUploadedFile>;
  integrations?: Maybe<ClinicIntegrations>;
  name: Scalars['String'];
  phone?: Maybe<Scalars['String']>;
};

/** Roles available to clinic staff members */
export enum ClinicScopedRole {
  Admin = 'Admin',
  Clinician = 'Clinician'
}

export type ConfigureClinicDrChronoIntegrationInput = {
  clientId: Scalars['String'];
  clientSecret: Scalars['String'];
  clinicId: Scalars['String'];
  redirectUri: Scalars['String'];
};

export type CreateClinicContactInput = {
  clinicId: Scalars['String'];
  email?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export type CreateClinicInput = {
  amenities?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  phone?: InputMaybe<Scalars['String']>;
  resources?: InputMaybe<Scalars['String']>;
  websiteUrl?: InputMaybe<Scalars['String']>;
  zohoUrl?: InputMaybe<Scalars['String']>;
};

export type CreateJobApplicationRulingDecisionEventInput = {
  decision: JobApplicationRulingDecision;
  jobApplicationId: Scalars['String'];
};

export type CreateJobApplicationRulingDecisionResetEventInput = {
  jobApplicationId: Scalars['String'];
};

export type CreateJobApplicationSharableProfileTokenInput = {
  clientDescription?: InputMaybe<Scalars['String']>;
  jobApplicationId: Scalars['String'];
};

export type CreateJobInput = {
  aboutJob?: InputMaybe<Scalars['String']>;
  clinicContactId?: InputMaybe<Scalars['String']>;
  clinicId: Scalars['String'];
  clinicianAdvocateId?: InputMaybe<Scalars['String']>;
  clinicianType?: InputMaybe<UserRole>;
  description?: InputMaybe<Scalars['String']>;
  desiredCertifications?: InputMaybe<Array<Certification>>;
  desiredHours?: InputMaybe<Scalars['String']>;
  desiredTelehealthExperience?: InputMaybe<DesiredTelehealthExperience>;
  displayClinicDetails?: InputMaybe<Scalars['Boolean']>;
  education?: InputMaybe<Scalars['String']>;
  employmentType?: InputMaybe<Array<EmploymentType>>;
  emrProviders?: InputMaybe<Array<EhrCompatibility>>;
  interviewDetails?: InputMaybe<Scalars['String']>;
  isInternal?: InputMaybe<Scalars['Boolean']>;
  isTelehealth?: InputMaybe<Scalars['Boolean']>;
  location?: InputMaybe<JobLocation>;
  minYearsExperience?: InputMaybe<NumYearsExperience>;
  numberToFill?: InputMaybe<Scalars['Int']>;
  numberToFillIsUnlimited?: InputMaybe<Scalars['Boolean']>;
  nurseSpecialty?: InputMaybe<Scalars['String']>;
  onboardingDetails?: InputMaybe<Scalars['String']>;
  orientationDetails?: InputMaybe<Scalars['String']>;
  otherInfo?: InputMaybe<Scalars['String']>;
  payAndPerks?: InputMaybe<Scalars['String']>;
  preferredLicenseStateIds?: InputMaybe<Array<Scalars['String']>>;
  profession?: InputMaybe<Scalars['String']>;
  requiredEquipment?: InputMaybe<Scalars['String']>;
  requiredLicenseStateIds?: InputMaybe<Array<Scalars['String']>>;
  requirements?: InputMaybe<Scalars['String']>;
  responsibilities?: InputMaybe<Scalars['String']>;
  salaryDetails?: InputMaybe<Scalars['String']>;
  schedulingDetails?: InputMaybe<Scalars['String']>;
  shiftDetails?: InputMaybe<Scalars['String']>;
  specialties?: InputMaybe<Array<Scalars['String']>>;
  startAt?: InputMaybe<Scalars['DateTime']>;
  stateId?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<JobStatus>;
  title: Scalars['String'];
  trainingLevel?: InputMaybe<Scalars['String']>;
  zohoUrl?: InputMaybe<Scalars['String']>;
};

export type CreateJobSuggestionInput = {
  clinicianAdvocateId: Scalars['String'];
  jobId: Scalars['String'];
  userId: Scalars['String'];
};

export type CreateJobSuggestionsInput = {
  clinicianAdvocateId: Scalars['String'];
  jobsToSuggestIds: Array<Scalars['String']>;
  userId: Scalars['String'];
};

export type CreateSharingTokenInput = {
  userId: Scalars['String'];
};

export type CreateUserInvitationInput = {
  clinicianAdvocateId: Scalars['String'];
  clinicianType: UserRole;
  email: Scalars['String'];
  firstName: Scalars['String'];
  jobsToSuggestIds?: InputMaybe<Array<Scalars['String']>>;
  lastName: Scalars['String'];
  preferredName: Scalars['String'];
};

export type CustomizeClinicDrChronoIntegrationInput = {
  clinicId: Scalars['String'];
  primaryButtonBgColor?: InputMaybe<Scalars['String']>;
};

export type DeleteClinicContactInput = {
  id: Scalars['String'];
};

export type DeleteJobApplicationSharableProfileTokenInput = {
  jobApplicationId: Scalars['String'];
};

export type DeleteJobInput = {
  id: Scalars['String'];
};

export type DeleteSharingTokenInput = {
  tokenId: Scalars['String'];
};

export type DeleteUserInput = {
  /** The user ID of the user to be deleted. */
  userId: Scalars['String'];
};

export enum DesiredTelehealthExperience {
  HasPreviousExperience = 'HasPreviousExperience',
  OpenToAny = 'OpenToAny'
}

export type DisableClinicDrChronoIntegrationInput = {
  clinicId: Scalars['String'];
};

export type DrChronoAppointment = {
  duration: Scalars['Int'];
  scheduledTime: Scalars['DateTime'];
};

export type DrChronoAppointmentInfoInput = {
  date: Scalars['DateTime'];
  profileId: Scalars['String'];
  visitReason: Scalars['String'];
};

export type DrChronoAvailableAppointmentsFilter = {
  after: Scalars['DateTime'];
  before: Scalars['DateTime'];
  cursor?: InputMaybe<Scalars['String']>;
};

export type DrChronoPatientInfoInput = {
  dateOfBirth: Scalars['DateTime'];
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  phone: Scalars['String'];
  stateId: Scalars['String'];
};

export enum EhrCompatibility {
  AllscriptsCps = 'AllscriptsCPS',
  AthenaHealth = 'AthenaHealth',
  CareCloud = 'CareCloud',
  Cerner = 'Cerner',
  Epic = 'Epic',
  Essentris = 'Essentris',
  GeCentricity = 'GECentricity',
  Meditech = 'Meditech',
  NextGen = 'NextGen',
  Other = 'Other',
  EClinicalWorks = 'eClinicalWorks'
}

export type EditClinicContactInput = {
  email?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export type EditClinicInput = {
  amenities?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  resources?: InputMaybe<Scalars['String']>;
  websiteUrl?: InputMaybe<Scalars['String']>;
  zohoUrl?: InputMaybe<Scalars['String']>;
};

export type EditJobApplicationSharableProfileTokenInput = {
  clientDescription?: InputMaybe<Scalars['String']>;
  jobApplicationId: Scalars['String'];
};

export type EditJobInput = {
  aboutJob?: InputMaybe<Scalars['String']>;
  clinicContactId?: InputMaybe<Scalars['String']>;
  clinicianAdvocateId?: InputMaybe<Scalars['String']>;
  clinicianType?: InputMaybe<UserRole>;
  description?: InputMaybe<Scalars['String']>;
  desiredCertifications?: InputMaybe<Array<Certification>>;
  desiredHours?: InputMaybe<Scalars['String']>;
  desiredTelehealthExperience?: InputMaybe<DesiredTelehealthExperience>;
  displayClinicDetails?: InputMaybe<Scalars['Boolean']>;
  education?: InputMaybe<Scalars['String']>;
  employmentType?: InputMaybe<Array<EmploymentType>>;
  emrProviders?: InputMaybe<Array<EhrCompatibility>>;
  id: Scalars['String'];
  interviewDetails?: InputMaybe<Scalars['String']>;
  isInternal?: InputMaybe<Scalars['Boolean']>;
  isTelehealth?: InputMaybe<Scalars['Boolean']>;
  location?: InputMaybe<JobLocation>;
  minYearsExperience?: InputMaybe<NumYearsExperience>;
  numberToFill?: InputMaybe<Scalars['Int']>;
  numberToFillIsUnlimited?: InputMaybe<Scalars['Boolean']>;
  nurseSpecialty?: InputMaybe<Scalars['String']>;
  onboardingDetails?: InputMaybe<Scalars['String']>;
  orientationDetails?: InputMaybe<Scalars['String']>;
  otherInfo?: InputMaybe<Scalars['String']>;
  payAndPerks?: InputMaybe<Scalars['String']>;
  preferredLicenseStateIds?: InputMaybe<Array<Scalars['String']>>;
  profession?: InputMaybe<Scalars['String']>;
  requiredEquipment?: InputMaybe<Scalars['String']>;
  requiredLicenseStateIds?: InputMaybe<Array<Scalars['String']>>;
  requirements?: InputMaybe<Scalars['String']>;
  responsibilities?: InputMaybe<Scalars['String']>;
  salaryDetails?: InputMaybe<Scalars['String']>;
  schedulingDetails?: InputMaybe<Scalars['String']>;
  shiftDetails?: InputMaybe<Scalars['String']>;
  specialties?: InputMaybe<Array<Scalars['String']>>;
  startAt?: InputMaybe<Scalars['DateTime']>;
  stateId?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<JobStatus>;
  title?: InputMaybe<Scalars['String']>;
  trainingLevel?: InputMaybe<Scalars['String']>;
  zohoUrl?: InputMaybe<Scalars['String']>;
};

export type EditUserProfileInput = {
  EHRCompatibility?: InputMaybe<Array<EhrCompatibility>>;
  availabilityMaxNumber?: InputMaybe<Scalars['Int']>;
  availabilityShifts?: InputMaybe<AvailabilityShiftsInput>;
  availabilityStartAt?: InputMaybe<Scalars['String']>;
  bio?: InputMaybe<Scalars['String']>;
  cityId?: InputMaybe<Scalars['String']>;
  currentActiveDEALicenses?: InputMaybe<Array<Scalars['String']>>;
  currentActiveLicenses?: InputMaybe<Array<Scalars['String']>>;
  currentPendingDEALicenses?: InputMaybe<Array<Scalars['String']>>;
  currentPendingLicenses?: InputMaybe<Array<Scalars['String']>>;
  dateOfBirth?: InputMaybe<Scalars['String']>;
  degreeObtained?: InputMaybe<Scalars['String']>;
  employmentHistory?: InputMaybe<Scalars['String']>;
  employmentStatus?: InputMaybe<EmploymentStatus>;
  firstName?: InputMaybe<Scalars['String']>;
  graduatingInstitution?: InputMaybe<Scalars['String']>;
  graduationYear?: InputMaybe<Scalars['Int']>;
  jobTypeSeeking?: InputMaybe<Array<EmploymentType>>;
  lastFourSSN?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  levelOfTraining?: InputMaybe<Scalars['String']>;
  npi?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  preferredName?: InputMaybe<Scalars['String']>;
  profession?: InputMaybe<Scalars['String']>;
  professionOther?: InputMaybe<Scalars['String']>;
  professionalReferencesText?: InputMaybe<Scalars['String']>;
  providerType?: InputMaybe<Scalars['String']>;
  referral?: InputMaybe<Scalars['String']>;
  referralOther?: InputMaybe<Scalars['String']>;
  salutation?: InputMaybe<Salutation>;
  specialty?: InputMaybe<Scalars['String']>;
  stateId?: InputMaybe<Scalars['String']>;
  utm?: InputMaybe<Scalars['JSON']>;
  yearLastPracticed?: InputMaybe<Scalars['Int']>;
};

export enum EmploymentStatus {
  CurrentlyEmployed = 'CurrentlyEmployed',
  NotCurrentlyEmployed = 'NotCurrentlyEmployed',
  Retired = 'Retired',
  Student = 'Student'
}

export enum EmploymentType {
  Contract = 'Contract',
  FullTime = 'FullTime',
  PartTime = 'PartTime',
  Permanent = 'Permanent',
  Temporary = 'Temporary'
}

export type InvalidateTokenInput = {
  userId: Scalars['String'];
};

export type Job = {
  aboutJob?: Maybe<Scalars['String']>;
  applicationDate?: Maybe<Scalars['DateTime']>;
  applications?: Maybe<Array<JobApplication>>;
  applied: Scalars['Boolean'];
  clinic: Clinic;
  clinicContact?: Maybe<ClinicContact>;
  clinicContactId?: Maybe<Scalars['String']>;
  clinicId: Scalars['String'];
  clinicianAdvocate?: Maybe<User>;
  clinicianAdvocateId?: Maybe<Scalars['String']>;
  clinicianType?: Maybe<UserRole>;
  createdAt: Scalars['DateTime'];
  createdBy: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  desiredCertifications?: Maybe<Array<Certification>>;
  desiredHours?: Maybe<Scalars['String']>;
  desiredTelehealthExperience?: Maybe<DesiredTelehealthExperience>;
  displayClinicDetails?: Maybe<Scalars['Boolean']>;
  education?: Maybe<Scalars['String']>;
  employmentType?: Maybe<Array<EmploymentType>>;
  emrProviders?: Maybe<Array<EhrCompatibility>>;
  id: Scalars['ID'];
  interviewDetails?: Maybe<Scalars['String']>;
  isDeleted: Scalars['Boolean'];
  isInternal: Scalars['Boolean'];
  isTelehealth?: Maybe<Scalars['Boolean']>;
  location?: Maybe<JobLocation>;
  minYearsExperience?: Maybe<NumYearsExperience>;
  numberToFill?: Maybe<Scalars['Int']>;
  numberToFillIsUnlimited?: Maybe<Scalars['Boolean']>;
  nurseSpecialty?: Maybe<Scalars['String']>;
  onboardingDetails?: Maybe<Scalars['String']>;
  orientationDetails?: Maybe<Scalars['String']>;
  otherInfo?: Maybe<Scalars['String']>;
  payAndPerks?: Maybe<Scalars['String']>;
  preferredLicenseStateIds?: Maybe<Array<Scalars['String']>>;
  preferredLicenseStates?: Maybe<Array<State>>;
  profession?: Maybe<Scalars['String']>;
  requiredEquipment?: Maybe<Scalars['String']>;
  requiredLicenseStateIds?: Maybe<Array<Scalars['String']>>;
  requiredLicenseStates?: Maybe<Array<State>>;
  requirements?: Maybe<Scalars['String']>;
  responsibilities?: Maybe<Scalars['String']>;
  salaryDetails?: Maybe<Scalars['String']>;
  schedulingDetails?: Maybe<Scalars['String']>;
  shiftDetails?: Maybe<Scalars['String']>;
  specialties?: Maybe<Array<Scalars['String']>>;
  startAt?: Maybe<Scalars['DateTime']>;
  state?: Maybe<State>;
  stateId?: Maybe<Scalars['String']>;
  status: JobStatus;
  suggestions?: Maybe<Array<JobSuggestion>>;
  title: Scalars['String'];
  trainingLevel?: Maybe<Scalars['String']>;
  zohoUrl?: Maybe<Scalars['String']>;
};

export type JobApplication = {
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  interviews?: Maybe<Array<JobInterview>>;
  job: Job;
  jobId: Scalars['String'];
  latestRuling?: Maybe<JobApplicationRulingEvent>;
  rulingEvents?: Maybe<Array<JobApplicationRulingEvent>>;
  sharableProfileToken?: Maybe<JobApplicationSharableProfileToken>;
  tagIds?: Maybe<Array<Scalars['String']>>;
  tags?: Maybe<Array<JobApplicationTag>>;
  user: User;
  userId: Scalars['String'];
  utm?: Maybe<Scalars['JSON']>;
};

export enum JobApplicationRulingDecision {
  AwaitingAccountManager = 'AwaitingAccountManager',
  MoveToZoho = 'MoveToZoho',
  No = 'No',
  Yes = 'Yes'
}

export type JobApplicationRulingEvent = {
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<User>;
  createdById: Scalars['String'];
  decision?: Maybe<JobApplicationRulingDecision>;
  decisionReset?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
};

export type JobApplicationSharableProfileToken = {
  clientDescription?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  createdBy: User;
  createdById: Scalars['String'];
  expiresAt: Scalars['DateTime'];
  isExpired: Scalars['Boolean'];
  token: Scalars['ID'];
};

export type JobApplicationTag = {
  clinicId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  name: Scalars['String'];
};

export type JobInterview = {
  createdAt: Scalars['DateTime'];
  createdBy: User;
  createdById: Scalars['String'];
  date?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  interviewer: User;
  interviewerId: Scalars['String'];
  jobApplication: JobApplication;
  jobApplicationId: Scalars['String'];
  notes: Scalars['String'];
};

export enum JobLocation {
  Remote = 'Remote',
  Statewide = 'Statewide'
}

export enum JobStatus {
  Active = 'Active',
  Cancelled = 'Cancelled',
  Declined = 'Declined',
  Filled = 'Filled',
  Inactive = 'Inactive',
  OnHold = 'OnHold',
  RequiresApproval = 'RequiresApproval'
}

export type JobSuggestion = {
  clinicianAdvocate: User;
  clinicianAdvocateId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  isEmailSent: Scalars['Boolean'];
  job: Job;
  jobId: Scalars['String'];
  user: User;
  userId: Scalars['String'];
};

export type JoinedPlatformInterestDocument = {
  joinedPlatformInterest: PlatformInterest;
  joinedPlatformInterestOther?: Maybe<Scalars['String']>;
};

export enum LevelOfTrainingApp {
  Arnp = 'ARNP',
  Crna = 'CRNA',
  Pa = 'PA'
}

export enum LevelOfTrainingNurse {
  Cnm = 'CNM',
  Cns = 'CNS',
  Dnp = 'DNP',
  Nurse = 'Nurse'
}

export enum LevelOfTrainingPhysician {
  Attending = 'Attending',
  Fellow1 = 'Fellow1',
  Fellow2 = 'Fellow2',
  Fellow3 = 'Fellow3',
  MedStudent = 'MedStudent',
  Resident1 = 'Resident1',
  Resident2 = 'Resident2',
  Resident3 = 'Resident3',
  Resident4 = 'Resident4',
  Resident5 = 'Resident5',
  Resident6 = 'Resident6'
}

export type License = {
  expirationDate?: Maybe<Scalars['Date']>;
  issueDate?: Maybe<Scalars['Date']>;
  licenseNumber?: Maybe<Scalars['String']>;
  state: State;
  stateId: Scalars['String'];
  status: LicenseStatus;
};

export enum LicenseStatus {
  SelfReportedActive = 'SelfReportedActive',
  SelfReportedPending = 'SelfReportedPending',
  VerifiedActive = 'VerifiedActive'
}

export type Location = {
  coordinates: Array<Scalars['Float']>;
  type: Scalars['String'];
};

export type LogInInput = {
  email: Scalars['String'];
  password: Scalars['String'];
  rememberMe?: InputMaybe<Scalars['Boolean']>;
};

export type ManageRolesInput = {
  roles: Array<UserRole>;
  userId: Scalars['String'];
};

export type Mutation = {
  addAuthorizedUserToClinic: Clinic;
  addClinicStaffMember: Clinic;
  adminAssignClinicianAdvocate: User;
  adminCreateUserNote: UserNote;
  adminDeleteUserNote: UserNote;
  adminGenerateReport: Array<Scalars['String']>;
  adminUnassignClinicianAdvocate: User;
  applyToJob: JobApplication;
  assignRoles: Scalars['Boolean'];
  authenticateClinicDrChronoIntegration: Clinic;
  changeProviderType: User;
  configureClinicDrChronoIntegration: Clinic;
  createClinic: Clinic;
  createClinicContact: ClinicContact;
  createJob: Job;
  createJobApplicationRulingDecisionEvent: JobApplication;
  createJobApplicationRulingDecisionResetEvent: JobApplication;
  createJobApplicationSharableProfileToken: JobApplication;
  createJobSuggestion: JobSuggestion;
  createJobSuggestions: Array<JobSuggestion>;
  createSharingToken?: Maybe<SharingToken>;
  createUserInvitation: UserInvitation;
  customizeClinicDrChronoIntegration: Clinic;
  deleteClinicContact: ClinicContact;
  deleteJob: Job;
  deleteJobApplicationSharableProfileToken: JobApplication;
  deleteSharingToken?: Maybe<Scalars['Boolean']>;
  /** Permanently delete a user from the system. */
  deleteUser?: Maybe<Scalars['Boolean']>;
  deleteUserInvitation: UserInvitation;
  disableClinicDrChronoIntegration: Clinic;
  editClinic: Clinic;
  editClinicContact: ClinicContact;
  editJob: Job;
  editJobApplicationSharableProfileToken: JobApplication;
  editUserProfile?: Maybe<User>;
  invalidateAllTokens?: Maybe<Scalars['Boolean']>;
  invalidateToken?: Maybe<Scalars['Boolean']>;
  logIn?: Maybe<AuthPayload>;
  logOut: Scalars['Boolean'];
  refresh?: Maybe<AuthPayload>;
  removeCV?: Maybe<User>;
  removeClinicImage: Clinic;
  removeClinicStaffMember: Clinic;
  removeUserProfileImage?: Maybe<User>;
  requestCVDownload?: Maybe<Scalars['String']>;
  requestPasswordReset?: Maybe<Scalars['Boolean']>;
  resendJobSuggestionsEmailByUserId: Array<JobSuggestion>;
  resendUserInvitationEmail: UserInvitation;
  resetPassword?: Maybe<Scalars['Boolean']>;
  resetUserInvitationToken: UserInvitation;
  retractRoles: Scalars['Boolean'];
  scheduleDrChronoAppointment: DrChronoAppointment;
  setClinicAccountManager: Clinic;
  setJoinedPlatformInterest?: Maybe<User>;
  setPrimaryContact: Scalars['Boolean'];
  setUserNetworkStatus: User;
  signUp?: Maybe<AuthPayload>;
  signUpAndApply?: Maybe<SignUpAndApplyPayload>;
  signUpByInvitation?: Maybe<AuthPayload>;
  uploadCV?: Maybe<User>;
  uploadClinicImage: Clinic;
  uploadUserProfileImage?: Maybe<User>;
};


export type MutationAddAuthorizedUserToClinicArgs = {
  input: AddAuthorizedUserToClinicInput;
};


export type MutationAddClinicStaffMemberArgs = {
  input: AddClinicStaffMemberInput;
};


export type MutationAdminAssignClinicianAdvocateArgs = {
  input: AdminAssignClinicianAdvocateInput;
};


export type MutationAdminCreateUserNoteArgs = {
  input: AdminCreateUserNoteInput;
};


export type MutationAdminDeleteUserNoteArgs = {
  input: AdminDeleteUserNoteInput;
};


export type MutationAdminGenerateReportArgs = {
  input: AdminGenerateReportInput;
};


export type MutationAdminUnassignClinicianAdvocateArgs = {
  input: AdminUnassignClinicianAdvocateInput;
};


export type MutationApplyToJobArgs = {
  input: ApplyToJobInput;
};


export type MutationAssignRolesArgs = {
  input: ManageRolesInput;
};


export type MutationAuthenticateClinicDrChronoIntegrationArgs = {
  input: AuthenticateClinicDrChronoIntegrationInput;
};


export type MutationChangeProviderTypeArgs = {
  input: ChangeProviderTypeInput;
};


export type MutationConfigureClinicDrChronoIntegrationArgs = {
  input: ConfigureClinicDrChronoIntegrationInput;
};


export type MutationCreateClinicArgs = {
  input: CreateClinicInput;
};


export type MutationCreateClinicContactArgs = {
  input: CreateClinicContactInput;
};


export type MutationCreateJobArgs = {
  input: CreateJobInput;
};


export type MutationCreateJobApplicationRulingDecisionEventArgs = {
  input: CreateJobApplicationRulingDecisionEventInput;
};


export type MutationCreateJobApplicationRulingDecisionResetEventArgs = {
  input: CreateJobApplicationRulingDecisionResetEventInput;
};


export type MutationCreateJobApplicationSharableProfileTokenArgs = {
  input: CreateJobApplicationSharableProfileTokenInput;
};


export type MutationCreateJobSuggestionArgs = {
  input: CreateJobSuggestionInput;
};


export type MutationCreateJobSuggestionsArgs = {
  input: CreateJobSuggestionsInput;
};


export type MutationCreateSharingTokenArgs = {
  input: CreateSharingTokenInput;
};


export type MutationCreateUserInvitationArgs = {
  input: CreateUserInvitationInput;
};


export type MutationCustomizeClinicDrChronoIntegrationArgs = {
  input: CustomizeClinicDrChronoIntegrationInput;
};


export type MutationDeleteClinicContactArgs = {
  input: DeleteClinicContactInput;
};


export type MutationDeleteJobArgs = {
  input: DeleteJobInput;
};


export type MutationDeleteJobApplicationSharableProfileTokenArgs = {
  input: DeleteJobApplicationSharableProfileTokenInput;
};


export type MutationDeleteSharingTokenArgs = {
  input: DeleteSharingTokenInput;
};


export type MutationDeleteUserArgs = {
  input: DeleteUserInput;
};


export type MutationDeleteUserInvitationArgs = {
  id: Scalars['String'];
};


export type MutationDisableClinicDrChronoIntegrationArgs = {
  input: DisableClinicDrChronoIntegrationInput;
};


export type MutationEditClinicArgs = {
  input: EditClinicInput;
};


export type MutationEditClinicContactArgs = {
  input: EditClinicContactInput;
};


export type MutationEditJobArgs = {
  input: EditJobInput;
};


export type MutationEditJobApplicationSharableProfileTokenArgs = {
  input: EditJobApplicationSharableProfileTokenInput;
};


export type MutationEditUserProfileArgs = {
  input: EditUserProfileInput;
};


export type MutationInvalidateTokenArgs = {
  input: InvalidateTokenInput;
};


export type MutationLogInArgs = {
  input: LogInInput;
};


export type MutationRemoveClinicImageArgs = {
  input: RemoveClinicImageInput;
};


export type MutationRemoveClinicStaffMemberArgs = {
  input: RemoveClinicStaffMemberInput;
};


export type MutationRequestCvDownloadArgs = {
  input: RequestCvDownloadInput;
};


export type MutationRequestPasswordResetArgs = {
  input: RequestPasswordResetInput;
};


export type MutationResendJobSuggestionsEmailByUserIdArgs = {
  userId: Scalars['String'];
};


export type MutationResendUserInvitationEmailArgs = {
  id: Scalars['String'];
};


export type MutationResetPasswordArgs = {
  input: ResetPasswordInput;
};


export type MutationResetUserInvitationTokenArgs = {
  id: Scalars['String'];
};


export type MutationRetractRolesArgs = {
  input: ManageRolesInput;
};


export type MutationScheduleDrChronoAppointmentArgs = {
  input: ScheduleDrChronoAppointmentInput;
};


export type MutationSetClinicAccountManagerArgs = {
  input: SetClinicAccountManagerInput;
};


export type MutationSetJoinedPlatformInterestArgs = {
  input: SetJoinedPlatformInterestInput;
};


export type MutationSetPrimaryContactArgs = {
  contactId: Scalars['String'];
};


export type MutationSetUserNetworkStatusArgs = {
  input: SetUserNetworkStatusInput;
};


export type MutationSignUpArgs = {
  input: SignUpInput;
  userProfileInput?: InputMaybe<EditUserProfileInput>;
};


export type MutationSignUpAndApplyArgs = {
  applyToJobInput: ApplyToJobInput;
  cv: Scalars['Upload'];
  signUpInput: SignUpInput;
  statesLicensedIn?: InputMaybe<Array<Scalars['String']>>;
  userProfileInput: EditUserProfileInput;
};


export type MutationSignUpByInvitationArgs = {
  input: SignUpByInvitationInput;
};


export type MutationUploadCvArgs = {
  input: UploadCvInput;
};


export type MutationUploadClinicImageArgs = {
  input: UploadClinicImageInput;
};


export type MutationUploadUserProfileImageArgs = {
  input: UploadUserProfileImageInput;
};

export enum NumYearsExperience {
  FivePlus = 'FivePlus',
  None = 'None',
  OneToThree = 'OneToThree',
  ThreeToFive = 'ThreeToFive',
  ZeroToOne = 'ZeroToOne'
}

export type NurseProfessionalContext = {
  EHRCompatibility?: Maybe<Array<EhrCompatibility>>;
  availabilityMaxNumber?: Maybe<Scalars['Int']>;
  availabilityShifts?: Maybe<AvailabilityShifts>;
  availabilityStartAt?: Maybe<Scalars['DateTime']>;
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  degreeObtained?: Maybe<Scalars['String']>;
  employmentHistory?: Maybe<Scalars['String']>;
  employmentStatus?: Maybe<EmploymentStatus>;
  graduatingInstitution?: Maybe<Scalars['String']>;
  graduationYear?: Maybe<Scalars['Int']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  jobTypeSeeking?: Maybe<Array<Scalars['String']>>;
  lastFourSSN?: Maybe<Scalars['String']>;
  levelOfTraining?: Maybe<LevelOfTrainingNurse>;
  npi?: Maybe<Scalars['String']>;
  professionalReferencesText?: Maybe<Scalars['String']>;
  specialty?: Maybe<Scalars['String']>;
  type: UserRole;
  yearLastPracticed?: Maybe<Scalars['String']>;
};

export type OffsetPaginatedAuditActions = OffsetPaginatedQueryResult & {
  auditActions: Array<AuditAction>;
  hasNext: Scalars['Boolean'];
  hasPrev: Scalars['Boolean'];
  skip: Scalars['Int'];
  take: Scalars['Int'];
  totalRecords: Scalars['Int'];
};

export type OffsetPaginatedQueryResult = {
  hasNext: Scalars['Boolean'];
  hasPrev: Scalars['Boolean'];
  skip: Scalars['Int'];
  take: Scalars['Int'];
  totalRecords: Scalars['Int'];
};

export type OffsetPaginatedUsers = OffsetPaginatedQueryResult & {
  hasNext: Scalars['Boolean'];
  hasPrev: Scalars['Boolean'];
  skip: Scalars['Int'];
  take: Scalars['Int'];
  totalRecords: Scalars['Int'];
  users: Array<User>;
};

export type OffsetPaginationInput = {
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};

export type OtherProfessionalContext = {
  availabilityMaxNumber?: Maybe<Scalars['Int']>;
  availabilityShifts?: Maybe<AvailabilityShifts>;
  availabilityStartAt?: Maybe<Scalars['DateTime']>;
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  degreeObtained?: Maybe<Scalars['String']>;
  employmentHistory?: Maybe<Scalars['String']>;
  employmentStatus?: Maybe<EmploymentStatus>;
  graduatingInstitution?: Maybe<Scalars['String']>;
  graduationYear?: Maybe<Scalars['Int']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  jobTypeSeeking?: Maybe<Array<Scalars['String']>>;
  lastFourSSN?: Maybe<Scalars['String']>;
  profession?: Maybe<Scalars['String']>;
  professionOther?: Maybe<Scalars['String']>;
  professionalReferencesText?: Maybe<Scalars['String']>;
  type: UserRole;
  yearLastPracticed?: Maybe<Scalars['String']>;
};

export type PhysicianProfessionalContext = {
  EHRCompatibility?: Maybe<Array<EhrCompatibility>>;
  availabilityMaxNumber?: Maybe<Scalars['Int']>;
  availabilityShifts?: Maybe<AvailabilityShifts>;
  availabilityStartAt?: Maybe<Scalars['DateTime']>;
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  degreeObtained?: Maybe<Scalars['String']>;
  employmentHistory?: Maybe<Scalars['String']>;
  employmentStatus?: Maybe<EmploymentStatus>;
  graduatingInstitution?: Maybe<Scalars['String']>;
  graduationYear?: Maybe<Scalars['Int']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  jobTypeSeeking?: Maybe<Array<Scalars['String']>>;
  lastFourSSN?: Maybe<Scalars['String']>;
  levelOfTraining?: Maybe<LevelOfTrainingPhysician>;
  npi?: Maybe<Scalars['String']>;
  professionalReferencesText?: Maybe<Scalars['String']>;
  providerType?: Maybe<Scalars['String']>;
  specialty?: Maybe<Scalars['String']>;
  type: UserRole;
  yearLastPracticed?: Maybe<Scalars['String']>;
};

export enum PlatformInterest {
  ActivelyLooking = 'ActivelyLooking',
  Browsing = 'Browsing',
  LookingPartTime = 'LookingPartTime',
  Other = 'Other'
}

export type ProfessionalContext = AppProfessionalContext | ClinicProfessionalContext | NurseProfessionalContext | OtherProfessionalContext | PhysicianProfessionalContext | TherapistProfessionalContext;

export type Query = {
  adminAdminUsers: Array<User>;
  adminClinic: Clinic;
  adminClinics: Array<Clinic>;
  adminStats: Stats;
  adminUser: User;
  auditActions: OffsetPaginatedAuditActions;
  cities: Array<City>;
  clinic: Clinic;
  clinicAdminJob: Job;
  clinicPublic: ClinicPublic;
  cliniciansSearch: OffsetPaginatedUsers;
  clinics: Array<Clinic>;
  currentUser: User;
  job: Job;
  jobApplication: JobApplication;
  jobApplications: Array<JobApplication>;
  jobSuggestionsByJobId: Array<JobSuggestion>;
  jobSuggestionsByUserId: Array<JobSuggestion>;
  jobs: Array<Job>;
  nonAdminUserExists: Scalars['Boolean'];
  states: Array<State>;
  systemInfo: SystemInfo;
  userBySharingToken: SharableUserProfileResult;
  userInvitation: UserInvitation;
  userInvitationByEmail?: Maybe<UserInvitation>;
  userInvitations: Array<UserInvitation>;
  verifyPasswordResetToken: User;
  verifyUserInvitationToken: VerifyUserInvitationTokenResult;
};


export type QueryAdminClinicArgs = {
  clinicId: Scalars['String'];
};


export type QueryAdminStatsArgs = {
  rangeEnd: Scalars['DateTime'];
  rangeStart: Scalars['DateTime'];
};


export type QueryAdminUserArgs = {
  userId: Scalars['String'];
};


export type QueryAuditActionsArgs = {
  filter: AuditActionsFilterInput;
  paginate: OffsetPaginationInput;
  sort: AuditActionsSortInput;
};


export type QueryCitiesArgs = {
  stateId: Scalars['String'];
};


export type QueryClinicArgs = {
  id: Scalars['String'];
};


export type QueryClinicAdminJobArgs = {
  id: Scalars['String'];
};


export type QueryClinicPublicArgs = {
  id: Scalars['String'];
};


export type QueryCliniciansSearchArgs = {
  filter?: InputMaybe<UsersFilterInput>;
  paginate?: InputMaybe<OffsetPaginationInput>;
  sort?: InputMaybe<UsersSortInput>;
};


export type QueryJobArgs = {
  id: Scalars['String'];
};


export type QueryJobApplicationArgs = {
  id: Scalars['String'];
};


export type QueryJobSuggestionsByJobIdArgs = {
  jobId: Scalars['String'];
};


export type QueryJobSuggestionsByUserIdArgs = {
  userId: Scalars['String'];
};


export type QueryNonAdminUserExistsArgs = {
  email: Scalars['String'];
};


export type QueryUserBySharingTokenArgs = {
  tokenId: Scalars['String'];
};


export type QueryUserInvitationArgs = {
  id: Scalars['String'];
};


export type QueryUserInvitationByEmailArgs = {
  email: Scalars['String'];
};


export type QueryVerifyPasswordResetTokenArgs = {
  resetToken: Scalars['String'];
};


export type QueryVerifyUserInvitationTokenArgs = {
  token: Scalars['String'];
};

export enum Referral {
  Doximity = 'Doximity',
  Email = 'Email',
  Facebook = 'Facebook',
  Google = 'Google',
  Instagram = 'Instagram',
  LinkedIn = 'LinkedIn',
  Other = 'Other',
  Referral = 'Referral',
  Twitter = 'Twitter'
}

export type RemoveClinicImageInput = {
  id: Scalars['ID'];
};

export type RemoveClinicStaffMemberInput = {
  id: Scalars['ID'];
  userId: Scalars['String'];
};

export type RequestCvDownloadInput = {
  userId: Scalars['String'];
};

export type RequestPasswordResetInput = {
  email: Scalars['String'];
};

export type ResetPasswordInput = {
  confirmPassword: Scalars['String'];
  email: Scalars['String'];
  password: Scalars['String'];
  resetToken: Scalars['String'];
};

export enum Salutation {
  Dr = 'Dr',
  Mr = 'Mr',
  Mrs = 'Mrs',
  Ms = 'Ms',
  Prof = 'Prof'
}

export type ScheduleDrChronoAppointmentInput = {
  appointment: DrChronoAppointmentInfoInput;
  clinicId: Scalars['String'];
  officeId: Scalars['String'];
  patient: DrChronoPatientInfoInput;
};

export type SetClinicAccountManagerInput = {
  accountManagerId: Scalars['String'];
  clinicId: Scalars['String'];
};

export type SetJoinedPlatformInterestInput = {
  platformInterest: PlatformInterest;
  platformInterestOther?: InputMaybe<Scalars['String']>;
};

export type SetUserNetworkStatusInput = {
  networkStatus: UserNetworkStatus;
  userId: Scalars['String'];
};

export type SharableUserProfile = {
  clientDescription?: Maybe<Scalars['String']>;
  jobApplication?: Maybe<JobApplication>;
  user: User;
  userId: Scalars['ID'];
};

export type SharableUserProfileLinkExpired = {
  isExpired: Scalars['Boolean'];
  message: Scalars['String'];
};

export type SharableUserProfileLinkNotFound = {
  isNotFound: Scalars['Boolean'];
  message: Scalars['String'];
};

export type SharableUserProfileResult = SharableUserProfile | SharableUserProfileLinkExpired | SharableUserProfileLinkNotFound;

export type SharingToken = {
  createdAt: Scalars['DateTime'];
  createdBy: User;
  creatorId: Scalars['String'];
  expires: Scalars['DateTime'];
  id: Scalars['ID'];
  userId: Scalars['String'];
};

export enum Shift {
  Day = 'Day',
  Evening = 'Evening',
  Full = 'Full',
  Night = 'Night'
}

export type SignUpAndApplyPayload = {
  jobApplication: JobApplication;
  licenses: Array<License>;
  user: AuthPayload;
  userProfile: UserProfile;
};

export type SignUpByInvitationInput = {
  confirmPassword: Scalars['String'];
  password: Scalars['String'];
  rememberMe?: InputMaybe<Scalars['Boolean']>;
  userInvitationId: Scalars['String'];
  utm?: InputMaybe<Scalars['JSON']>;
};

export type SignUpInput = {
  email: Scalars['String'];
  password: Scalars['String'];
  rememberMe?: InputMaybe<Scalars['Boolean']>;
  role: UserRole;
};

export enum SortDirection {
  Asc = 'Asc',
  Desc = 'Desc'
}

export type State = {
  id: Scalars['ID'];
  name: Scalars['String'];
  shortName: Scalars['String'];
};

export type Stats = {
  clinics: Array<Clinic>;
  deltaClinics: Scalars['Int'];
  deltaJobs: Scalars['Int'];
  deltaUser: Scalars['Int'];
  jobs: Array<Job>;
  totalClinics: Scalars['Int'];
  totalJobs: Scalars['Int'];
  totalUsers: Scalars['Int'];
  users: Array<User>;
};

export type SystemInfo = {
  version: Scalars['String'];
};

export type TherapistProfessionalContext = {
  EHRCompatibility?: Maybe<Array<EhrCompatibility>>;
  availabilityMaxNumber?: Maybe<Scalars['Int']>;
  availabilityShifts?: Maybe<AvailabilityShifts>;
  availabilityStartAt?: Maybe<Scalars['DateTime']>;
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  degreeObtained?: Maybe<Scalars['String']>;
  employmentHistory?: Maybe<Scalars['String']>;
  employmentStatus?: Maybe<EmploymentStatus>;
  graduatingInstitution?: Maybe<Scalars['String']>;
  graduationYear?: Maybe<Scalars['Int']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  jobTypeSeeking?: Maybe<Array<Scalars['String']>>;
  lastFourSSN?: Maybe<Scalars['String']>;
  levelOfTraining?: Maybe<Scalars['String']>;
  professionalReferencesText?: Maybe<Scalars['String']>;
  providerType?: Maybe<Scalars['String']>;
  specialty?: Maybe<Scalars['String']>;
  type: UserRole;
  yearLastPracticed?: Maybe<Scalars['String']>;
};

export type UploadCvInput = {
  file: Scalars['Upload'];
  userId: Scalars['String'];
};

export type UploadClinicImageInput = {
  file: Scalars['Upload'];
  id: Scalars['ID'];
};

export type UploadUserProfileImageInput = {
  file: Scalars['Upload'];
};

export type User = {
  clinicianAdvocate?: Maybe<User>;
  clinicianAdvocateId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  email: Scalars['String'];
  id: Scalars['ID'];
  jobApplications?: Maybe<Array<JobApplication>>;
  jobSuggestions?: Maybe<Array<JobSuggestion>>;
  lastActive?: Maybe<Scalars['DateTime']>;
  notes?: Maybe<Array<UserNote>>;
  profile: UserProfile;
  role: UserRole;
  roles?: Maybe<Array<Scalars['String']>>;
  sharingTokens?: Maybe<Array<SharingToken>>;
  tasks: Array<UserTask>;
  verifiedActiveLicenses: Array<License>;
  zohoRecruitUserId?: Maybe<Scalars['String']>;
};

export type UserAddress = {
  city: City;
  cityId: Scalars['String'];
  location?: Maybe<Location>;
  state: State;
  stateId: Scalars['String'];
};

export type UserInvitation = {
  clinicianAdvocate: User;
  clinicianAdvocateId: Scalars['String'];
  clinicianType: UserRole;
  createdAt: Scalars['DateTime'];
  email: Scalars['String'];
  firstName: Scalars['String'];
  id: Scalars['ID'];
  inviter: User;
  inviterId: Scalars['String'];
  isDeleted: Scalars['Boolean'];
  isEmailSent: Scalars['Boolean'];
  jobsToSuggest: Array<Job>;
  jobsToSuggestIds: Array<Scalars['String']>;
  lastName: Scalars['String'];
  preferredName: Scalars['String'];
  token: Scalars['String'];
  tokenExpirationTime: Scalars['DateTime'];
};

export type UserInvitationExpired = {
  isExpired: Scalars['Boolean'];
  message: Scalars['String'];
  userInvitation: UserInvitation;
};

export type UserInvitationNotFound = {
  isNotFound: Scalars['Boolean'];
  message: Scalars['String'];
};

/** Current Status of User in the Openloop Network */
export enum UserNetworkStatus {
  Incomplete = 'Incomplete',
  NoNetwork = 'NoNetwork',
  NotNowNetwork = 'NotNowNetwork',
  PendingReview = 'PendingReview',
  YesNetwork = 'YesNetwork'
}

export type UserNote = {
  createdAt: Scalars['DateTime'];
  creator: User;
  creatorId: Scalars['String'];
  id: Scalars['String'];
  isDeleted: Scalars['Boolean'];
  message: Scalars['String'];
  user: User;
  userId: Scalars['String'];
};

export type UserProfile = {
  DEALicenses: Array<License>;
  address?: Maybe<UserAddress>;
  bio?: Maybe<Scalars['String']>;
  completion?: Maybe<Scalars['Int']>;
  createdAt: Scalars['DateTime'];
  cv?: Maybe<UserUploadedFile>;
  displayName: Scalars['String'];
  firstName?: Maybe<Scalars['String']>;
  image?: Maybe<UserUploadedFile>;
  joinedPlatformInterestDocument?: Maybe<JoinedPlatformInterestDocument>;
  lastName?: Maybe<Scalars['String']>;
  learnMore?: Maybe<Scalars['Boolean']>;
  licenses: Array<License>;
  missingFields: Array<Scalars['String']>;
  networkStatus: UserNetworkStatus;
  phone?: Maybe<Scalars['String']>;
  preferredName?: Maybe<Scalars['String']>;
  professionalContext: ProfessionalContext;
  referral?: Maybe<Referral>;
  referralOther?: Maybe<Scalars['String']>;
  salutation?: Maybe<Salutation>;
  userId: Scalars['String'];
  utm?: Maybe<Scalars['JSON']>;
};

export enum UserRole {
  App = 'APP',
  Admin = 'Admin',
  Clinic = 'Clinic',
  Nurse = 'Nurse',
  Other = 'Other',
  Physician = 'Physician',
  Therapist = 'Therapist'
}

export enum UserTask {
  AddLicenses = 'AddLicenses',
  PersonalizeProfile = 'PersonalizeProfile',
  SubmitVerification = 'SubmitVerification'
}

export type UserUploadedFile = {
  filename: Scalars['String'];
  key: Scalars['String'];
  location: Scalars['String'];
};

export type UsersFilterInput = {
  clinicianAdvocateId?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  licenseCount?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  networkStatus?: InputMaybe<Array<UserNetworkStatus>>;
  phone?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<Array<UserRole>>;
  specialty?: InputMaybe<Array<Scalars['String']>>;
  stateId?: InputMaybe<Array<Scalars['String']>>;
  statesDEALicensedIn?: InputMaybe<Array<Scalars['String']>>;
  statesLicensedIn?: InputMaybe<Array<Scalars['String']>>;
  userAppliedToClinicIds?: InputMaybe<Array<Scalars['String']>>;
  userAppliedToJobIds?: InputMaybe<Array<Scalars['String']>>;
  userAppliedToJobRuling?: InputMaybe<Scalars['String']>;
  utm?: InputMaybe<Scalars['JSON']>;
  verifiedLicenseCount?: InputMaybe<Scalars['Int']>;
  verifiedStatesLicensedIn?: InputMaybe<Array<Scalars['String']>>;
};

export enum UsersSortBy {
  City = 'City',
  ClinicianAdvocate = 'ClinicianAdvocate',
  DateJoined = 'DateJoined',
  LastActive = 'LastActive',
  LicenseCount = 'LicenseCount',
  Name = 'Name',
  Role = 'Role',
  Specialty = 'Specialty',
  VerifiedLicenseCount = 'VerifiedLicenseCount'
}

export type UsersSortInput = {
  direction?: InputMaybe<SortDirection>;
  sortBy?: InputMaybe<UsersSortBy>;
};

export type VerifyUserInvitationTokenResult = UserInvitation | UserInvitationExpired | UserInvitationNotFound;

export type UserAddressFieldsFragment = { city: { id: string, description?: string | null, image?: string | null, name: string, slug: string, stateId: string, state: { id: string, name: string, shortName: string } }, location?: { coordinates: Array<number> } | null, state: { id: string, name: string, shortName: string } };

export type CityFieldsFragment = { id: string, description?: string | null, image?: string | null, name: string, slug: string, stateId: string, state: { id: string, name: string, shortName: string } };

export type ClinicFieldsFragment = { accountManagerId?: string | null, amenities?: string | null, createdAt: any, createdBy: string, id: string, name: string, numJobsActive?: number | null, phone?: string | null, resources?: string | null, websiteUrl?: string | null, zohoUrl?: string | null, accountManager?: { id: string, profile: { displayName: string, firstName?: string | null, lastName?: string | null, userId: string } } | null, image?: { filename: string, key: string, location: string } | null, jobs: Array<{ id: string, isTelehealth?: boolean | null, status: JobStatus }> };

export type ClinicContactFieldsFragment = { createdAt: any, id: string, isDeleted: boolean, isPrimary: boolean, email?: string | null, name?: string | null, phone?: string | null, title?: string | null, createdBy: { createdAt: any, id: string, email: string, role: UserRole, clinicianAdvocate?: { id: string, email: string, profile: { firstName?: string | null, lastName?: string | null, displayName: string, userId: string, phone?: string | null, image?: { filename: string, key: string, location: string } | null } } | null } };

export type FileFieldsFragment = { filename: string, key: string, location: string };

export type JobFieldsFragment = { aboutJob?: string | null, applied: boolean, clinicianAdvocateId?: string | null, clinicianType?: UserRole | null, clinicId: string, clinicContactId?: string | null, createdAt: any, createdBy: string, description?: string | null, desiredCertifications?: Array<Certification> | null, desiredHours?: string | null, desiredTelehealthExperience?: DesiredTelehealthExperience | null, displayClinicDetails?: boolean | null, education?: string | null, employmentType?: Array<EmploymentType> | null, emrProviders?: Array<EhrCompatibility> | null, id: string, interviewDetails?: string | null, isDeleted: boolean, isInternal: boolean, isTelehealth?: boolean | null, location?: JobLocation | null, minYearsExperience?: NumYearsExperience | null, numberToFill?: number | null, numberToFillIsUnlimited?: boolean | null, nurseSpecialty?: string | null, onboardingDetails?: string | null, orientationDetails?: string | null, otherInfo?: string | null, payAndPerks?: string | null, preferredLicenseStateIds?: Array<string> | null, profession?: string | null, requiredEquipment?: string | null, requiredLicenseStateIds?: Array<string> | null, requirements?: string | null, responsibilities?: string | null, salaryDetails?: string | null, schedulingDetails?: string | null, shiftDetails?: string | null, specialties?: Array<string> | null, startAt?: any | null, stateId?: string | null, status: JobStatus, title: string, trainingLevel?: string | null, zohoUrl?: string | null, clinicianAdvocate?: { createdAt: any, id: string, email: string, role: UserRole, profile: { firstName?: string | null, lastName?: string | null, userId: string }, clinicianAdvocate?: { id: string, email: string, profile: { firstName?: string | null, lastName?: string | null, displayName: string, userId: string, phone?: string | null, image?: { filename: string, key: string, location: string } | null } } | null } | null, clinic: { accountManagerId?: string | null, amenities?: string | null, createdAt: any, createdBy: string, id: string, name: string, numJobsActive?: number | null, phone?: string | null, resources?: string | null, websiteUrl?: string | null, zohoUrl?: string | null, accountManager?: { id: string, profile: { displayName: string, firstName?: string | null, lastName?: string | null, userId: string } } | null, image?: { filename: string, key: string, location: string } | null, jobs: Array<{ id: string, isTelehealth?: boolean | null, status: JobStatus }> }, preferredLicenseStates?: Array<{ id: string, name: string, shortName: string }> | null, requiredLicenseStates?: Array<{ id: string, name: string, shortName: string }> | null, state?: { id: string, name: string, shortName: string } | null };

export type JobSuggestionFieldsFragment = { clinicianAdvocateId: string, createdAt: any, id: string, jobId: string, userId: string, job: { title: string }, user: { createdAt: any, id: string, email: string, role: UserRole, clinicianAdvocate?: { id: string, email: string, profile: { firstName?: string | null, lastName?: string | null, displayName: string, userId: string, phone?: string | null, image?: { filename: string, key: string, location: string } | null } } | null } };

export type LicenseFieldsFragment = { expirationDate?: any | null, issueDate?: any | null, licenseNumber?: string | null, stateId: string, status: LicenseStatus, state: { id: string, name: string, shortName: string } };

export type SharingTokenFieldsFragment = { id: string, createdAt: any, expires: any, createdBy: { id: string, email: string } };

export type StateFieldsFragment = { id: string, name: string, shortName: string };

export type AvailabilityShiftsFieldsFragment = { sun?: Array<Shift> | null, mon?: Array<Shift> | null, tue?: Array<Shift> | null, wed?: Array<Shift> | null, thu?: Array<Shift> | null, fri?: Array<Shift> | null, sat?: Array<Shift> | null };

export type SimpleProfessionalContextFragment = { professionalContext: { isVerified?: boolean | null, jobTypeSeeking?: Array<string> | null, specialty?: string | null, type: UserRole, appLevelOfTraining?: LevelOfTrainingApp | null } | { isVerified?: boolean | null, jobTypeSeeking?: Array<string> | null, specialty?: string | null, type: UserRole, nurseLevelOfTraining?: LevelOfTrainingNurse | null } | { isVerified?: boolean | null, jobTypeSeeking?: Array<string> | null, profession?: string | null, professionOther?: string | null, type: UserRole } | { isVerified?: boolean | null, jobTypeSeeking?: Array<string> | null, providerType?: string | null, specialty?: string | null, type: UserRole, physicianLevelOfTraining?: LevelOfTrainingPhysician | null } | { isVerified?: boolean | null, jobTypeSeeking?: Array<string> | null, providerType?: string | null, specialty?: string | null, type: UserRole, therapistLevelOfTraining?: string | null } | {} };

export type AppProfessionalContextFieldsFragment = { availabilityMaxNumber?: number | null, availabilityStartAt?: any | null, dateOfBirth?: any | null, degreeObtained?: string | null, EHRCompatibility?: Array<EhrCompatibility> | null, employmentHistory?: string | null, employmentStatus?: EmploymentStatus | null, graduatingInstitution?: string | null, graduationYear?: number | null, isVerified?: boolean | null, jobTypeSeeking?: Array<string> | null, lastFourSSN?: string | null, npi?: string | null, professionalReferencesText?: string | null, specialty?: string | null, type: UserRole, yearLastPracticed?: string | null, appLevelOfTraining?: LevelOfTrainingApp | null, availabilityShifts?: { sun?: Array<Shift> | null, mon?: Array<Shift> | null, tue?: Array<Shift> | null, wed?: Array<Shift> | null, thu?: Array<Shift> | null, fri?: Array<Shift> | null, sat?: Array<Shift> | null } | null };

export type NurseProfessionalContextFieldsFragment = { availabilityMaxNumber?: number | null, availabilityStartAt?: any | null, dateOfBirth?: any | null, degreeObtained?: string | null, EHRCompatibility?: Array<EhrCompatibility> | null, employmentHistory?: string | null, employmentStatus?: EmploymentStatus | null, graduatingInstitution?: string | null, graduationYear?: number | null, isVerified?: boolean | null, jobTypeSeeking?: Array<string> | null, lastFourSSN?: string | null, npi?: string | null, professionalReferencesText?: string | null, specialty?: string | null, type: UserRole, yearLastPracticed?: string | null, nurseLevelOfTraining?: LevelOfTrainingNurse | null, availabilityShifts?: { sun?: Array<Shift> | null, mon?: Array<Shift> | null, tue?: Array<Shift> | null, wed?: Array<Shift> | null, thu?: Array<Shift> | null, fri?: Array<Shift> | null, sat?: Array<Shift> | null } | null };

export type OtherProfessionalContextFieldsFragment = { availabilityMaxNumber?: number | null, availabilityStartAt?: any | null, dateOfBirth?: any | null, degreeObtained?: string | null, employmentHistory?: string | null, employmentStatus?: EmploymentStatus | null, graduatingInstitution?: string | null, graduationYear?: number | null, isVerified?: boolean | null, jobTypeSeeking?: Array<string> | null, lastFourSSN?: string | null, profession?: string | null, professionOther?: string | null, professionalReferencesText?: string | null, type: UserRole, yearLastPracticed?: string | null, availabilityShifts?: { sun?: Array<Shift> | null, mon?: Array<Shift> | null, tue?: Array<Shift> | null, wed?: Array<Shift> | null, thu?: Array<Shift> | null, fri?: Array<Shift> | null, sat?: Array<Shift> | null } | null };

export type PhysicianProfessionalContextFieldsFragment = { availabilityMaxNumber?: number | null, availabilityStartAt?: any | null, dateOfBirth?: any | null, degreeObtained?: string | null, EHRCompatibility?: Array<EhrCompatibility> | null, employmentHistory?: string | null, employmentStatus?: EmploymentStatus | null, graduatingInstitution?: string | null, graduationYear?: number | null, isVerified?: boolean | null, jobTypeSeeking?: Array<string> | null, lastFourSSN?: string | null, npi?: string | null, professionalReferencesText?: string | null, providerType?: string | null, specialty?: string | null, type: UserRole, yearLastPracticed?: string | null, physicianLevelOfTraining?: LevelOfTrainingPhysician | null, availabilityShifts?: { sun?: Array<Shift> | null, mon?: Array<Shift> | null, tue?: Array<Shift> | null, wed?: Array<Shift> | null, thu?: Array<Shift> | null, fri?: Array<Shift> | null, sat?: Array<Shift> | null } | null };

export type TherapistProfessionalContextFieldsFragment = { availabilityMaxNumber?: number | null, availabilityStartAt?: any | null, dateOfBirth?: any | null, degreeObtained?: string | null, EHRCompatibility?: Array<EhrCompatibility> | null, employmentHistory?: string | null, employmentStatus?: EmploymentStatus | null, graduatingInstitution?: string | null, graduationYear?: number | null, isVerified?: boolean | null, jobTypeSeeking?: Array<string> | null, lastFourSSN?: string | null, professionalReferencesText?: string | null, providerType?: string | null, specialty?: string | null, type: UserRole, yearLastPracticed?: string | null, therapistLevelOfTraining?: string | null, availabilityShifts?: { sun?: Array<Shift> | null, mon?: Array<Shift> | null, tue?: Array<Shift> | null, wed?: Array<Shift> | null, thu?: Array<Shift> | null, fri?: Array<Shift> | null, sat?: Array<Shift> | null } | null };

export type ProfessionalContextFragment = { professionalContext: { __typename: 'APPProfessionalContext', availabilityMaxNumber?: number | null, availabilityStartAt?: any | null, dateOfBirth?: any | null, degreeObtained?: string | null, EHRCompatibility?: Array<EhrCompatibility> | null, employmentHistory?: string | null, employmentStatus?: EmploymentStatus | null, graduatingInstitution?: string | null, graduationYear?: number | null, isVerified?: boolean | null, jobTypeSeeking?: Array<string> | null, lastFourSSN?: string | null, npi?: string | null, professionalReferencesText?: string | null, specialty?: string | null, type: UserRole, yearLastPracticed?: string | null, appLevelOfTraining?: LevelOfTrainingApp | null, availabilityShifts?: { sun?: Array<Shift> | null, mon?: Array<Shift> | null, tue?: Array<Shift> | null, wed?: Array<Shift> | null, thu?: Array<Shift> | null, fri?: Array<Shift> | null, sat?: Array<Shift> | null } | null } | { __typename: 'ClinicProfessionalContext' } | { __typename: 'NurseProfessionalContext', availabilityMaxNumber?: number | null, availabilityStartAt?: any | null, dateOfBirth?: any | null, degreeObtained?: string | null, EHRCompatibility?: Array<EhrCompatibility> | null, employmentHistory?: string | null, employmentStatus?: EmploymentStatus | null, graduatingInstitution?: string | null, graduationYear?: number | null, isVerified?: boolean | null, jobTypeSeeking?: Array<string> | null, lastFourSSN?: string | null, npi?: string | null, professionalReferencesText?: string | null, specialty?: string | null, type: UserRole, yearLastPracticed?: string | null, nurseLevelOfTraining?: LevelOfTrainingNurse | null, availabilityShifts?: { sun?: Array<Shift> | null, mon?: Array<Shift> | null, tue?: Array<Shift> | null, wed?: Array<Shift> | null, thu?: Array<Shift> | null, fri?: Array<Shift> | null, sat?: Array<Shift> | null } | null } | { __typename: 'OtherProfessionalContext', availabilityMaxNumber?: number | null, availabilityStartAt?: any | null, dateOfBirth?: any | null, degreeObtained?: string | null, employmentHistory?: string | null, employmentStatus?: EmploymentStatus | null, graduatingInstitution?: string | null, graduationYear?: number | null, isVerified?: boolean | null, jobTypeSeeking?: Array<string> | null, lastFourSSN?: string | null, profession?: string | null, professionOther?: string | null, professionalReferencesText?: string | null, type: UserRole, yearLastPracticed?: string | null, availabilityShifts?: { sun?: Array<Shift> | null, mon?: Array<Shift> | null, tue?: Array<Shift> | null, wed?: Array<Shift> | null, thu?: Array<Shift> | null, fri?: Array<Shift> | null, sat?: Array<Shift> | null } | null } | { __typename: 'PhysicianProfessionalContext', availabilityMaxNumber?: number | null, availabilityStartAt?: any | null, dateOfBirth?: any | null, degreeObtained?: string | null, EHRCompatibility?: Array<EhrCompatibility> | null, employmentHistory?: string | null, employmentStatus?: EmploymentStatus | null, graduatingInstitution?: string | null, graduationYear?: number | null, isVerified?: boolean | null, jobTypeSeeking?: Array<string> | null, lastFourSSN?: string | null, npi?: string | null, professionalReferencesText?: string | null, providerType?: string | null, specialty?: string | null, type: UserRole, yearLastPracticed?: string | null, physicianLevelOfTraining?: LevelOfTrainingPhysician | null, availabilityShifts?: { sun?: Array<Shift> | null, mon?: Array<Shift> | null, tue?: Array<Shift> | null, wed?: Array<Shift> | null, thu?: Array<Shift> | null, fri?: Array<Shift> | null, sat?: Array<Shift> | null } | null } | { __typename: 'TherapistProfessionalContext', availabilityMaxNumber?: number | null, availabilityStartAt?: any | null, dateOfBirth?: any | null, degreeObtained?: string | null, EHRCompatibility?: Array<EhrCompatibility> | null, employmentHistory?: string | null, employmentStatus?: EmploymentStatus | null, graduatingInstitution?: string | null, graduationYear?: number | null, isVerified?: boolean | null, jobTypeSeeking?: Array<string> | null, lastFourSSN?: string | null, professionalReferencesText?: string | null, providerType?: string | null, specialty?: string | null, type: UserRole, yearLastPracticed?: string | null, therapistLevelOfTraining?: string | null, availabilityShifts?: { sun?: Array<Shift> | null, mon?: Array<Shift> | null, tue?: Array<Shift> | null, wed?: Array<Shift> | null, thu?: Array<Shift> | null, fri?: Array<Shift> | null, sat?: Array<Shift> | null } | null } };

export type UserProfileFieldsFragment = { bio?: string | null, completion?: number | null, displayName: string, firstName?: string | null, lastName?: string | null, preferredName?: string | null, learnMore?: boolean | null, phone?: string | null, referral?: Referral | null, referralOther?: string | null, salutation?: Salutation | null, userId: string, networkStatus: UserNetworkStatus, address?: { city: { id: string, description?: string | null, image?: string | null, name: string, slug: string, stateId: string, state: { id: string, name: string, shortName: string } }, location?: { coordinates: Array<number> } | null, state: { id: string, name: string, shortName: string } } | null, cv?: { filename: string, key: string } | null, image?: { filename: string, key: string, location: string } | null, licenses: Array<{ expirationDate?: any | null, issueDate?: any | null, licenseNumber?: string | null, stateId: string, status: LicenseStatus, state: { id: string, name: string, shortName: string } }>, DEALicenses: Array<{ expirationDate?: any | null, issueDate?: any | null, licenseNumber?: string | null, stateId: string, status: LicenseStatus, state: { id: string, name: string, shortName: string } }>, professionalContext: { __typename: 'APPProfessionalContext', availabilityMaxNumber?: number | null, availabilityStartAt?: any | null, dateOfBirth?: any | null, degreeObtained?: string | null, EHRCompatibility?: Array<EhrCompatibility> | null, employmentHistory?: string | null, employmentStatus?: EmploymentStatus | null, graduatingInstitution?: string | null, graduationYear?: number | null, isVerified?: boolean | null, jobTypeSeeking?: Array<string> | null, lastFourSSN?: string | null, npi?: string | null, professionalReferencesText?: string | null, specialty?: string | null, type: UserRole, yearLastPracticed?: string | null, appLevelOfTraining?: LevelOfTrainingApp | null, availabilityShifts?: { sun?: Array<Shift> | null, mon?: Array<Shift> | null, tue?: Array<Shift> | null, wed?: Array<Shift> | null, thu?: Array<Shift> | null, fri?: Array<Shift> | null, sat?: Array<Shift> | null } | null } | { __typename: 'ClinicProfessionalContext' } | { __typename: 'NurseProfessionalContext', availabilityMaxNumber?: number | null, availabilityStartAt?: any | null, dateOfBirth?: any | null, degreeObtained?: string | null, EHRCompatibility?: Array<EhrCompatibility> | null, employmentHistory?: string | null, employmentStatus?: EmploymentStatus | null, graduatingInstitution?: string | null, graduationYear?: number | null, isVerified?: boolean | null, jobTypeSeeking?: Array<string> | null, lastFourSSN?: string | null, npi?: string | null, professionalReferencesText?: string | null, specialty?: string | null, type: UserRole, yearLastPracticed?: string | null, nurseLevelOfTraining?: LevelOfTrainingNurse | null, availabilityShifts?: { sun?: Array<Shift> | null, mon?: Array<Shift> | null, tue?: Array<Shift> | null, wed?: Array<Shift> | null, thu?: Array<Shift> | null, fri?: Array<Shift> | null, sat?: Array<Shift> | null } | null } | { __typename: 'OtherProfessionalContext', availabilityMaxNumber?: number | null, availabilityStartAt?: any | null, dateOfBirth?: any | null, degreeObtained?: string | null, employmentHistory?: string | null, employmentStatus?: EmploymentStatus | null, graduatingInstitution?: string | null, graduationYear?: number | null, isVerified?: boolean | null, jobTypeSeeking?: Array<string> | null, lastFourSSN?: string | null, profession?: string | null, professionOther?: string | null, professionalReferencesText?: string | null, type: UserRole, yearLastPracticed?: string | null, availabilityShifts?: { sun?: Array<Shift> | null, mon?: Array<Shift> | null, tue?: Array<Shift> | null, wed?: Array<Shift> | null, thu?: Array<Shift> | null, fri?: Array<Shift> | null, sat?: Array<Shift> | null } | null } | { __typename: 'PhysicianProfessionalContext', availabilityMaxNumber?: number | null, availabilityStartAt?: any | null, dateOfBirth?: any | null, degreeObtained?: string | null, EHRCompatibility?: Array<EhrCompatibility> | null, employmentHistory?: string | null, employmentStatus?: EmploymentStatus | null, graduatingInstitution?: string | null, graduationYear?: number | null, isVerified?: boolean | null, jobTypeSeeking?: Array<string> | null, lastFourSSN?: string | null, npi?: string | null, professionalReferencesText?: string | null, providerType?: string | null, specialty?: string | null, type: UserRole, yearLastPracticed?: string | null, physicianLevelOfTraining?: LevelOfTrainingPhysician | null, availabilityShifts?: { sun?: Array<Shift> | null, mon?: Array<Shift> | null, tue?: Array<Shift> | null, wed?: Array<Shift> | null, thu?: Array<Shift> | null, fri?: Array<Shift> | null, sat?: Array<Shift> | null } | null } | { __typename: 'TherapistProfessionalContext', availabilityMaxNumber?: number | null, availabilityStartAt?: any | null, dateOfBirth?: any | null, degreeObtained?: string | null, EHRCompatibility?: Array<EhrCompatibility> | null, employmentHistory?: string | null, employmentStatus?: EmploymentStatus | null, graduatingInstitution?: string | null, graduationYear?: number | null, isVerified?: boolean | null, jobTypeSeeking?: Array<string> | null, lastFourSSN?: string | null, professionalReferencesText?: string | null, providerType?: string | null, specialty?: string | null, type: UserRole, yearLastPracticed?: string | null, therapistLevelOfTraining?: string | null, availabilityShifts?: { sun?: Array<Shift> | null, mon?: Array<Shift> | null, tue?: Array<Shift> | null, wed?: Array<Shift> | null, thu?: Array<Shift> | null, fri?: Array<Shift> | null, sat?: Array<Shift> | null } | null } };

export type UserFieldsFragment = { createdAt: any, id: string, email: string, role: UserRole, clinicianAdvocate?: { id: string, email: string, profile: { firstName?: string | null, lastName?: string | null, displayName: string, userId: string, phone?: string | null, image?: { filename: string, key: string, location: string } | null } } | null };

export type UserNoteFieldsFragment = { createdAt: any, creatorId: string, id: string, isDeleted: boolean, message: string, userId: string, creator: { id: string, profile: { displayName: string, userId: string } } };

export type AdminCreateUserNoteMutationVariables = Exact<{
  input: AdminCreateUserNoteInput;
}>;


export type AdminCreateUserNoteMutation = { adminCreateUserNote: { createdAt: any, creatorId: string, id: string, isDeleted: boolean, message: string, userId: string, creator: { id: string, profile: { displayName: string, userId: string } } } };

export type AdminDeleteUserNoteMutationVariables = Exact<{
  input: AdminDeleteUserNoteInput;
}>;


export type AdminDeleteUserNoteMutation = { adminDeleteUserNote: { createdAt: any, creatorId: string, id: string, isDeleted: boolean, message: string, userId: string, creator: { id: string, profile: { displayName: string, userId: string } } } };

export type AdminGenerateReportMutationVariables = Exact<{
  input: AdminGenerateReportInput;
}>;


export type AdminGenerateReportMutation = { adminGenerateReport: Array<string> };

export type AdminSetClinicianAdvocateIdMutationVariables = Exact<{
  input: AdminAssignClinicianAdvocateInput;
}>;


export type AdminSetClinicianAdvocateIdMutation = { adminAssignClinicianAdvocate: { id: string, clinicianAdvocateId?: string | null, clinicianAdvocate?: { id: string, email: string, profile: { userId: string, firstName?: string | null, lastName?: string | null, displayName: string } } | null } };

export type AdminUnsetClinicianAdvocateIdMutationVariables = Exact<{
  input: AdminUnassignClinicianAdvocateInput;
}>;


export type AdminUnsetClinicianAdvocateIdMutation = { adminUnassignClinicianAdvocate: { id: string, clinicianAdvocateId?: string | null, clinicianAdvocate?: { id: string, email: string, profile: { userId: string, firstName?: string | null, lastName?: string | null, displayName: string } } | null } };

export type CreateClinicMutationVariables = Exact<{
  input: CreateClinicInput;
}>;


export type CreateClinicMutation = { createClinic: { accountManagerId?: string | null, amenities?: string | null, createdAt: any, createdBy: string, id: string, name: string, numJobsActive?: number | null, phone?: string | null, resources?: string | null, websiteUrl?: string | null, zohoUrl?: string | null, accountManager?: { id: string, profile: { displayName: string, firstName?: string | null, lastName?: string | null, userId: string } } | null, image?: { filename: string, key: string, location: string } | null, jobs: Array<{ id: string, isTelehealth?: boolean | null, status: JobStatus }> } };

export type EditClinicMutationVariables = Exact<{
  input: EditClinicInput;
}>;


export type EditClinicMutation = { editClinic: { accountManagerId?: string | null, amenities?: string | null, createdAt: any, createdBy: string, id: string, name: string, numJobsActive?: number | null, phone?: string | null, resources?: string | null, websiteUrl?: string | null, zohoUrl?: string | null, accountManager?: { id: string, profile: { displayName: string, firstName?: string | null, lastName?: string | null, userId: string } } | null, image?: { filename: string, key: string, location: string } | null, jobs: Array<{ id: string, isTelehealth?: boolean | null, status: JobStatus }> } };

export type SetClinicAccountManagerMutationVariables = Exact<{
  input: SetClinicAccountManagerInput;
}>;


export type SetClinicAccountManagerMutation = { setClinicAccountManager: { accountManagerId?: string | null, amenities?: string | null, createdAt: any, createdBy: string, id: string, name: string, numJobsActive?: number | null, phone?: string | null, resources?: string | null, websiteUrl?: string | null, zohoUrl?: string | null, accountManager?: { id: string, profile: { displayName: string, firstName?: string | null, lastName?: string | null, userId: string } } | null, image?: { filename: string, key: string, location: string } | null, jobs: Array<{ id: string, isTelehealth?: boolean | null, status: JobStatus }> } };

export type UploadClinicImageMutationVariables = Exact<{
  input: UploadClinicImageInput;
}>;


export type UploadClinicImageMutation = { uploadClinicImage: { accountManagerId?: string | null, amenities?: string | null, createdAt: any, createdBy: string, id: string, name: string, numJobsActive?: number | null, phone?: string | null, resources?: string | null, websiteUrl?: string | null, zohoUrl?: string | null, accountManager?: { id: string, profile: { displayName: string, firstName?: string | null, lastName?: string | null, userId: string } } | null, image?: { filename: string, key: string, location: string } | null, jobs: Array<{ id: string, isTelehealth?: boolean | null, status: JobStatus }> } };

export type RemoveClinicImageMutationVariables = Exact<{
  input: RemoveClinicImageInput;
}>;


export type RemoveClinicImageMutation = { removeClinicImage: { accountManagerId?: string | null, amenities?: string | null, createdAt: any, createdBy: string, id: string, name: string, numJobsActive?: number | null, phone?: string | null, resources?: string | null, websiteUrl?: string | null, zohoUrl?: string | null, accountManager?: { id: string, profile: { displayName: string, firstName?: string | null, lastName?: string | null, userId: string } } | null, image?: { filename: string, key: string, location: string } | null, jobs: Array<{ id: string, isTelehealth?: boolean | null, status: JobStatus }> } };

export type CreateClinicContactMutationVariables = Exact<{
  input: CreateClinicContactInput;
}>;


export type CreateClinicContactMutation = { createClinicContact: { createdAt: any, id: string, isDeleted: boolean, isPrimary: boolean, email?: string | null, name?: string | null, phone?: string | null, title?: string | null, createdBy: { createdAt: any, id: string, email: string, role: UserRole, clinicianAdvocate?: { id: string, email: string, profile: { firstName?: string | null, lastName?: string | null, displayName: string, userId: string, phone?: string | null, image?: { filename: string, key: string, location: string } | null } } | null } } };

export type EditClinicContactMutationVariables = Exact<{
  input: EditClinicContactInput;
}>;


export type EditClinicContactMutation = { editClinicContact: { createdAt: any, id: string, isDeleted: boolean, isPrimary: boolean, email?: string | null, name?: string | null, phone?: string | null, title?: string | null, createdBy: { createdAt: any, id: string, email: string, role: UserRole, clinicianAdvocate?: { id: string, email: string, profile: { firstName?: string | null, lastName?: string | null, displayName: string, userId: string, phone?: string | null, image?: { filename: string, key: string, location: string } | null } } | null } } };

export type DeleteClinicContactMutationVariables = Exact<{
  input: DeleteClinicContactInput;
}>;


export type DeleteClinicContactMutation = { deleteClinicContact: { createdAt: any, id: string, isDeleted: boolean, isPrimary: boolean, email?: string | null, name?: string | null, phone?: string | null, title?: string | null, createdBy: { createdAt: any, id: string, email: string, role: UserRole, clinicianAdvocate?: { id: string, email: string, profile: { firstName?: string | null, lastName?: string | null, displayName: string, userId: string, phone?: string | null, image?: { filename: string, key: string, location: string } | null } } | null } } };

export type SetPrimaryContactMutationVariables = Exact<{
  contactId: Scalars['String'];
}>;


export type SetPrimaryContactMutation = { setPrimaryContact: boolean };

export type AuthenticateClinicDrChronoIntegrationMutationVariables = Exact<{
  input: AuthenticateClinicDrChronoIntegrationInput;
}>;


export type AuthenticateClinicDrChronoIntegrationMutation = { authenticateClinicDrChronoIntegration: { id: string, integrations?: { drChrono: { isActive: boolean } } | null } };

export type ConfigureClinicDrChronoIntegrationMutationVariables = Exact<{
  input: ConfigureClinicDrChronoIntegrationInput;
  clinicId: Scalars['String'];
}>;


export type ConfigureClinicDrChronoIntegrationMutation = { configureClinicDrChronoIntegration: { id: string, integrations?: { drChrono: { isActive: boolean, config?: { clientId?: string | null, clientSecret?: string | null } | null } } | null } };

export type CustomizeClinicDrChronoIntegrationMutationVariables = Exact<{
  input: CustomizeClinicDrChronoIntegrationInput;
}>;


export type CustomizeClinicDrChronoIntegrationMutation = { customizeClinicDrChronoIntegration: { id: string, integrations?: { drChrono: { customization: { primaryButtonBgColor?: string | null } } } | null } };

export type DisableClinicDrChronoIntegrationMutationVariables = Exact<{
  input: DisableClinicDrChronoIntegrationInput;
  clinicId: Scalars['String'];
}>;


export type DisableClinicDrChronoIntegrationMutation = { disableClinicDrChronoIntegration: { id: string, integrations?: { drChrono: { isActive: boolean, config?: { clientId?: string | null, clientSecret?: string | null } | null } } | null } };

export type CreateJobMutationVariables = Exact<{
  input: CreateJobInput;
}>;


export type CreateJobMutation = { createJob: { aboutJob?: string | null, applied: boolean, clinicianAdvocateId?: string | null, clinicianType?: UserRole | null, clinicId: string, clinicContactId?: string | null, createdAt: any, createdBy: string, description?: string | null, desiredCertifications?: Array<Certification> | null, desiredHours?: string | null, desiredTelehealthExperience?: DesiredTelehealthExperience | null, displayClinicDetails?: boolean | null, education?: string | null, employmentType?: Array<EmploymentType> | null, emrProviders?: Array<EhrCompatibility> | null, id: string, interviewDetails?: string | null, isDeleted: boolean, isInternal: boolean, isTelehealth?: boolean | null, location?: JobLocation | null, minYearsExperience?: NumYearsExperience | null, numberToFill?: number | null, numberToFillIsUnlimited?: boolean | null, nurseSpecialty?: string | null, onboardingDetails?: string | null, orientationDetails?: string | null, otherInfo?: string | null, payAndPerks?: string | null, preferredLicenseStateIds?: Array<string> | null, profession?: string | null, requiredEquipment?: string | null, requiredLicenseStateIds?: Array<string> | null, requirements?: string | null, responsibilities?: string | null, salaryDetails?: string | null, schedulingDetails?: string | null, shiftDetails?: string | null, specialties?: Array<string> | null, startAt?: any | null, stateId?: string | null, status: JobStatus, title: string, trainingLevel?: string | null, zohoUrl?: string | null, clinicianAdvocate?: { createdAt: any, id: string, email: string, role: UserRole, profile: { firstName?: string | null, lastName?: string | null, userId: string }, clinicianAdvocate?: { id: string, email: string, profile: { firstName?: string | null, lastName?: string | null, displayName: string, userId: string, phone?: string | null, image?: { filename: string, key: string, location: string } | null } } | null } | null, clinic: { accountManagerId?: string | null, amenities?: string | null, createdAt: any, createdBy: string, id: string, name: string, numJobsActive?: number | null, phone?: string | null, resources?: string | null, websiteUrl?: string | null, zohoUrl?: string | null, accountManager?: { id: string, profile: { displayName: string, firstName?: string | null, lastName?: string | null, userId: string } } | null, image?: { filename: string, key: string, location: string } | null, jobs: Array<{ id: string, isTelehealth?: boolean | null, status: JobStatus }> }, preferredLicenseStates?: Array<{ id: string, name: string, shortName: string }> | null, requiredLicenseStates?: Array<{ id: string, name: string, shortName: string }> | null, state?: { id: string, name: string, shortName: string } | null } };

export type DeleteJobMutationVariables = Exact<{
  input: DeleteJobInput;
}>;


export type DeleteJobMutation = { deleteJob: { aboutJob?: string | null, applied: boolean, clinicianAdvocateId?: string | null, clinicianType?: UserRole | null, clinicId: string, clinicContactId?: string | null, createdAt: any, createdBy: string, description?: string | null, desiredCertifications?: Array<Certification> | null, desiredHours?: string | null, desiredTelehealthExperience?: DesiredTelehealthExperience | null, displayClinicDetails?: boolean | null, education?: string | null, employmentType?: Array<EmploymentType> | null, emrProviders?: Array<EhrCompatibility> | null, id: string, interviewDetails?: string | null, isDeleted: boolean, isInternal: boolean, isTelehealth?: boolean | null, location?: JobLocation | null, minYearsExperience?: NumYearsExperience | null, numberToFill?: number | null, numberToFillIsUnlimited?: boolean | null, nurseSpecialty?: string | null, onboardingDetails?: string | null, orientationDetails?: string | null, otherInfo?: string | null, payAndPerks?: string | null, preferredLicenseStateIds?: Array<string> | null, profession?: string | null, requiredEquipment?: string | null, requiredLicenseStateIds?: Array<string> | null, requirements?: string | null, responsibilities?: string | null, salaryDetails?: string | null, schedulingDetails?: string | null, shiftDetails?: string | null, specialties?: Array<string> | null, startAt?: any | null, stateId?: string | null, status: JobStatus, title: string, trainingLevel?: string | null, zohoUrl?: string | null, clinicianAdvocate?: { createdAt: any, id: string, email: string, role: UserRole, profile: { firstName?: string | null, lastName?: string | null, userId: string }, clinicianAdvocate?: { id: string, email: string, profile: { firstName?: string | null, lastName?: string | null, displayName: string, userId: string, phone?: string | null, image?: { filename: string, key: string, location: string } | null } } | null } | null, clinic: { accountManagerId?: string | null, amenities?: string | null, createdAt: any, createdBy: string, id: string, name: string, numJobsActive?: number | null, phone?: string | null, resources?: string | null, websiteUrl?: string | null, zohoUrl?: string | null, accountManager?: { id: string, profile: { displayName: string, firstName?: string | null, lastName?: string | null, userId: string } } | null, image?: { filename: string, key: string, location: string } | null, jobs: Array<{ id: string, isTelehealth?: boolean | null, status: JobStatus }> }, preferredLicenseStates?: Array<{ id: string, name: string, shortName: string }> | null, requiredLicenseStates?: Array<{ id: string, name: string, shortName: string }> | null, state?: { id: string, name: string, shortName: string } | null } };

export type EditJobMutationVariables = Exact<{
  input: EditJobInput;
}>;


export type EditJobMutation = { editJob: { aboutJob?: string | null, applied: boolean, clinicianAdvocateId?: string | null, clinicianType?: UserRole | null, clinicId: string, clinicContactId?: string | null, createdAt: any, createdBy: string, description?: string | null, desiredCertifications?: Array<Certification> | null, desiredHours?: string | null, desiredTelehealthExperience?: DesiredTelehealthExperience | null, displayClinicDetails?: boolean | null, education?: string | null, employmentType?: Array<EmploymentType> | null, emrProviders?: Array<EhrCompatibility> | null, id: string, interviewDetails?: string | null, isDeleted: boolean, isInternal: boolean, isTelehealth?: boolean | null, location?: JobLocation | null, minYearsExperience?: NumYearsExperience | null, numberToFill?: number | null, numberToFillIsUnlimited?: boolean | null, nurseSpecialty?: string | null, onboardingDetails?: string | null, orientationDetails?: string | null, otherInfo?: string | null, payAndPerks?: string | null, preferredLicenseStateIds?: Array<string> | null, profession?: string | null, requiredEquipment?: string | null, requiredLicenseStateIds?: Array<string> | null, requirements?: string | null, responsibilities?: string | null, salaryDetails?: string | null, schedulingDetails?: string | null, shiftDetails?: string | null, specialties?: Array<string> | null, startAt?: any | null, stateId?: string | null, status: JobStatus, title: string, trainingLevel?: string | null, zohoUrl?: string | null, clinicianAdvocate?: { createdAt: any, id: string, email: string, role: UserRole, profile: { firstName?: string | null, lastName?: string | null, userId: string }, clinicianAdvocate?: { id: string, email: string, profile: { firstName?: string | null, lastName?: string | null, displayName: string, userId: string, phone?: string | null, image?: { filename: string, key: string, location: string } | null } } | null } | null, clinic: { accountManagerId?: string | null, amenities?: string | null, createdAt: any, createdBy: string, id: string, name: string, numJobsActive?: number | null, phone?: string | null, resources?: string | null, websiteUrl?: string | null, zohoUrl?: string | null, accountManager?: { id: string, profile: { displayName: string, firstName?: string | null, lastName?: string | null, userId: string } } | null, image?: { filename: string, key: string, location: string } | null, jobs: Array<{ id: string, isTelehealth?: boolean | null, status: JobStatus }> }, preferredLicenseStates?: Array<{ id: string, name: string, shortName: string }> | null, requiredLicenseStates?: Array<{ id: string, name: string, shortName: string }> | null, state?: { id: string, name: string, shortName: string } | null } };

export type ApplyToJobMutationVariables = Exact<{
  input: ApplyToJobInput;
}>;


export type ApplyToJobMutation = { applyToJob: { id: string, jobId: string } };

export type CreateJobApplicationRulingDecisionEventMutationVariables = Exact<{
  input: CreateJobApplicationRulingDecisionEventInput;
}>;


export type CreateJobApplicationRulingDecisionEventMutation = { createJobApplicationRulingDecisionEvent: { id: string, latestRuling?: { id: string, decision?: JobApplicationRulingDecision | null, decisionReset?: boolean | null } | null, rulingEvents?: Array<{ createdAt: any, decision?: JobApplicationRulingDecision | null, decisionReset?: boolean | null, id: string, createdById: string, createdBy?: { email: string, id: string, profile: { displayName: string, firstName?: string | null, lastName?: string | null, userId: string } } | null }> | null } };

export type CreateJobApplicationRulingDecisionResetEventMutationVariables = Exact<{
  input: CreateJobApplicationRulingDecisionResetEventInput;
}>;


export type CreateJobApplicationRulingDecisionResetEventMutation = { createJobApplicationRulingDecisionResetEvent: { id: string, latestRuling?: { id: string, decision?: JobApplicationRulingDecision | null, decisionReset?: boolean | null } | null, rulingEvents?: Array<{ createdAt: any, decision?: JobApplicationRulingDecision | null, decisionReset?: boolean | null, id: string, createdById: string, createdBy?: { email: string, id: string, profile: { displayName: string, firstName?: string | null, lastName?: string | null, userId: string } } | null }> | null } };

export type CreateJobSuggestionMutationVariables = Exact<{
  input: CreateJobSuggestionInput;
}>;


export type CreateJobSuggestionMutation = { createJobSuggestion: { clinicianAdvocateId: string, createdAt: any, id: string, jobId: string, userId: string, job: { title: string }, user: { createdAt: any, id: string, email: string, role: UserRole, clinicianAdvocate?: { id: string, email: string, profile: { firstName?: string | null, lastName?: string | null, displayName: string, userId: string, phone?: string | null, image?: { filename: string, key: string, location: string } | null } } | null } } };

export type CreateSharingTokenMutationVariables = Exact<{
  input: CreateSharingTokenInput;
}>;


export type CreateSharingTokenMutation = { createSharingToken?: { id: string, createdAt: any, expires: any, createdBy: { id: string, email: string } } | null };

export type DeleteSharingTokenMutationVariables = Exact<{
  input: DeleteSharingTokenInput;
}>;


export type DeleteSharingTokenMutation = { deleteSharingToken?: boolean | null };

export type EditUserProfileMutationVariables = Exact<{
  input: EditUserProfileInput;
}>;


export type EditUserProfileMutation = { editUserProfile?: { tasks: Array<UserTask>, createdAt: any, id: string, email: string, role: UserRole, profile: { bio?: string | null, completion?: number | null, displayName: string, firstName?: string | null, lastName?: string | null, preferredName?: string | null, learnMore?: boolean | null, phone?: string | null, referral?: Referral | null, referralOther?: string | null, salutation?: Salutation | null, userId: string, networkStatus: UserNetworkStatus, address?: { city: { id: string, description?: string | null, image?: string | null, name: string, slug: string, stateId: string, state: { id: string, name: string, shortName: string } }, location?: { coordinates: Array<number> } | null, state: { id: string, name: string, shortName: string } } | null, cv?: { filename: string, key: string } | null, image?: { filename: string, key: string, location: string } | null, licenses: Array<{ expirationDate?: any | null, issueDate?: any | null, licenseNumber?: string | null, stateId: string, status: LicenseStatus, state: { id: string, name: string, shortName: string } }>, DEALicenses: Array<{ expirationDate?: any | null, issueDate?: any | null, licenseNumber?: string | null, stateId: string, status: LicenseStatus, state: { id: string, name: string, shortName: string } }>, professionalContext: { __typename: 'APPProfessionalContext', availabilityMaxNumber?: number | null, availabilityStartAt?: any | null, dateOfBirth?: any | null, degreeObtained?: string | null, EHRCompatibility?: Array<EhrCompatibility> | null, employmentHistory?: string | null, employmentStatus?: EmploymentStatus | null, graduatingInstitution?: string | null, graduationYear?: number | null, isVerified?: boolean | null, jobTypeSeeking?: Array<string> | null, lastFourSSN?: string | null, npi?: string | null, professionalReferencesText?: string | null, specialty?: string | null, type: UserRole, yearLastPracticed?: string | null, appLevelOfTraining?: LevelOfTrainingApp | null, availabilityShifts?: { sun?: Array<Shift> | null, mon?: Array<Shift> | null, tue?: Array<Shift> | null, wed?: Array<Shift> | null, thu?: Array<Shift> | null, fri?: Array<Shift> | null, sat?: Array<Shift> | null } | null } | { __typename: 'ClinicProfessionalContext' } | { __typename: 'NurseProfessionalContext', availabilityMaxNumber?: number | null, availabilityStartAt?: any | null, dateOfBirth?: any | null, degreeObtained?: string | null, EHRCompatibility?: Array<EhrCompatibility> | null, employmentHistory?: string | null, employmentStatus?: EmploymentStatus | null, graduatingInstitution?: string | null, graduationYear?: number | null, isVerified?: boolean | null, jobTypeSeeking?: Array<string> | null, lastFourSSN?: string | null, npi?: string | null, professionalReferencesText?: string | null, specialty?: string | null, type: UserRole, yearLastPracticed?: string | null, nurseLevelOfTraining?: LevelOfTrainingNurse | null, availabilityShifts?: { sun?: Array<Shift> | null, mon?: Array<Shift> | null, tue?: Array<Shift> | null, wed?: Array<Shift> | null, thu?: Array<Shift> | null, fri?: Array<Shift> | null, sat?: Array<Shift> | null } | null } | { __typename: 'OtherProfessionalContext', availabilityMaxNumber?: number | null, availabilityStartAt?: any | null, dateOfBirth?: any | null, degreeObtained?: string | null, employmentHistory?: string | null, employmentStatus?: EmploymentStatus | null, graduatingInstitution?: string | null, graduationYear?: number | null, isVerified?: boolean | null, jobTypeSeeking?: Array<string> | null, lastFourSSN?: string | null, profession?: string | null, professionOther?: string | null, professionalReferencesText?: string | null, type: UserRole, yearLastPracticed?: string | null, availabilityShifts?: { sun?: Array<Shift> | null, mon?: Array<Shift> | null, tue?: Array<Shift> | null, wed?: Array<Shift> | null, thu?: Array<Shift> | null, fri?: Array<Shift> | null, sat?: Array<Shift> | null } | null } | { __typename: 'PhysicianProfessionalContext', availabilityMaxNumber?: number | null, availabilityStartAt?: any | null, dateOfBirth?: any | null, degreeObtained?: string | null, EHRCompatibility?: Array<EhrCompatibility> | null, employmentHistory?: string | null, employmentStatus?: EmploymentStatus | null, graduatingInstitution?: string | null, graduationYear?: number | null, isVerified?: boolean | null, jobTypeSeeking?: Array<string> | null, lastFourSSN?: string | null, npi?: string | null, professionalReferencesText?: string | null, providerType?: string | null, specialty?: string | null, type: UserRole, yearLastPracticed?: string | null, physicianLevelOfTraining?: LevelOfTrainingPhysician | null, availabilityShifts?: { sun?: Array<Shift> | null, mon?: Array<Shift> | null, tue?: Array<Shift> | null, wed?: Array<Shift> | null, thu?: Array<Shift> | null, fri?: Array<Shift> | null, sat?: Array<Shift> | null } | null } | { __typename: 'TherapistProfessionalContext', availabilityMaxNumber?: number | null, availabilityStartAt?: any | null, dateOfBirth?: any | null, degreeObtained?: string | null, EHRCompatibility?: Array<EhrCompatibility> | null, employmentHistory?: string | null, employmentStatus?: EmploymentStatus | null, graduatingInstitution?: string | null, graduationYear?: number | null, isVerified?: boolean | null, jobTypeSeeking?: Array<string> | null, lastFourSSN?: string | null, professionalReferencesText?: string | null, providerType?: string | null, specialty?: string | null, type: UserRole, yearLastPracticed?: string | null, therapistLevelOfTraining?: string | null, availabilityShifts?: { sun?: Array<Shift> | null, mon?: Array<Shift> | null, tue?: Array<Shift> | null, wed?: Array<Shift> | null, thu?: Array<Shift> | null, fri?: Array<Shift> | null, sat?: Array<Shift> | null } | null } }, clinicianAdvocate?: { id: string, email: string, profile: { firstName?: string | null, lastName?: string | null, displayName: string, userId: string, phone?: string | null, image?: { filename: string, key: string, location: string } | null } } | null } | null };

export type SetJoinedPlatformInterestMutationVariables = Exact<{
  input: SetJoinedPlatformInterestInput;
}>;


export type SetJoinedPlatformInterestMutation = { setJoinedPlatformInterest?: { id: string, profile: { userId: string, joinedPlatformInterestDocument?: { joinedPlatformInterest: PlatformInterest, joinedPlatformInterestOther?: string | null } | null } } | null };

export type UploadCvMutationVariables = Exact<{
  input: UploadCvInput;
}>;


export type UploadCvMutation = { uploadCV?: { tasks: Array<UserTask>, createdAt: any, id: string, email: string, role: UserRole, profile: { bio?: string | null, completion?: number | null, displayName: string, firstName?: string | null, lastName?: string | null, preferredName?: string | null, learnMore?: boolean | null, phone?: string | null, referral?: Referral | null, referralOther?: string | null, salutation?: Salutation | null, userId: string, networkStatus: UserNetworkStatus, address?: { city: { id: string, description?: string | null, image?: string | null, name: string, slug: string, stateId: string, state: { id: string, name: string, shortName: string } }, location?: { coordinates: Array<number> } | null, state: { id: string, name: string, shortName: string } } | null, cv?: { filename: string, key: string } | null, image?: { filename: string, key: string, location: string } | null, licenses: Array<{ expirationDate?: any | null, issueDate?: any | null, licenseNumber?: string | null, stateId: string, status: LicenseStatus, state: { id: string, name: string, shortName: string } }>, DEALicenses: Array<{ expirationDate?: any | null, issueDate?: any | null, licenseNumber?: string | null, stateId: string, status: LicenseStatus, state: { id: string, name: string, shortName: string } }>, professionalContext: { __typename: 'APPProfessionalContext', availabilityMaxNumber?: number | null, availabilityStartAt?: any | null, dateOfBirth?: any | null, degreeObtained?: string | null, EHRCompatibility?: Array<EhrCompatibility> | null, employmentHistory?: string | null, employmentStatus?: EmploymentStatus | null, graduatingInstitution?: string | null, graduationYear?: number | null, isVerified?: boolean | null, jobTypeSeeking?: Array<string> | null, lastFourSSN?: string | null, npi?: string | null, professionalReferencesText?: string | null, specialty?: string | null, type: UserRole, yearLastPracticed?: string | null, appLevelOfTraining?: LevelOfTrainingApp | null, availabilityShifts?: { sun?: Array<Shift> | null, mon?: Array<Shift> | null, tue?: Array<Shift> | null, wed?: Array<Shift> | null, thu?: Array<Shift> | null, fri?: Array<Shift> | null, sat?: Array<Shift> | null } | null } | { __typename: 'ClinicProfessionalContext' } | { __typename: 'NurseProfessionalContext', availabilityMaxNumber?: number | null, availabilityStartAt?: any | null, dateOfBirth?: any | null, degreeObtained?: string | null, EHRCompatibility?: Array<EhrCompatibility> | null, employmentHistory?: string | null, employmentStatus?: EmploymentStatus | null, graduatingInstitution?: string | null, graduationYear?: number | null, isVerified?: boolean | null, jobTypeSeeking?: Array<string> | null, lastFourSSN?: string | null, npi?: string | null, professionalReferencesText?: string | null, specialty?: string | null, type: UserRole, yearLastPracticed?: string | null, nurseLevelOfTraining?: LevelOfTrainingNurse | null, availabilityShifts?: { sun?: Array<Shift> | null, mon?: Array<Shift> | null, tue?: Array<Shift> | null, wed?: Array<Shift> | null, thu?: Array<Shift> | null, fri?: Array<Shift> | null, sat?: Array<Shift> | null } | null } | { __typename: 'OtherProfessionalContext', availabilityMaxNumber?: number | null, availabilityStartAt?: any | null, dateOfBirth?: any | null, degreeObtained?: string | null, employmentHistory?: string | null, employmentStatus?: EmploymentStatus | null, graduatingInstitution?: string | null, graduationYear?: number | null, isVerified?: boolean | null, jobTypeSeeking?: Array<string> | null, lastFourSSN?: string | null, profession?: string | null, professionOther?: string | null, professionalReferencesText?: string | null, type: UserRole, yearLastPracticed?: string | null, availabilityShifts?: { sun?: Array<Shift> | null, mon?: Array<Shift> | null, tue?: Array<Shift> | null, wed?: Array<Shift> | null, thu?: Array<Shift> | null, fri?: Array<Shift> | null, sat?: Array<Shift> | null } | null } | { __typename: 'PhysicianProfessionalContext', availabilityMaxNumber?: number | null, availabilityStartAt?: any | null, dateOfBirth?: any | null, degreeObtained?: string | null, EHRCompatibility?: Array<EhrCompatibility> | null, employmentHistory?: string | null, employmentStatus?: EmploymentStatus | null, graduatingInstitution?: string | null, graduationYear?: number | null, isVerified?: boolean | null, jobTypeSeeking?: Array<string> | null, lastFourSSN?: string | null, npi?: string | null, professionalReferencesText?: string | null, providerType?: string | null, specialty?: string | null, type: UserRole, yearLastPracticed?: string | null, physicianLevelOfTraining?: LevelOfTrainingPhysician | null, availabilityShifts?: { sun?: Array<Shift> | null, mon?: Array<Shift> | null, tue?: Array<Shift> | null, wed?: Array<Shift> | null, thu?: Array<Shift> | null, fri?: Array<Shift> | null, sat?: Array<Shift> | null } | null } | { __typename: 'TherapistProfessionalContext', availabilityMaxNumber?: number | null, availabilityStartAt?: any | null, dateOfBirth?: any | null, degreeObtained?: string | null, EHRCompatibility?: Array<EhrCompatibility> | null, employmentHistory?: string | null, employmentStatus?: EmploymentStatus | null, graduatingInstitution?: string | null, graduationYear?: number | null, isVerified?: boolean | null, jobTypeSeeking?: Array<string> | null, lastFourSSN?: string | null, professionalReferencesText?: string | null, providerType?: string | null, specialty?: string | null, type: UserRole, yearLastPracticed?: string | null, therapistLevelOfTraining?: string | null, availabilityShifts?: { sun?: Array<Shift> | null, mon?: Array<Shift> | null, tue?: Array<Shift> | null, wed?: Array<Shift> | null, thu?: Array<Shift> | null, fri?: Array<Shift> | null, sat?: Array<Shift> | null } | null } }, clinicianAdvocate?: { id: string, email: string, profile: { firstName?: string | null, lastName?: string | null, displayName: string, userId: string, phone?: string | null, image?: { filename: string, key: string, location: string } | null } } | null } | null };

export type RemoveCvMutationVariables = Exact<{ [key: string]: never; }>;


export type RemoveCvMutation = { removeCV?: { tasks: Array<UserTask>, createdAt: any, id: string, email: string, role: UserRole, profile: { bio?: string | null, completion?: number | null, displayName: string, firstName?: string | null, lastName?: string | null, preferredName?: string | null, learnMore?: boolean | null, phone?: string | null, referral?: Referral | null, referralOther?: string | null, salutation?: Salutation | null, userId: string, networkStatus: UserNetworkStatus, address?: { city: { id: string, description?: string | null, image?: string | null, name: string, slug: string, stateId: string, state: { id: string, name: string, shortName: string } }, location?: { coordinates: Array<number> } | null, state: { id: string, name: string, shortName: string } } | null, cv?: { filename: string, key: string } | null, image?: { filename: string, key: string, location: string } | null, licenses: Array<{ expirationDate?: any | null, issueDate?: any | null, licenseNumber?: string | null, stateId: string, status: LicenseStatus, state: { id: string, name: string, shortName: string } }>, DEALicenses: Array<{ expirationDate?: any | null, issueDate?: any | null, licenseNumber?: string | null, stateId: string, status: LicenseStatus, state: { id: string, name: string, shortName: string } }>, professionalContext: { __typename: 'APPProfessionalContext', availabilityMaxNumber?: number | null, availabilityStartAt?: any | null, dateOfBirth?: any | null, degreeObtained?: string | null, EHRCompatibility?: Array<EhrCompatibility> | null, employmentHistory?: string | null, employmentStatus?: EmploymentStatus | null, graduatingInstitution?: string | null, graduationYear?: number | null, isVerified?: boolean | null, jobTypeSeeking?: Array<string> | null, lastFourSSN?: string | null, npi?: string | null, professionalReferencesText?: string | null, specialty?: string | null, type: UserRole, yearLastPracticed?: string | null, appLevelOfTraining?: LevelOfTrainingApp | null, availabilityShifts?: { sun?: Array<Shift> | null, mon?: Array<Shift> | null, tue?: Array<Shift> | null, wed?: Array<Shift> | null, thu?: Array<Shift> | null, fri?: Array<Shift> | null, sat?: Array<Shift> | null } | null } | { __typename: 'ClinicProfessionalContext' } | { __typename: 'NurseProfessionalContext', availabilityMaxNumber?: number | null, availabilityStartAt?: any | null, dateOfBirth?: any | null, degreeObtained?: string | null, EHRCompatibility?: Array<EhrCompatibility> | null, employmentHistory?: string | null, employmentStatus?: EmploymentStatus | null, graduatingInstitution?: string | null, graduationYear?: number | null, isVerified?: boolean | null, jobTypeSeeking?: Array<string> | null, lastFourSSN?: string | null, npi?: string | null, professionalReferencesText?: string | null, specialty?: string | null, type: UserRole, yearLastPracticed?: string | null, nurseLevelOfTraining?: LevelOfTrainingNurse | null, availabilityShifts?: { sun?: Array<Shift> | null, mon?: Array<Shift> | null, tue?: Array<Shift> | null, wed?: Array<Shift> | null, thu?: Array<Shift> | null, fri?: Array<Shift> | null, sat?: Array<Shift> | null } | null } | { __typename: 'OtherProfessionalContext', availabilityMaxNumber?: number | null, availabilityStartAt?: any | null, dateOfBirth?: any | null, degreeObtained?: string | null, employmentHistory?: string | null, employmentStatus?: EmploymentStatus | null, graduatingInstitution?: string | null, graduationYear?: number | null, isVerified?: boolean | null, jobTypeSeeking?: Array<string> | null, lastFourSSN?: string | null, profession?: string | null, professionOther?: string | null, professionalReferencesText?: string | null, type: UserRole, yearLastPracticed?: string | null, availabilityShifts?: { sun?: Array<Shift> | null, mon?: Array<Shift> | null, tue?: Array<Shift> | null, wed?: Array<Shift> | null, thu?: Array<Shift> | null, fri?: Array<Shift> | null, sat?: Array<Shift> | null } | null } | { __typename: 'PhysicianProfessionalContext', availabilityMaxNumber?: number | null, availabilityStartAt?: any | null, dateOfBirth?: any | null, degreeObtained?: string | null, EHRCompatibility?: Array<EhrCompatibility> | null, employmentHistory?: string | null, employmentStatus?: EmploymentStatus | null, graduatingInstitution?: string | null, graduationYear?: number | null, isVerified?: boolean | null, jobTypeSeeking?: Array<string> | null, lastFourSSN?: string | null, npi?: string | null, professionalReferencesText?: string | null, providerType?: string | null, specialty?: string | null, type: UserRole, yearLastPracticed?: string | null, physicianLevelOfTraining?: LevelOfTrainingPhysician | null, availabilityShifts?: { sun?: Array<Shift> | null, mon?: Array<Shift> | null, tue?: Array<Shift> | null, wed?: Array<Shift> | null, thu?: Array<Shift> | null, fri?: Array<Shift> | null, sat?: Array<Shift> | null } | null } | { __typename: 'TherapistProfessionalContext', availabilityMaxNumber?: number | null, availabilityStartAt?: any | null, dateOfBirth?: any | null, degreeObtained?: string | null, EHRCompatibility?: Array<EhrCompatibility> | null, employmentHistory?: string | null, employmentStatus?: EmploymentStatus | null, graduatingInstitution?: string | null, graduationYear?: number | null, isVerified?: boolean | null, jobTypeSeeking?: Array<string> | null, lastFourSSN?: string | null, professionalReferencesText?: string | null, providerType?: string | null, specialty?: string | null, type: UserRole, yearLastPracticed?: string | null, therapistLevelOfTraining?: string | null, availabilityShifts?: { sun?: Array<Shift> | null, mon?: Array<Shift> | null, tue?: Array<Shift> | null, wed?: Array<Shift> | null, thu?: Array<Shift> | null, fri?: Array<Shift> | null, sat?: Array<Shift> | null } | null } }, clinicianAdvocate?: { id: string, email: string, profile: { firstName?: string | null, lastName?: string | null, displayName: string, userId: string, phone?: string | null, image?: { filename: string, key: string, location: string } | null } } | null } | null };

export type UploadUserProfileImageMutationVariables = Exact<{
  input: UploadUserProfileImageInput;
}>;


export type UploadUserProfileImageMutation = { uploadUserProfileImage?: { tasks: Array<UserTask>, createdAt: any, id: string, email: string, role: UserRole, profile: { bio?: string | null, completion?: number | null, displayName: string, firstName?: string | null, lastName?: string | null, preferredName?: string | null, learnMore?: boolean | null, phone?: string | null, referral?: Referral | null, referralOther?: string | null, salutation?: Salutation | null, userId: string, networkStatus: UserNetworkStatus, address?: { city: { id: string, description?: string | null, image?: string | null, name: string, slug: string, stateId: string, state: { id: string, name: string, shortName: string } }, location?: { coordinates: Array<number> } | null, state: { id: string, name: string, shortName: string } } | null, cv?: { filename: string, key: string } | null, image?: { filename: string, key: string, location: string } | null, licenses: Array<{ expirationDate?: any | null, issueDate?: any | null, licenseNumber?: string | null, stateId: string, status: LicenseStatus, state: { id: string, name: string, shortName: string } }>, DEALicenses: Array<{ expirationDate?: any | null, issueDate?: any | null, licenseNumber?: string | null, stateId: string, status: LicenseStatus, state: { id: string, name: string, shortName: string } }>, professionalContext: { __typename: 'APPProfessionalContext', availabilityMaxNumber?: number | null, availabilityStartAt?: any | null, dateOfBirth?: any | null, degreeObtained?: string | null, EHRCompatibility?: Array<EhrCompatibility> | null, employmentHistory?: string | null, employmentStatus?: EmploymentStatus | null, graduatingInstitution?: string | null, graduationYear?: number | null, isVerified?: boolean | null, jobTypeSeeking?: Array<string> | null, lastFourSSN?: string | null, npi?: string | null, professionalReferencesText?: string | null, specialty?: string | null, type: UserRole, yearLastPracticed?: string | null, appLevelOfTraining?: LevelOfTrainingApp | null, availabilityShifts?: { sun?: Array<Shift> | null, mon?: Array<Shift> | null, tue?: Array<Shift> | null, wed?: Array<Shift> | null, thu?: Array<Shift> | null, fri?: Array<Shift> | null, sat?: Array<Shift> | null } | null } | { __typename: 'ClinicProfessionalContext' } | { __typename: 'NurseProfessionalContext', availabilityMaxNumber?: number | null, availabilityStartAt?: any | null, dateOfBirth?: any | null, degreeObtained?: string | null, EHRCompatibility?: Array<EhrCompatibility> | null, employmentHistory?: string | null, employmentStatus?: EmploymentStatus | null, graduatingInstitution?: string | null, graduationYear?: number | null, isVerified?: boolean | null, jobTypeSeeking?: Array<string> | null, lastFourSSN?: string | null, npi?: string | null, professionalReferencesText?: string | null, specialty?: string | null, type: UserRole, yearLastPracticed?: string | null, nurseLevelOfTraining?: LevelOfTrainingNurse | null, availabilityShifts?: { sun?: Array<Shift> | null, mon?: Array<Shift> | null, tue?: Array<Shift> | null, wed?: Array<Shift> | null, thu?: Array<Shift> | null, fri?: Array<Shift> | null, sat?: Array<Shift> | null } | null } | { __typename: 'OtherProfessionalContext', availabilityMaxNumber?: number | null, availabilityStartAt?: any | null, dateOfBirth?: any | null, degreeObtained?: string | null, employmentHistory?: string | null, employmentStatus?: EmploymentStatus | null, graduatingInstitution?: string | null, graduationYear?: number | null, isVerified?: boolean | null, jobTypeSeeking?: Array<string> | null, lastFourSSN?: string | null, profession?: string | null, professionOther?: string | null, professionalReferencesText?: string | null, type: UserRole, yearLastPracticed?: string | null, availabilityShifts?: { sun?: Array<Shift> | null, mon?: Array<Shift> | null, tue?: Array<Shift> | null, wed?: Array<Shift> | null, thu?: Array<Shift> | null, fri?: Array<Shift> | null, sat?: Array<Shift> | null } | null } | { __typename: 'PhysicianProfessionalContext', availabilityMaxNumber?: number | null, availabilityStartAt?: any | null, dateOfBirth?: any | null, degreeObtained?: string | null, EHRCompatibility?: Array<EhrCompatibility> | null, employmentHistory?: string | null, employmentStatus?: EmploymentStatus | null, graduatingInstitution?: string | null, graduationYear?: number | null, isVerified?: boolean | null, jobTypeSeeking?: Array<string> | null, lastFourSSN?: string | null, npi?: string | null, professionalReferencesText?: string | null, providerType?: string | null, specialty?: string | null, type: UserRole, yearLastPracticed?: string | null, physicianLevelOfTraining?: LevelOfTrainingPhysician | null, availabilityShifts?: { sun?: Array<Shift> | null, mon?: Array<Shift> | null, tue?: Array<Shift> | null, wed?: Array<Shift> | null, thu?: Array<Shift> | null, fri?: Array<Shift> | null, sat?: Array<Shift> | null } | null } | { __typename: 'TherapistProfessionalContext', availabilityMaxNumber?: number | null, availabilityStartAt?: any | null, dateOfBirth?: any | null, degreeObtained?: string | null, EHRCompatibility?: Array<EhrCompatibility> | null, employmentHistory?: string | null, employmentStatus?: EmploymentStatus | null, graduatingInstitution?: string | null, graduationYear?: number | null, isVerified?: boolean | null, jobTypeSeeking?: Array<string> | null, lastFourSSN?: string | null, professionalReferencesText?: string | null, providerType?: string | null, specialty?: string | null, type: UserRole, yearLastPracticed?: string | null, therapistLevelOfTraining?: string | null, availabilityShifts?: { sun?: Array<Shift> | null, mon?: Array<Shift> | null, tue?: Array<Shift> | null, wed?: Array<Shift> | null, thu?: Array<Shift> | null, fri?: Array<Shift> | null, sat?: Array<Shift> | null } | null } }, clinicianAdvocate?: { id: string, email: string, profile: { firstName?: string | null, lastName?: string | null, displayName: string, userId: string, phone?: string | null, image?: { filename: string, key: string, location: string } | null } } | null } | null };

export type RemoveUserProfileImageMutationVariables = Exact<{ [key: string]: never; }>;


export type RemoveUserProfileImageMutation = { removeUserProfileImage?: { tasks: Array<UserTask>, createdAt: any, id: string, email: string, role: UserRole, profile: { bio?: string | null, completion?: number | null, displayName: string, firstName?: string | null, lastName?: string | null, preferredName?: string | null, learnMore?: boolean | null, phone?: string | null, referral?: Referral | null, referralOther?: string | null, salutation?: Salutation | null, userId: string, networkStatus: UserNetworkStatus, address?: { city: { id: string, description?: string | null, image?: string | null, name: string, slug: string, stateId: string, state: { id: string, name: string, shortName: string } }, location?: { coordinates: Array<number> } | null, state: { id: string, name: string, shortName: string } } | null, cv?: { filename: string, key: string } | null, image?: { filename: string, key: string, location: string } | null, licenses: Array<{ expirationDate?: any | null, issueDate?: any | null, licenseNumber?: string | null, stateId: string, status: LicenseStatus, state: { id: string, name: string, shortName: string } }>, DEALicenses: Array<{ expirationDate?: any | null, issueDate?: any | null, licenseNumber?: string | null, stateId: string, status: LicenseStatus, state: { id: string, name: string, shortName: string } }>, professionalContext: { __typename: 'APPProfessionalContext', availabilityMaxNumber?: number | null, availabilityStartAt?: any | null, dateOfBirth?: any | null, degreeObtained?: string | null, EHRCompatibility?: Array<EhrCompatibility> | null, employmentHistory?: string | null, employmentStatus?: EmploymentStatus | null, graduatingInstitution?: string | null, graduationYear?: number | null, isVerified?: boolean | null, jobTypeSeeking?: Array<string> | null, lastFourSSN?: string | null, npi?: string | null, professionalReferencesText?: string | null, specialty?: string | null, type: UserRole, yearLastPracticed?: string | null, appLevelOfTraining?: LevelOfTrainingApp | null, availabilityShifts?: { sun?: Array<Shift> | null, mon?: Array<Shift> | null, tue?: Array<Shift> | null, wed?: Array<Shift> | null, thu?: Array<Shift> | null, fri?: Array<Shift> | null, sat?: Array<Shift> | null } | null } | { __typename: 'ClinicProfessionalContext' } | { __typename: 'NurseProfessionalContext', availabilityMaxNumber?: number | null, availabilityStartAt?: any | null, dateOfBirth?: any | null, degreeObtained?: string | null, EHRCompatibility?: Array<EhrCompatibility> | null, employmentHistory?: string | null, employmentStatus?: EmploymentStatus | null, graduatingInstitution?: string | null, graduationYear?: number | null, isVerified?: boolean | null, jobTypeSeeking?: Array<string> | null, lastFourSSN?: string | null, npi?: string | null, professionalReferencesText?: string | null, specialty?: string | null, type: UserRole, yearLastPracticed?: string | null, nurseLevelOfTraining?: LevelOfTrainingNurse | null, availabilityShifts?: { sun?: Array<Shift> | null, mon?: Array<Shift> | null, tue?: Array<Shift> | null, wed?: Array<Shift> | null, thu?: Array<Shift> | null, fri?: Array<Shift> | null, sat?: Array<Shift> | null } | null } | { __typename: 'OtherProfessionalContext', availabilityMaxNumber?: number | null, availabilityStartAt?: any | null, dateOfBirth?: any | null, degreeObtained?: string | null, employmentHistory?: string | null, employmentStatus?: EmploymentStatus | null, graduatingInstitution?: string | null, graduationYear?: number | null, isVerified?: boolean | null, jobTypeSeeking?: Array<string> | null, lastFourSSN?: string | null, profession?: string | null, professionOther?: string | null, professionalReferencesText?: string | null, type: UserRole, yearLastPracticed?: string | null, availabilityShifts?: { sun?: Array<Shift> | null, mon?: Array<Shift> | null, tue?: Array<Shift> | null, wed?: Array<Shift> | null, thu?: Array<Shift> | null, fri?: Array<Shift> | null, sat?: Array<Shift> | null } | null } | { __typename: 'PhysicianProfessionalContext', availabilityMaxNumber?: number | null, availabilityStartAt?: any | null, dateOfBirth?: any | null, degreeObtained?: string | null, EHRCompatibility?: Array<EhrCompatibility> | null, employmentHistory?: string | null, employmentStatus?: EmploymentStatus | null, graduatingInstitution?: string | null, graduationYear?: number | null, isVerified?: boolean | null, jobTypeSeeking?: Array<string> | null, lastFourSSN?: string | null, npi?: string | null, professionalReferencesText?: string | null, providerType?: string | null, specialty?: string | null, type: UserRole, yearLastPracticed?: string | null, physicianLevelOfTraining?: LevelOfTrainingPhysician | null, availabilityShifts?: { sun?: Array<Shift> | null, mon?: Array<Shift> | null, tue?: Array<Shift> | null, wed?: Array<Shift> | null, thu?: Array<Shift> | null, fri?: Array<Shift> | null, sat?: Array<Shift> | null } | null } | { __typename: 'TherapistProfessionalContext', availabilityMaxNumber?: number | null, availabilityStartAt?: any | null, dateOfBirth?: any | null, degreeObtained?: string | null, EHRCompatibility?: Array<EhrCompatibility> | null, employmentHistory?: string | null, employmentStatus?: EmploymentStatus | null, graduatingInstitution?: string | null, graduationYear?: number | null, isVerified?: boolean | null, jobTypeSeeking?: Array<string> | null, lastFourSSN?: string | null, professionalReferencesText?: string | null, providerType?: string | null, specialty?: string | null, type: UserRole, yearLastPracticed?: string | null, therapistLevelOfTraining?: string | null, availabilityShifts?: { sun?: Array<Shift> | null, mon?: Array<Shift> | null, tue?: Array<Shift> | null, wed?: Array<Shift> | null, thu?: Array<Shift> | null, fri?: Array<Shift> | null, sat?: Array<Shift> | null } | null } }, clinicianAdvocate?: { id: string, email: string, profile: { firstName?: string | null, lastName?: string | null, displayName: string, userId: string, phone?: string | null, image?: { filename: string, key: string, location: string } | null } } | null } | null };

export type RequestCvDownloadMutationVariables = Exact<{
  input: RequestCvDownloadInput;
}>;


export type RequestCvDownloadMutation = { requestCVDownload?: string | null };

export type ServerLogInMutationVariables = Exact<{
  input: LogInInput;
}>;


export type ServerLogInMutation = { logIn?: { token: string, userId: string } | null };

export type ServerSignUpMutationVariables = Exact<{
  input: SignUpInput;
  userProfileInput?: InputMaybe<EditUserProfileInput>;
}>;


export type ServerSignUpMutation = { signUp?: { token: string, userId: string } | null };

export type RequestPasswordResetMutationVariables = Exact<{
  input: RequestPasswordResetInput;
}>;


export type RequestPasswordResetMutation = { requestPasswordReset?: boolean | null };

export type ResetPasswordMutationVariables = Exact<{
  input: ResetPasswordInput;
}>;


export type ResetPasswordMutation = { resetPassword?: boolean | null };

export type SignUpAndApplyMutationVariables = Exact<{
  signUpInput: SignUpInput;
  userProfileInput: EditUserProfileInput;
  cv: Scalars['Upload'];
  statesLicensedIn?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  applyToJobInput: ApplyToJobInput;
}>;


export type SignUpAndApplyMutation = { signUpAndApply?: { user: { token: string, userId: string }, jobApplication: { id: string }, userProfile: { userId: string, licenses: Array<{ expirationDate?: any | null, issueDate?: any | null, licenseNumber?: string | null, stateId: string, status: LicenseStatus, state: { id: string, name: string, shortName: string } }> } } | null };

export type SetNetworkStatusMutationVariables = Exact<{
  input: SetUserNetworkStatusInput;
}>;


export type SetNetworkStatusMutation = { setUserNetworkStatus: { createdAt: any, id: string, email: string, role: UserRole, profile: { bio?: string | null, completion?: number | null, displayName: string, firstName?: string | null, lastName?: string | null, preferredName?: string | null, learnMore?: boolean | null, phone?: string | null, referral?: Referral | null, referralOther?: string | null, salutation?: Salutation | null, userId: string, networkStatus: UserNetworkStatus, address?: { city: { id: string, description?: string | null, image?: string | null, name: string, slug: string, stateId: string, state: { id: string, name: string, shortName: string } }, location?: { coordinates: Array<number> } | null, state: { id: string, name: string, shortName: string } } | null, cv?: { filename: string, key: string } | null, image?: { filename: string, key: string, location: string } | null, licenses: Array<{ expirationDate?: any | null, issueDate?: any | null, licenseNumber?: string | null, stateId: string, status: LicenseStatus, state: { id: string, name: string, shortName: string } }>, DEALicenses: Array<{ expirationDate?: any | null, issueDate?: any | null, licenseNumber?: string | null, stateId: string, status: LicenseStatus, state: { id: string, name: string, shortName: string } }>, professionalContext: { __typename: 'APPProfessionalContext', availabilityMaxNumber?: number | null, availabilityStartAt?: any | null, dateOfBirth?: any | null, degreeObtained?: string | null, EHRCompatibility?: Array<EhrCompatibility> | null, employmentHistory?: string | null, employmentStatus?: EmploymentStatus | null, graduatingInstitution?: string | null, graduationYear?: number | null, isVerified?: boolean | null, jobTypeSeeking?: Array<string> | null, lastFourSSN?: string | null, npi?: string | null, professionalReferencesText?: string | null, specialty?: string | null, type: UserRole, yearLastPracticed?: string | null, appLevelOfTraining?: LevelOfTrainingApp | null, availabilityShifts?: { sun?: Array<Shift> | null, mon?: Array<Shift> | null, tue?: Array<Shift> | null, wed?: Array<Shift> | null, thu?: Array<Shift> | null, fri?: Array<Shift> | null, sat?: Array<Shift> | null } | null } | { __typename: 'ClinicProfessionalContext' } | { __typename: 'NurseProfessionalContext', availabilityMaxNumber?: number | null, availabilityStartAt?: any | null, dateOfBirth?: any | null, degreeObtained?: string | null, EHRCompatibility?: Array<EhrCompatibility> | null, employmentHistory?: string | null, employmentStatus?: EmploymentStatus | null, graduatingInstitution?: string | null, graduationYear?: number | null, isVerified?: boolean | null, jobTypeSeeking?: Array<string> | null, lastFourSSN?: string | null, npi?: string | null, professionalReferencesText?: string | null, specialty?: string | null, type: UserRole, yearLastPracticed?: string | null, nurseLevelOfTraining?: LevelOfTrainingNurse | null, availabilityShifts?: { sun?: Array<Shift> | null, mon?: Array<Shift> | null, tue?: Array<Shift> | null, wed?: Array<Shift> | null, thu?: Array<Shift> | null, fri?: Array<Shift> | null, sat?: Array<Shift> | null } | null } | { __typename: 'OtherProfessionalContext', availabilityMaxNumber?: number | null, availabilityStartAt?: any | null, dateOfBirth?: any | null, degreeObtained?: string | null, employmentHistory?: string | null, employmentStatus?: EmploymentStatus | null, graduatingInstitution?: string | null, graduationYear?: number | null, isVerified?: boolean | null, jobTypeSeeking?: Array<string> | null, lastFourSSN?: string | null, profession?: string | null, professionOther?: string | null, professionalReferencesText?: string | null, type: UserRole, yearLastPracticed?: string | null, availabilityShifts?: { sun?: Array<Shift> | null, mon?: Array<Shift> | null, tue?: Array<Shift> | null, wed?: Array<Shift> | null, thu?: Array<Shift> | null, fri?: Array<Shift> | null, sat?: Array<Shift> | null } | null } | { __typename: 'PhysicianProfessionalContext', availabilityMaxNumber?: number | null, availabilityStartAt?: any | null, dateOfBirth?: any | null, degreeObtained?: string | null, EHRCompatibility?: Array<EhrCompatibility> | null, employmentHistory?: string | null, employmentStatus?: EmploymentStatus | null, graduatingInstitution?: string | null, graduationYear?: number | null, isVerified?: boolean | null, jobTypeSeeking?: Array<string> | null, lastFourSSN?: string | null, npi?: string | null, professionalReferencesText?: string | null, providerType?: string | null, specialty?: string | null, type: UserRole, yearLastPracticed?: string | null, physicianLevelOfTraining?: LevelOfTrainingPhysician | null, availabilityShifts?: { sun?: Array<Shift> | null, mon?: Array<Shift> | null, tue?: Array<Shift> | null, wed?: Array<Shift> | null, thu?: Array<Shift> | null, fri?: Array<Shift> | null, sat?: Array<Shift> | null } | null } | { __typename: 'TherapistProfessionalContext', availabilityMaxNumber?: number | null, availabilityStartAt?: any | null, dateOfBirth?: any | null, degreeObtained?: string | null, EHRCompatibility?: Array<EhrCompatibility> | null, employmentHistory?: string | null, employmentStatus?: EmploymentStatus | null, graduatingInstitution?: string | null, graduationYear?: number | null, isVerified?: boolean | null, jobTypeSeeking?: Array<string> | null, lastFourSSN?: string | null, professionalReferencesText?: string | null, providerType?: string | null, specialty?: string | null, type: UserRole, yearLastPracticed?: string | null, therapistLevelOfTraining?: string | null, availabilityShifts?: { sun?: Array<Shift> | null, mon?: Array<Shift> | null, tue?: Array<Shift> | null, wed?: Array<Shift> | null, thu?: Array<Shift> | null, fri?: Array<Shift> | null, sat?: Array<Shift> | null } | null } }, clinicianAdvocate?: { id: string, email: string, profile: { firstName?: string | null, lastName?: string | null, displayName: string, userId: string, phone?: string | null, image?: { filename: string, key: string, location: string } | null } } | null } };

export type NonAdminUserExistsQueryVariables = Exact<{
  email: Scalars['String'];
}>;


export type NonAdminUserExistsQuery = { nonAdminUserExists: boolean };

export type AdminAdminUsersQueryVariables = Exact<{ [key: string]: never; }>;


export type AdminAdminUsersQuery = { adminAdminUsers: Array<{ id: string, email: string, profile: { displayName: string, firstName?: string | null, lastName?: string | null, userId: string } }> };

export type AdminStatsQueryVariables = Exact<{
  rangeStart: Scalars['DateTime'];
  rangeEnd: Scalars['DateTime'];
}>;


export type AdminStatsQuery = { adminStats: { clinics: Array<{ id: string, createdAt: any, name: string }>, jobs: Array<{ id: string, createdAt: any, clinicId: string, title: string }>, users: Array<{ id: string, createdAt: any, role: UserRole, profile: { firstName?: string | null, lastName?: string | null, userId: string } }> } };

export type AdminUserQueryVariables = Exact<{
  userId: Scalars['String'];
}>;


export type AdminUserQuery = { adminUser: { clinicianAdvocateId?: string | null, zohoRecruitUserId?: string | null, createdAt: any, id: string, email: string, role: UserRole, profile: { missingFields: Array<string>, utm?: any | null, bio?: string | null, completion?: number | null, displayName: string, firstName?: string | null, lastName?: string | null, preferredName?: string | null, learnMore?: boolean | null, phone?: string | null, referral?: Referral | null, referralOther?: string | null, salutation?: Salutation | null, userId: string, networkStatus: UserNetworkStatus, licenses: Array<{ expirationDate?: any | null, issueDate?: any | null, licenseNumber?: string | null, stateId: string, status: LicenseStatus, state: { id: string, name: string, shortName: string } }>, address?: { city: { id: string, description?: string | null, image?: string | null, name: string, slug: string, stateId: string, state: { id: string, name: string, shortName: string } }, location?: { coordinates: Array<number> } | null, state: { id: string, name: string, shortName: string } } | null, cv?: { filename: string, key: string } | null, image?: { filename: string, key: string, location: string } | null, DEALicenses: Array<{ expirationDate?: any | null, issueDate?: any | null, licenseNumber?: string | null, stateId: string, status: LicenseStatus, state: { id: string, name: string, shortName: string } }>, professionalContext: { __typename: 'APPProfessionalContext', availabilityMaxNumber?: number | null, availabilityStartAt?: any | null, dateOfBirth?: any | null, degreeObtained?: string | null, EHRCompatibility?: Array<EhrCompatibility> | null, employmentHistory?: string | null, employmentStatus?: EmploymentStatus | null, graduatingInstitution?: string | null, graduationYear?: number | null, isVerified?: boolean | null, jobTypeSeeking?: Array<string> | null, lastFourSSN?: string | null, npi?: string | null, professionalReferencesText?: string | null, specialty?: string | null, type: UserRole, yearLastPracticed?: string | null, appLevelOfTraining?: LevelOfTrainingApp | null, availabilityShifts?: { sun?: Array<Shift> | null, mon?: Array<Shift> | null, tue?: Array<Shift> | null, wed?: Array<Shift> | null, thu?: Array<Shift> | null, fri?: Array<Shift> | null, sat?: Array<Shift> | null } | null } | { __typename: 'ClinicProfessionalContext' } | { __typename: 'NurseProfessionalContext', availabilityMaxNumber?: number | null, availabilityStartAt?: any | null, dateOfBirth?: any | null, degreeObtained?: string | null, EHRCompatibility?: Array<EhrCompatibility> | null, employmentHistory?: string | null, employmentStatus?: EmploymentStatus | null, graduatingInstitution?: string | null, graduationYear?: number | null, isVerified?: boolean | null, jobTypeSeeking?: Array<string> | null, lastFourSSN?: string | null, npi?: string | null, professionalReferencesText?: string | null, specialty?: string | null, type: UserRole, yearLastPracticed?: string | null, nurseLevelOfTraining?: LevelOfTrainingNurse | null, availabilityShifts?: { sun?: Array<Shift> | null, mon?: Array<Shift> | null, tue?: Array<Shift> | null, wed?: Array<Shift> | null, thu?: Array<Shift> | null, fri?: Array<Shift> | null, sat?: Array<Shift> | null } | null } | { __typename: 'OtherProfessionalContext', availabilityMaxNumber?: number | null, availabilityStartAt?: any | null, dateOfBirth?: any | null, degreeObtained?: string | null, employmentHistory?: string | null, employmentStatus?: EmploymentStatus | null, graduatingInstitution?: string | null, graduationYear?: number | null, isVerified?: boolean | null, jobTypeSeeking?: Array<string> | null, lastFourSSN?: string | null, profession?: string | null, professionOther?: string | null, professionalReferencesText?: string | null, type: UserRole, yearLastPracticed?: string | null, availabilityShifts?: { sun?: Array<Shift> | null, mon?: Array<Shift> | null, tue?: Array<Shift> | null, wed?: Array<Shift> | null, thu?: Array<Shift> | null, fri?: Array<Shift> | null, sat?: Array<Shift> | null } | null } | { __typename: 'PhysicianProfessionalContext', availabilityMaxNumber?: number | null, availabilityStartAt?: any | null, dateOfBirth?: any | null, degreeObtained?: string | null, EHRCompatibility?: Array<EhrCompatibility> | null, employmentHistory?: string | null, employmentStatus?: EmploymentStatus | null, graduatingInstitution?: string | null, graduationYear?: number | null, isVerified?: boolean | null, jobTypeSeeking?: Array<string> | null, lastFourSSN?: string | null, npi?: string | null, professionalReferencesText?: string | null, providerType?: string | null, specialty?: string | null, type: UserRole, yearLastPracticed?: string | null, physicianLevelOfTraining?: LevelOfTrainingPhysician | null, availabilityShifts?: { sun?: Array<Shift> | null, mon?: Array<Shift> | null, tue?: Array<Shift> | null, wed?: Array<Shift> | null, thu?: Array<Shift> | null, fri?: Array<Shift> | null, sat?: Array<Shift> | null } | null } | { __typename: 'TherapistProfessionalContext', availabilityMaxNumber?: number | null, availabilityStartAt?: any | null, dateOfBirth?: any | null, degreeObtained?: string | null, EHRCompatibility?: Array<EhrCompatibility> | null, employmentHistory?: string | null, employmentStatus?: EmploymentStatus | null, graduatingInstitution?: string | null, graduationYear?: number | null, isVerified?: boolean | null, jobTypeSeeking?: Array<string> | null, lastFourSSN?: string | null, professionalReferencesText?: string | null, providerType?: string | null, specialty?: string | null, type: UserRole, yearLastPracticed?: string | null, therapistLevelOfTraining?: string | null, availabilityShifts?: { sun?: Array<Shift> | null, mon?: Array<Shift> | null, tue?: Array<Shift> | null, wed?: Array<Shift> | null, thu?: Array<Shift> | null, fri?: Array<Shift> | null, sat?: Array<Shift> | null } | null } }, notes?: Array<{ createdAt: any, creatorId: string, id: string, isDeleted: boolean, message: string, userId: string, creator: { id: string, profile: { displayName: string, userId: string } } }> | null, clinicianAdvocate?: { id: string, email: string, profile: { firstName?: string | null, lastName?: string | null, userId: string, displayName: string, phone?: string | null, image?: { filename: string, key: string, location: string } | null } } | null, sharingTokens?: Array<{ id: string, createdAt: any, expires: any, createdBy: { id: string, email: string } }> | null, jobApplications?: Array<{ id: string, jobId: string, utm?: any | null, latestRuling?: { id: string, decision?: JobApplicationRulingDecision | null } | null, job: { title: string, clinicianType?: UserRole | null, id: string, specialties?: Array<string> | null, status: JobStatus, clinicianAdvocate?: { profile: { firstName?: string | null, lastName?: string | null, displayName: string, userId: string } } | null, clinic: { id: string, name: string } }, sharableProfileToken?: { clientDescription?: string | null, createdAt: any, createdById: string, expiresAt: any, token: string, createdBy: { id: string, profile: { firstName?: string | null, lastName?: string | null, displayName: string, userId: string } } } | null }> | null, verifiedActiveLicenses: Array<{ expirationDate?: any | null, issueDate?: any | null, licenseNumber?: string | null, stateId: string, status: LicenseStatus, state: { id: string, name: string, shortName: string } }>, jobSuggestions?: Array<{ clinicianAdvocateId: string, createdAt: any, id: string, jobId: string, job: { id: string, title: string, clinic: { id: string, name: string } } }> | null } };

export type CitiesQueryVariables = Exact<{
  stateId: Scalars['String'];
}>;


export type CitiesQuery = { cities: Array<{ id: string, description?: string | null, image?: string | null, name: string, slug: string, stateId: string, state: { id: string, name: string, shortName: string } }> };

export type ClinicQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type ClinicQuery = { clinic: { accountManagerId?: string | null, amenities?: string | null, createdAt: any, createdBy: string, id: string, name: string, numJobsActive?: number | null, phone?: string | null, resources?: string | null, websiteUrl?: string | null, zohoUrl?: string | null, contacts?: Array<{ createdAt: any, id: string, isDeleted: boolean, isPrimary: boolean, email?: string | null, name?: string | null, phone?: string | null, title?: string | null, createdBy: { createdAt: any, id: string, email: string, role: UserRole, clinicianAdvocate?: { id: string, email: string, profile: { firstName?: string | null, lastName?: string | null, displayName: string, userId: string, phone?: string | null, image?: { filename: string, key: string, location: string } | null } } | null } }> | null, jobs: Array<{ clinicianAdvocateId?: string | null, clinicContactId?: string | null, clinicId: string, clinicianType?: UserRole | null, createdAt: any, employmentType?: Array<EmploymentType> | null, id: string, isTelehealth?: boolean | null, salaryDetails?: string | null, specialties?: Array<string> | null, status: JobStatus, title: string, applications?: Array<{ id: string, latestRuling?: { id: string, createdAt: any, decision?: JobApplicationRulingDecision | null } | null }> | null, clinicianAdvocate?: { id: string, email: string, profile: { displayName: string, firstName?: string | null, lastName?: string | null, userId: string } } | null, clinicContact?: { id: string, email?: string | null, isDeleted: boolean, name?: string | null, phone?: string | null } | null, suggestions?: Array<{ id: string, createdAt: any }> | null }>, accountManager?: { id: string, profile: { displayName: string, firstName?: string | null, lastName?: string | null, userId: string } } | null, image?: { filename: string, key: string, location: string } | null } };

export type ClinicsQueryVariables = Exact<{ [key: string]: never; }>;


export type ClinicsQuery = { clinics: Array<{ accountManagerId?: string | null, amenities?: string | null, createdAt: any, createdBy: string, id: string, name: string, numJobsActive?: number | null, phone?: string | null, resources?: string | null, websiteUrl?: string | null, zohoUrl?: string | null, accountManager?: { id: string, profile: { displayName: string, firstName?: string | null, lastName?: string | null, userId: string } } | null, image?: { filename: string, key: string, location: string } | null, jobs: Array<{ id: string, isTelehealth?: boolean | null, status: JobStatus }> }> };

export type ClinicIntegrationsQueryVariables = Exact<{
  clinicId: Scalars['String'];
}>;


export type ClinicIntegrationsQuery = { clinic: { id: string, integrations?: { drChrono: { isActive: boolean, config?: { clientId?: string | null, clientSecret?: string | null } | null, customization: { primaryButtonBgColor?: string | null } } } | null } };

export type ClinicIntegrationsDrChronoOfficesQueryVariables = Exact<{
  clinicId: Scalars['String'];
}>;


export type ClinicIntegrationsDrChronoOfficesQuery = { clinic: { id: string, integrations?: { drChrono: { offices?: Array<{ id: string, name: string }> | null } } | null } };

export type ClinicAdminJobQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type ClinicAdminJobQuery = { clinicAdminJob: { aboutJob?: string | null, applied: boolean, clinicianAdvocateId?: string | null, clinicianType?: UserRole | null, clinicId: string, clinicContactId?: string | null, createdAt: any, createdBy: string, description?: string | null, desiredCertifications?: Array<Certification> | null, desiredHours?: string | null, desiredTelehealthExperience?: DesiredTelehealthExperience | null, displayClinicDetails?: boolean | null, education?: string | null, employmentType?: Array<EmploymentType> | null, emrProviders?: Array<EhrCompatibility> | null, id: string, interviewDetails?: string | null, isDeleted: boolean, isInternal: boolean, isTelehealth?: boolean | null, location?: JobLocation | null, minYearsExperience?: NumYearsExperience | null, numberToFill?: number | null, numberToFillIsUnlimited?: boolean | null, nurseSpecialty?: string | null, onboardingDetails?: string | null, orientationDetails?: string | null, otherInfo?: string | null, payAndPerks?: string | null, preferredLicenseStateIds?: Array<string> | null, profession?: string | null, requiredEquipment?: string | null, requiredLicenseStateIds?: Array<string> | null, requirements?: string | null, responsibilities?: string | null, salaryDetails?: string | null, schedulingDetails?: string | null, shiftDetails?: string | null, specialties?: Array<string> | null, startAt?: any | null, stateId?: string | null, status: JobStatus, title: string, trainingLevel?: string | null, zohoUrl?: string | null, clinicianAdvocate?: { createdAt: any, id: string, email: string, role: UserRole, profile: { firstName?: string | null, lastName?: string | null, userId: string }, clinicianAdvocate?: { id: string, email: string, profile: { firstName?: string | null, lastName?: string | null, displayName: string, userId: string, phone?: string | null, image?: { filename: string, key: string, location: string } | null } } | null } | null, clinic: { accountManagerId?: string | null, amenities?: string | null, createdAt: any, createdBy: string, id: string, name: string, numJobsActive?: number | null, phone?: string | null, resources?: string | null, websiteUrl?: string | null, zohoUrl?: string | null, accountManager?: { id: string, profile: { displayName: string, firstName?: string | null, lastName?: string | null, userId: string } } | null, image?: { filename: string, key: string, location: string } | null, jobs: Array<{ id: string, isTelehealth?: boolean | null, status: JobStatus }> }, preferredLicenseStates?: Array<{ id: string, name: string, shortName: string }> | null, requiredLicenseStates?: Array<{ id: string, name: string, shortName: string }> | null, state?: { id: string, name: string, shortName: string } | null } };

export type JobQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type JobQuery = { job: { aboutJob?: string | null, applicationDate?: any | null, applied: boolean, clinicianType?: UserRole | null, clinicId: string, createdAt: any, description?: string | null, desiredCertifications?: Array<Certification> | null, desiredHours?: string | null, desiredTelehealthExperience?: DesiredTelehealthExperience | null, employmentType?: Array<EmploymentType> | null, emrProviders?: Array<EhrCompatibility> | null, id: string, interviewDetails?: string | null, isDeleted: boolean, isTelehealth?: boolean | null, location?: JobLocation | null, minYearsExperience?: NumYearsExperience | null, numberToFill?: number | null, numberToFillIsUnlimited?: boolean | null, onboardingDetails?: string | null, orientationDetails?: string | null, otherInfo?: string | null, payAndPerks?: string | null, preferredLicenseStateIds?: Array<string> | null, requiredEquipment?: string | null, requiredLicenseStateIds?: Array<string> | null, requirements?: string | null, responsibilities?: string | null, salaryDetails?: string | null, schedulingDetails?: string | null, shiftDetails?: string | null, specialties?: Array<string> | null, startAt?: any | null, status: JobStatus, title: string, trainingLevel?: string | null, zohoUrl?: string | null, clinic: { id: string, name: string }, preferredLicenseStates?: Array<{ id: string, name: string, shortName: string }> | null, requiredLicenseStates?: Array<{ id: string, name: string, shortName: string }> | null, state?: { id: string, name: string, shortName: string } | null } };

export type JobSuggestionsByUserIdQueryVariables = Exact<{
  userId: Scalars['String'];
}>;


export type JobSuggestionsByUserIdQuery = { jobSuggestionsByUserId: Array<{ clinicianAdvocateId: string, createdAt: any, id: string, jobId: string, userId: string, job: { title: string }, user: { createdAt: any, id: string, email: string, role: UserRole, clinicianAdvocate?: { id: string, email: string, profile: { firstName?: string | null, lastName?: string | null, displayName: string, userId: string, phone?: string | null, image?: { filename: string, key: string, location: string } | null } } | null } }> };

export type JobSuggestionsByJobIdQueryVariables = Exact<{
  jobId: Scalars['String'];
}>;


export type JobSuggestionsByJobIdQuery = { jobSuggestionsByJobId: Array<{ clinicianAdvocateId: string, createdAt: any, id: string, jobId: string, userId: string, job: { title: string }, user: { createdAt: any, id: string, email: string, role: UserRole, clinicianAdvocate?: { id: string, email: string, profile: { firstName?: string | null, lastName?: string | null, displayName: string, userId: string, phone?: string | null, image?: { filename: string, key: string, location: string } | null } } | null } }> };

export type StatesQueryVariables = Exact<{ [key: string]: never; }>;


export type StatesQuery = { states: Array<{ id: string, name: string, shortName: string }> };

export type CurrentUserQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserQuery = { currentUser: { createdAt: any, id: string, email: string, role: UserRole, profile: { bio?: string | null, completion?: number | null, displayName: string, firstName?: string | null, lastName?: string | null, preferredName?: string | null, learnMore?: boolean | null, phone?: string | null, referral?: Referral | null, referralOther?: string | null, salutation?: Salutation | null, userId: string, networkStatus: UserNetworkStatus, joinedPlatformInterestDocument?: { joinedPlatformInterest: PlatformInterest, joinedPlatformInterestOther?: string | null } | null, address?: { city: { id: string, description?: string | null, image?: string | null, name: string, slug: string, stateId: string, state: { id: string, name: string, shortName: string } }, location?: { coordinates: Array<number> } | null, state: { id: string, name: string, shortName: string } } | null, cv?: { filename: string, key: string } | null, image?: { filename: string, key: string, location: string } | null, licenses: Array<{ expirationDate?: any | null, issueDate?: any | null, licenseNumber?: string | null, stateId: string, status: LicenseStatus, state: { id: string, name: string, shortName: string } }>, DEALicenses: Array<{ expirationDate?: any | null, issueDate?: any | null, licenseNumber?: string | null, stateId: string, status: LicenseStatus, state: { id: string, name: string, shortName: string } }>, professionalContext: { __typename: 'APPProfessionalContext', availabilityMaxNumber?: number | null, availabilityStartAt?: any | null, dateOfBirth?: any | null, degreeObtained?: string | null, EHRCompatibility?: Array<EhrCompatibility> | null, employmentHistory?: string | null, employmentStatus?: EmploymentStatus | null, graduatingInstitution?: string | null, graduationYear?: number | null, isVerified?: boolean | null, jobTypeSeeking?: Array<string> | null, lastFourSSN?: string | null, npi?: string | null, professionalReferencesText?: string | null, specialty?: string | null, type: UserRole, yearLastPracticed?: string | null, appLevelOfTraining?: LevelOfTrainingApp | null, availabilityShifts?: { sun?: Array<Shift> | null, mon?: Array<Shift> | null, tue?: Array<Shift> | null, wed?: Array<Shift> | null, thu?: Array<Shift> | null, fri?: Array<Shift> | null, sat?: Array<Shift> | null } | null } | { __typename: 'ClinicProfessionalContext' } | { __typename: 'NurseProfessionalContext', availabilityMaxNumber?: number | null, availabilityStartAt?: any | null, dateOfBirth?: any | null, degreeObtained?: string | null, EHRCompatibility?: Array<EhrCompatibility> | null, employmentHistory?: string | null, employmentStatus?: EmploymentStatus | null, graduatingInstitution?: string | null, graduationYear?: number | null, isVerified?: boolean | null, jobTypeSeeking?: Array<string> | null, lastFourSSN?: string | null, npi?: string | null, professionalReferencesText?: string | null, specialty?: string | null, type: UserRole, yearLastPracticed?: string | null, nurseLevelOfTraining?: LevelOfTrainingNurse | null, availabilityShifts?: { sun?: Array<Shift> | null, mon?: Array<Shift> | null, tue?: Array<Shift> | null, wed?: Array<Shift> | null, thu?: Array<Shift> | null, fri?: Array<Shift> | null, sat?: Array<Shift> | null } | null } | { __typename: 'OtherProfessionalContext', availabilityMaxNumber?: number | null, availabilityStartAt?: any | null, dateOfBirth?: any | null, degreeObtained?: string | null, employmentHistory?: string | null, employmentStatus?: EmploymentStatus | null, graduatingInstitution?: string | null, graduationYear?: number | null, isVerified?: boolean | null, jobTypeSeeking?: Array<string> | null, lastFourSSN?: string | null, profession?: string | null, professionOther?: string | null, professionalReferencesText?: string | null, type: UserRole, yearLastPracticed?: string | null, availabilityShifts?: { sun?: Array<Shift> | null, mon?: Array<Shift> | null, tue?: Array<Shift> | null, wed?: Array<Shift> | null, thu?: Array<Shift> | null, fri?: Array<Shift> | null, sat?: Array<Shift> | null } | null } | { __typename: 'PhysicianProfessionalContext', availabilityMaxNumber?: number | null, availabilityStartAt?: any | null, dateOfBirth?: any | null, degreeObtained?: string | null, EHRCompatibility?: Array<EhrCompatibility> | null, employmentHistory?: string | null, employmentStatus?: EmploymentStatus | null, graduatingInstitution?: string | null, graduationYear?: number | null, isVerified?: boolean | null, jobTypeSeeking?: Array<string> | null, lastFourSSN?: string | null, npi?: string | null, professionalReferencesText?: string | null, providerType?: string | null, specialty?: string | null, type: UserRole, yearLastPracticed?: string | null, physicianLevelOfTraining?: LevelOfTrainingPhysician | null, availabilityShifts?: { sun?: Array<Shift> | null, mon?: Array<Shift> | null, tue?: Array<Shift> | null, wed?: Array<Shift> | null, thu?: Array<Shift> | null, fri?: Array<Shift> | null, sat?: Array<Shift> | null } | null } | { __typename: 'TherapistProfessionalContext', availabilityMaxNumber?: number | null, availabilityStartAt?: any | null, dateOfBirth?: any | null, degreeObtained?: string | null, EHRCompatibility?: Array<EhrCompatibility> | null, employmentHistory?: string | null, employmentStatus?: EmploymentStatus | null, graduatingInstitution?: string | null, graduationYear?: number | null, isVerified?: boolean | null, jobTypeSeeking?: Array<string> | null, lastFourSSN?: string | null, professionalReferencesText?: string | null, providerType?: string | null, specialty?: string | null, type: UserRole, yearLastPracticed?: string | null, therapistLevelOfTraining?: string | null, availabilityShifts?: { sun?: Array<Shift> | null, mon?: Array<Shift> | null, tue?: Array<Shift> | null, wed?: Array<Shift> | null, thu?: Array<Shift> | null, fri?: Array<Shift> | null, sat?: Array<Shift> | null } | null } }, jobApplications?: Array<{ id: string, jobId: string, createdAt: any, latestRuling?: { id: string, createdAt: any, decision?: JobApplicationRulingDecision | null, decisionReset?: boolean | null } | null, job: { title: string, status: JobStatus } }> | null, jobSuggestions?: Array<{ clinicianAdvocateId: string, createdAt: any, id: string, jobId: string, userId: string, job: { title: string }, user: { createdAt: any, id: string, email: string, role: UserRole, clinicianAdvocate?: { id: string, email: string, profile: { firstName?: string | null, lastName?: string | null, displayName: string, userId: string, phone?: string | null, image?: { filename: string, key: string, location: string } | null } } | null } }> | null, clinicianAdvocate?: { id: string, email: string, profile: { firstName?: string | null, lastName?: string | null, displayName: string, userId: string, phone?: string | null, image?: { filename: string, key: string, location: string } | null } } | null } };

export type CurrentUserTasksQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserTasksQuery = { currentUser: { id: string, tasks: Array<UserTask> } };

export type VerifyPasswordResetTokenQueryVariables = Exact<{
  resetToken: Scalars['String'];
}>;


export type VerifyPasswordResetTokenQuery = { verifyPasswordResetToken: { createdAt: any, id: string, email: string, role: UserRole, clinicianAdvocate?: { id: string, email: string, profile: { firstName?: string | null, lastName?: string | null, displayName: string, userId: string, phone?: string | null, image?: { filename: string, key: string, location: string } | null } } | null } };

export const FileFieldsFragmentDoc = gql`
    fragment FileFields on UserUploadedFile {
  filename
  key
  location
}
    `;
export const UserFieldsFragmentDoc = gql`
    fragment UserFields on User {
  createdAt
  id
  email
  role
  clinicianAdvocate {
    id
    email
    profile {
      firstName
      lastName
      displayName @client
      userId
      phone
      image {
        ...FileFields
      }
    }
  }
}
    ${FileFieldsFragmentDoc}`;
export const ClinicContactFieldsFragmentDoc = gql`
    fragment ClinicContactFields on ClinicContact {
  createdAt
  createdBy {
    ...UserFields
  }
  id
  isDeleted
  isPrimary
  email
  name
  phone
  title
}
    ${UserFieldsFragmentDoc}`;
export const ClinicFieldsFragmentDoc = gql`
    fragment ClinicFields on Clinic {
  accountManager {
    id
    profile {
      displayName @client
      firstName
      lastName
      userId
    }
  }
  accountManagerId
  amenities
  createdAt
  createdBy
  id
  image {
    ...FileFields
  }
  jobs {
    id
    isTelehealth
    status
  }
  name
  numJobsActive
  phone
  resources
  websiteUrl
  zohoUrl
}
    ${FileFieldsFragmentDoc}`;
export const StateFieldsFragmentDoc = gql`
    fragment StateFields on State {
  id
  name
  shortName
}
    `;
export const JobFieldsFragmentDoc = gql`
    fragment JobFields on Job {
  aboutJob
  applied
  clinicianAdvocateId
  clinicianAdvocate {
    ...UserFields
    profile {
      firstName
      lastName
      userId
    }
  }
  clinicianType
  clinic {
    ...ClinicFields
  }
  clinicId
  clinicContactId
  createdAt
  createdBy
  description
  desiredCertifications
  desiredHours
  desiredTelehealthExperience
  displayClinicDetails
  education
  employmentType
  emrProviders
  id
  interviewDetails
  isDeleted
  isInternal
  isTelehealth
  location
  minYearsExperience
  numberToFill
  numberToFillIsUnlimited
  nurseSpecialty
  onboardingDetails
  orientationDetails
  otherInfo
  payAndPerks
  preferredLicenseStateIds
  preferredLicenseStates {
    ...StateFields
  }
  profession
  requiredEquipment
  requiredLicenseStateIds
  requiredLicenseStates {
    ...StateFields
  }
  requirements
  responsibilities
  salaryDetails
  schedulingDetails
  shiftDetails
  specialties
  startAt
  stateId
  state {
    ...StateFields
  }
  status
  title
  trainingLevel
  zohoUrl
}
    ${UserFieldsFragmentDoc}
${ClinicFieldsFragmentDoc}
${StateFieldsFragmentDoc}`;
export const JobSuggestionFieldsFragmentDoc = gql`
    fragment JobSuggestionFields on JobSuggestion {
  clinicianAdvocateId
  createdAt
  id
  jobId
  job {
    title
  }
  userId
  user {
    ...UserFields
  }
}
    ${UserFieldsFragmentDoc}`;
export const SharingTokenFieldsFragmentDoc = gql`
    fragment SharingTokenFields on SharingToken {
  id
  createdAt
  createdBy {
    id
    email
  }
  expires
}
    `;
export const SimpleProfessionalContextFragmentDoc = gql`
    fragment SimpleProfessionalContext on UserProfile {
  professionalContext {
    ... on APPProfessionalContext {
      isVerified
      jobTypeSeeking
      appLevelOfTraining: levelOfTraining
      specialty
      type
    }
    ... on NurseProfessionalContext {
      isVerified
      jobTypeSeeking
      nurseLevelOfTraining: levelOfTraining
      specialty
      type
    }
    ... on OtherProfessionalContext {
      isVerified
      jobTypeSeeking
      profession
      professionOther
      type
    }
    ... on PhysicianProfessionalContext {
      isVerified
      jobTypeSeeking
      physicianLevelOfTraining: levelOfTraining
      providerType
      specialty
      type
    }
    ... on TherapistProfessionalContext {
      isVerified
      jobTypeSeeking
      therapistLevelOfTraining: levelOfTraining
      providerType
      specialty
      type
    }
  }
}
    `;
export const CityFieldsFragmentDoc = gql`
    fragment CityFields on City {
  id
  description
  image
  name
  slug
  stateId
  state {
    ...StateFields
  }
}
    ${StateFieldsFragmentDoc}`;
export const UserAddressFieldsFragmentDoc = gql`
    fragment UserAddressFields on UserAddress {
  city {
    ...CityFields
  }
  location {
    coordinates
  }
  state {
    ...StateFields
  }
}
    ${CityFieldsFragmentDoc}
${StateFieldsFragmentDoc}`;
export const LicenseFieldsFragmentDoc = gql`
    fragment LicenseFields on License {
  expirationDate
  issueDate
  licenseNumber
  state {
    ...StateFields
  }
  stateId
  status
}
    ${StateFieldsFragmentDoc}`;
export const AvailabilityShiftsFieldsFragmentDoc = gql`
    fragment AvailabilityShiftsFields on AvailabilityShifts {
  sun
  mon
  tue
  wed
  thu
  fri
  sat
}
    `;
export const AppProfessionalContextFieldsFragmentDoc = gql`
    fragment APPProfessionalContextFields on APPProfessionalContext {
  availabilityMaxNumber
  availabilityShifts {
    ...AvailabilityShiftsFields
  }
  availabilityStartAt
  dateOfBirth
  degreeObtained
  EHRCompatibility
  employmentHistory
  employmentStatus
  graduatingInstitution
  graduationYear
  isVerified
  jobTypeSeeking
  lastFourSSN
  npi
  appLevelOfTraining: levelOfTraining
  professionalReferencesText
  specialty
  type
  yearLastPracticed
}
    ${AvailabilityShiftsFieldsFragmentDoc}`;
export const NurseProfessionalContextFieldsFragmentDoc = gql`
    fragment NurseProfessionalContextFields on NurseProfessionalContext {
  availabilityMaxNumber
  availabilityShifts {
    ...AvailabilityShiftsFields
  }
  availabilityStartAt
  dateOfBirth
  degreeObtained
  EHRCompatibility
  employmentHistory
  employmentStatus
  graduatingInstitution
  graduationYear
  isVerified
  jobTypeSeeking
  lastFourSSN
  npi
  nurseLevelOfTraining: levelOfTraining
  professionalReferencesText
  specialty
  type
  yearLastPracticed
}
    ${AvailabilityShiftsFieldsFragmentDoc}`;
export const OtherProfessionalContextFieldsFragmentDoc = gql`
    fragment OtherProfessionalContextFields on OtherProfessionalContext {
  availabilityMaxNumber
  availabilityShifts {
    ...AvailabilityShiftsFields
  }
  availabilityStartAt
  dateOfBirth
  degreeObtained
  employmentHistory
  employmentStatus
  graduatingInstitution
  graduationYear
  isVerified
  jobTypeSeeking
  lastFourSSN
  profession
  professionOther
  professionalReferencesText
  type
  yearLastPracticed
}
    ${AvailabilityShiftsFieldsFragmentDoc}`;
export const PhysicianProfessionalContextFieldsFragmentDoc = gql`
    fragment PhysicianProfessionalContextFields on PhysicianProfessionalContext {
  availabilityMaxNumber
  availabilityShifts {
    ...AvailabilityShiftsFields
  }
  availabilityStartAt
  dateOfBirth
  degreeObtained
  EHRCompatibility
  employmentHistory
  employmentStatus
  graduatingInstitution
  graduationYear
  isVerified
  jobTypeSeeking
  lastFourSSN
  npi
  physicianLevelOfTraining: levelOfTraining
  professionalReferencesText
  providerType
  specialty
  type
  yearLastPracticed
}
    ${AvailabilityShiftsFieldsFragmentDoc}`;
export const TherapistProfessionalContextFieldsFragmentDoc = gql`
    fragment TherapistProfessionalContextFields on TherapistProfessionalContext {
  availabilityMaxNumber
  availabilityShifts {
    ...AvailabilityShiftsFields
  }
  availabilityStartAt
  dateOfBirth
  degreeObtained
  EHRCompatibility
  employmentHistory
  employmentStatus
  graduatingInstitution
  graduationYear
  isVerified
  jobTypeSeeking
  lastFourSSN
  therapistLevelOfTraining: levelOfTraining
  professionalReferencesText
  providerType
  specialty
  type
  yearLastPracticed
}
    ${AvailabilityShiftsFieldsFragmentDoc}`;
export const ProfessionalContextFragmentDoc = gql`
    fragment ProfessionalContext on UserProfile {
  professionalContext {
    __typename
    ... on APPProfessionalContext {
      ...APPProfessionalContextFields
    }
    ... on NurseProfessionalContext {
      ...NurseProfessionalContextFields
    }
    ... on OtherProfessionalContext {
      ...OtherProfessionalContextFields
    }
    ... on PhysicianProfessionalContext {
      ...PhysicianProfessionalContextFields
    }
    ... on TherapistProfessionalContext {
      ...TherapistProfessionalContextFields
    }
  }
}
    ${AppProfessionalContextFieldsFragmentDoc}
${NurseProfessionalContextFieldsFragmentDoc}
${OtherProfessionalContextFieldsFragmentDoc}
${PhysicianProfessionalContextFieldsFragmentDoc}
${TherapistProfessionalContextFieldsFragmentDoc}`;
export const UserProfileFieldsFragmentDoc = gql`
    fragment UserProfileFields on UserProfile {
  address {
    ...UserAddressFields
  }
  bio
  completion
  cv {
    filename
    key
  }
  displayName @client
  firstName
  image {
    ...FileFields
  }
  lastName
  preferredName
  learnMore
  licenses {
    ...LicenseFields
  }
  DEALicenses {
    ...LicenseFields
  }
  phone
  ...ProfessionalContext
  referral
  referralOther
  salutation
  userId
  networkStatus
}
    ${UserAddressFieldsFragmentDoc}
${FileFieldsFragmentDoc}
${LicenseFieldsFragmentDoc}
${ProfessionalContextFragmentDoc}`;
export const UserNoteFieldsFragmentDoc = gql`
    fragment UserNoteFields on UserNote {
  createdAt
  creator {
    id
    profile {
      displayName @client
      userId
    }
  }
  creatorId
  id
  isDeleted
  message
  userId
}
    `;
export const AdminCreateUserNoteDocument = gql`
    mutation AdminCreateUserNote($input: AdminCreateUserNoteInput!) {
  adminCreateUserNote(input: $input) {
    ...UserNoteFields
  }
}
    ${UserNoteFieldsFragmentDoc}`;
export type AdminCreateUserNoteMutationFn = Apollo.MutationFunction<AdminCreateUserNoteMutation, AdminCreateUserNoteMutationVariables>;

/**
 * __useAdminCreateUserNoteMutation__
 *
 * To run a mutation, you first call `useAdminCreateUserNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminCreateUserNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminCreateUserNoteMutation, { data, loading, error }] = useAdminCreateUserNoteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminCreateUserNoteMutation(baseOptions?: Apollo.MutationHookOptions<AdminCreateUserNoteMutation, AdminCreateUserNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminCreateUserNoteMutation, AdminCreateUserNoteMutationVariables>(AdminCreateUserNoteDocument, options);
      }
export type AdminCreateUserNoteMutationHookResult = ReturnType<typeof useAdminCreateUserNoteMutation>;
export type AdminCreateUserNoteMutationResult = Apollo.MutationResult<AdminCreateUserNoteMutation>;
export type AdminCreateUserNoteMutationOptions = Apollo.BaseMutationOptions<AdminCreateUserNoteMutation, AdminCreateUserNoteMutationVariables>;
export const AdminDeleteUserNoteDocument = gql`
    mutation AdminDeleteUserNote($input: AdminDeleteUserNoteInput!) {
  adminDeleteUserNote(input: $input) {
    ...UserNoteFields
  }
}
    ${UserNoteFieldsFragmentDoc}`;
export type AdminDeleteUserNoteMutationFn = Apollo.MutationFunction<AdminDeleteUserNoteMutation, AdminDeleteUserNoteMutationVariables>;

/**
 * __useAdminDeleteUserNoteMutation__
 *
 * To run a mutation, you first call `useAdminDeleteUserNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminDeleteUserNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminDeleteUserNoteMutation, { data, loading, error }] = useAdminDeleteUserNoteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminDeleteUserNoteMutation(baseOptions?: Apollo.MutationHookOptions<AdminDeleteUserNoteMutation, AdminDeleteUserNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminDeleteUserNoteMutation, AdminDeleteUserNoteMutationVariables>(AdminDeleteUserNoteDocument, options);
      }
export type AdminDeleteUserNoteMutationHookResult = ReturnType<typeof useAdminDeleteUserNoteMutation>;
export type AdminDeleteUserNoteMutationResult = Apollo.MutationResult<AdminDeleteUserNoteMutation>;
export type AdminDeleteUserNoteMutationOptions = Apollo.BaseMutationOptions<AdminDeleteUserNoteMutation, AdminDeleteUserNoteMutationVariables>;
export const AdminGenerateReportDocument = gql`
    mutation AdminGenerateReport($input: AdminGenerateReportInput!) {
  adminGenerateReport(input: $input)
}
    `;
export type AdminGenerateReportMutationFn = Apollo.MutationFunction<AdminGenerateReportMutation, AdminGenerateReportMutationVariables>;

/**
 * __useAdminGenerateReportMutation__
 *
 * To run a mutation, you first call `useAdminGenerateReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminGenerateReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminGenerateReportMutation, { data, loading, error }] = useAdminGenerateReportMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminGenerateReportMutation(baseOptions?: Apollo.MutationHookOptions<AdminGenerateReportMutation, AdminGenerateReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminGenerateReportMutation, AdminGenerateReportMutationVariables>(AdminGenerateReportDocument, options);
      }
export type AdminGenerateReportMutationHookResult = ReturnType<typeof useAdminGenerateReportMutation>;
export type AdminGenerateReportMutationResult = Apollo.MutationResult<AdminGenerateReportMutation>;
export type AdminGenerateReportMutationOptions = Apollo.BaseMutationOptions<AdminGenerateReportMutation, AdminGenerateReportMutationVariables>;
export const AdminSetClinicianAdvocateIdDocument = gql`
    mutation AdminSetClinicianAdvocateId($input: AdminAssignClinicianAdvocateInput!) {
  adminAssignClinicianAdvocate(input: $input) {
    id
    clinicianAdvocateId
    clinicianAdvocate {
      id
      email
      profile {
        userId
        firstName
        lastName
        displayName @client
      }
    }
  }
}
    `;
export type AdminSetClinicianAdvocateIdMutationFn = Apollo.MutationFunction<AdminSetClinicianAdvocateIdMutation, AdminSetClinicianAdvocateIdMutationVariables>;

/**
 * __useAdminSetClinicianAdvocateIdMutation__
 *
 * To run a mutation, you first call `useAdminSetClinicianAdvocateIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminSetClinicianAdvocateIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminSetClinicianAdvocateIdMutation, { data, loading, error }] = useAdminSetClinicianAdvocateIdMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminSetClinicianAdvocateIdMutation(baseOptions?: Apollo.MutationHookOptions<AdminSetClinicianAdvocateIdMutation, AdminSetClinicianAdvocateIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminSetClinicianAdvocateIdMutation, AdminSetClinicianAdvocateIdMutationVariables>(AdminSetClinicianAdvocateIdDocument, options);
      }
export type AdminSetClinicianAdvocateIdMutationHookResult = ReturnType<typeof useAdminSetClinicianAdvocateIdMutation>;
export type AdminSetClinicianAdvocateIdMutationResult = Apollo.MutationResult<AdminSetClinicianAdvocateIdMutation>;
export type AdminSetClinicianAdvocateIdMutationOptions = Apollo.BaseMutationOptions<AdminSetClinicianAdvocateIdMutation, AdminSetClinicianAdvocateIdMutationVariables>;
export const AdminUnsetClinicianAdvocateIdDocument = gql`
    mutation AdminUnsetClinicianAdvocateId($input: AdminUnassignClinicianAdvocateInput!) {
  adminUnassignClinicianAdvocate(input: $input) {
    id
    clinicianAdvocateId
    clinicianAdvocate {
      id
      email
      profile {
        userId
        firstName
        lastName
        displayName @client
      }
    }
  }
}
    `;
export type AdminUnsetClinicianAdvocateIdMutationFn = Apollo.MutationFunction<AdminUnsetClinicianAdvocateIdMutation, AdminUnsetClinicianAdvocateIdMutationVariables>;

/**
 * __useAdminUnsetClinicianAdvocateIdMutation__
 *
 * To run a mutation, you first call `useAdminUnsetClinicianAdvocateIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminUnsetClinicianAdvocateIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminUnsetClinicianAdvocateIdMutation, { data, loading, error }] = useAdminUnsetClinicianAdvocateIdMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminUnsetClinicianAdvocateIdMutation(baseOptions?: Apollo.MutationHookOptions<AdminUnsetClinicianAdvocateIdMutation, AdminUnsetClinicianAdvocateIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminUnsetClinicianAdvocateIdMutation, AdminUnsetClinicianAdvocateIdMutationVariables>(AdminUnsetClinicianAdvocateIdDocument, options);
      }
export type AdminUnsetClinicianAdvocateIdMutationHookResult = ReturnType<typeof useAdminUnsetClinicianAdvocateIdMutation>;
export type AdminUnsetClinicianAdvocateIdMutationResult = Apollo.MutationResult<AdminUnsetClinicianAdvocateIdMutation>;
export type AdminUnsetClinicianAdvocateIdMutationOptions = Apollo.BaseMutationOptions<AdminUnsetClinicianAdvocateIdMutation, AdminUnsetClinicianAdvocateIdMutationVariables>;
export const CreateClinicDocument = gql`
    mutation CreateClinic($input: CreateClinicInput!) {
  createClinic(input: $input) {
    ...ClinicFields
  }
}
    ${ClinicFieldsFragmentDoc}`;
export type CreateClinicMutationFn = Apollo.MutationFunction<CreateClinicMutation, CreateClinicMutationVariables>;

/**
 * __useCreateClinicMutation__
 *
 * To run a mutation, you first call `useCreateClinicMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateClinicMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createClinicMutation, { data, loading, error }] = useCreateClinicMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateClinicMutation(baseOptions?: Apollo.MutationHookOptions<CreateClinicMutation, CreateClinicMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateClinicMutation, CreateClinicMutationVariables>(CreateClinicDocument, options);
      }
export type CreateClinicMutationHookResult = ReturnType<typeof useCreateClinicMutation>;
export type CreateClinicMutationResult = Apollo.MutationResult<CreateClinicMutation>;
export type CreateClinicMutationOptions = Apollo.BaseMutationOptions<CreateClinicMutation, CreateClinicMutationVariables>;
export const EditClinicDocument = gql`
    mutation EditClinic($input: EditClinicInput!) {
  editClinic(input: $input) {
    ...ClinicFields
  }
}
    ${ClinicFieldsFragmentDoc}`;
export type EditClinicMutationFn = Apollo.MutationFunction<EditClinicMutation, EditClinicMutationVariables>;

/**
 * __useEditClinicMutation__
 *
 * To run a mutation, you first call `useEditClinicMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditClinicMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editClinicMutation, { data, loading, error }] = useEditClinicMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditClinicMutation(baseOptions?: Apollo.MutationHookOptions<EditClinicMutation, EditClinicMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditClinicMutation, EditClinicMutationVariables>(EditClinicDocument, options);
      }
export type EditClinicMutationHookResult = ReturnType<typeof useEditClinicMutation>;
export type EditClinicMutationResult = Apollo.MutationResult<EditClinicMutation>;
export type EditClinicMutationOptions = Apollo.BaseMutationOptions<EditClinicMutation, EditClinicMutationVariables>;
export const SetClinicAccountManagerDocument = gql`
    mutation SetClinicAccountManager($input: SetClinicAccountManagerInput!) {
  setClinicAccountManager(input: $input) {
    ...ClinicFields
  }
}
    ${ClinicFieldsFragmentDoc}`;
export type SetClinicAccountManagerMutationFn = Apollo.MutationFunction<SetClinicAccountManagerMutation, SetClinicAccountManagerMutationVariables>;

/**
 * __useSetClinicAccountManagerMutation__
 *
 * To run a mutation, you first call `useSetClinicAccountManagerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetClinicAccountManagerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setClinicAccountManagerMutation, { data, loading, error }] = useSetClinicAccountManagerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetClinicAccountManagerMutation(baseOptions?: Apollo.MutationHookOptions<SetClinicAccountManagerMutation, SetClinicAccountManagerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetClinicAccountManagerMutation, SetClinicAccountManagerMutationVariables>(SetClinicAccountManagerDocument, options);
      }
export type SetClinicAccountManagerMutationHookResult = ReturnType<typeof useSetClinicAccountManagerMutation>;
export type SetClinicAccountManagerMutationResult = Apollo.MutationResult<SetClinicAccountManagerMutation>;
export type SetClinicAccountManagerMutationOptions = Apollo.BaseMutationOptions<SetClinicAccountManagerMutation, SetClinicAccountManagerMutationVariables>;
export const UploadClinicImageDocument = gql`
    mutation UploadClinicImage($input: UploadClinicImageInput!) {
  uploadClinicImage(input: $input) {
    ...ClinicFields
  }
}
    ${ClinicFieldsFragmentDoc}`;
export type UploadClinicImageMutationFn = Apollo.MutationFunction<UploadClinicImageMutation, UploadClinicImageMutationVariables>;

/**
 * __useUploadClinicImageMutation__
 *
 * To run a mutation, you first call `useUploadClinicImageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadClinicImageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadClinicImageMutation, { data, loading, error }] = useUploadClinicImageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUploadClinicImageMutation(baseOptions?: Apollo.MutationHookOptions<UploadClinicImageMutation, UploadClinicImageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadClinicImageMutation, UploadClinicImageMutationVariables>(UploadClinicImageDocument, options);
      }
export type UploadClinicImageMutationHookResult = ReturnType<typeof useUploadClinicImageMutation>;
export type UploadClinicImageMutationResult = Apollo.MutationResult<UploadClinicImageMutation>;
export type UploadClinicImageMutationOptions = Apollo.BaseMutationOptions<UploadClinicImageMutation, UploadClinicImageMutationVariables>;
export const RemoveClinicImageDocument = gql`
    mutation RemoveClinicImage($input: RemoveClinicImageInput!) {
  removeClinicImage(input: $input) {
    ...ClinicFields
  }
}
    ${ClinicFieldsFragmentDoc}`;
export type RemoveClinicImageMutationFn = Apollo.MutationFunction<RemoveClinicImageMutation, RemoveClinicImageMutationVariables>;

/**
 * __useRemoveClinicImageMutation__
 *
 * To run a mutation, you first call `useRemoveClinicImageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveClinicImageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeClinicImageMutation, { data, loading, error }] = useRemoveClinicImageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveClinicImageMutation(baseOptions?: Apollo.MutationHookOptions<RemoveClinicImageMutation, RemoveClinicImageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveClinicImageMutation, RemoveClinicImageMutationVariables>(RemoveClinicImageDocument, options);
      }
export type RemoveClinicImageMutationHookResult = ReturnType<typeof useRemoveClinicImageMutation>;
export type RemoveClinicImageMutationResult = Apollo.MutationResult<RemoveClinicImageMutation>;
export type RemoveClinicImageMutationOptions = Apollo.BaseMutationOptions<RemoveClinicImageMutation, RemoveClinicImageMutationVariables>;
export const CreateClinicContactDocument = gql`
    mutation CreateClinicContact($input: CreateClinicContactInput!) {
  createClinicContact(input: $input) {
    ...ClinicContactFields
  }
}
    ${ClinicContactFieldsFragmentDoc}`;
export type CreateClinicContactMutationFn = Apollo.MutationFunction<CreateClinicContactMutation, CreateClinicContactMutationVariables>;

/**
 * __useCreateClinicContactMutation__
 *
 * To run a mutation, you first call `useCreateClinicContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateClinicContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createClinicContactMutation, { data, loading, error }] = useCreateClinicContactMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateClinicContactMutation(baseOptions?: Apollo.MutationHookOptions<CreateClinicContactMutation, CreateClinicContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateClinicContactMutation, CreateClinicContactMutationVariables>(CreateClinicContactDocument, options);
      }
export type CreateClinicContactMutationHookResult = ReturnType<typeof useCreateClinicContactMutation>;
export type CreateClinicContactMutationResult = Apollo.MutationResult<CreateClinicContactMutation>;
export type CreateClinicContactMutationOptions = Apollo.BaseMutationOptions<CreateClinicContactMutation, CreateClinicContactMutationVariables>;
export const EditClinicContactDocument = gql`
    mutation EditClinicContact($input: EditClinicContactInput!) {
  editClinicContact(input: $input) {
    ...ClinicContactFields
  }
}
    ${ClinicContactFieldsFragmentDoc}`;
export type EditClinicContactMutationFn = Apollo.MutationFunction<EditClinicContactMutation, EditClinicContactMutationVariables>;

/**
 * __useEditClinicContactMutation__
 *
 * To run a mutation, you first call `useEditClinicContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditClinicContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editClinicContactMutation, { data, loading, error }] = useEditClinicContactMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditClinicContactMutation(baseOptions?: Apollo.MutationHookOptions<EditClinicContactMutation, EditClinicContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditClinicContactMutation, EditClinicContactMutationVariables>(EditClinicContactDocument, options);
      }
export type EditClinicContactMutationHookResult = ReturnType<typeof useEditClinicContactMutation>;
export type EditClinicContactMutationResult = Apollo.MutationResult<EditClinicContactMutation>;
export type EditClinicContactMutationOptions = Apollo.BaseMutationOptions<EditClinicContactMutation, EditClinicContactMutationVariables>;
export const DeleteClinicContactDocument = gql`
    mutation DeleteClinicContact($input: DeleteClinicContactInput!) {
  deleteClinicContact(input: $input) {
    ...ClinicContactFields
  }
}
    ${ClinicContactFieldsFragmentDoc}`;
export type DeleteClinicContactMutationFn = Apollo.MutationFunction<DeleteClinicContactMutation, DeleteClinicContactMutationVariables>;

/**
 * __useDeleteClinicContactMutation__
 *
 * To run a mutation, you first call `useDeleteClinicContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteClinicContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteClinicContactMutation, { data, loading, error }] = useDeleteClinicContactMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteClinicContactMutation(baseOptions?: Apollo.MutationHookOptions<DeleteClinicContactMutation, DeleteClinicContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteClinicContactMutation, DeleteClinicContactMutationVariables>(DeleteClinicContactDocument, options);
      }
export type DeleteClinicContactMutationHookResult = ReturnType<typeof useDeleteClinicContactMutation>;
export type DeleteClinicContactMutationResult = Apollo.MutationResult<DeleteClinicContactMutation>;
export type DeleteClinicContactMutationOptions = Apollo.BaseMutationOptions<DeleteClinicContactMutation, DeleteClinicContactMutationVariables>;
export const SetPrimaryContactDocument = gql`
    mutation SetPrimaryContact($contactId: String!) {
  setPrimaryContact(contactId: $contactId)
}
    `;
export type SetPrimaryContactMutationFn = Apollo.MutationFunction<SetPrimaryContactMutation, SetPrimaryContactMutationVariables>;

/**
 * __useSetPrimaryContactMutation__
 *
 * To run a mutation, you first call `useSetPrimaryContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetPrimaryContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setPrimaryContactMutation, { data, loading, error }] = useSetPrimaryContactMutation({
 *   variables: {
 *      contactId: // value for 'contactId'
 *   },
 * });
 */
export function useSetPrimaryContactMutation(baseOptions?: Apollo.MutationHookOptions<SetPrimaryContactMutation, SetPrimaryContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetPrimaryContactMutation, SetPrimaryContactMutationVariables>(SetPrimaryContactDocument, options);
      }
export type SetPrimaryContactMutationHookResult = ReturnType<typeof useSetPrimaryContactMutation>;
export type SetPrimaryContactMutationResult = Apollo.MutationResult<SetPrimaryContactMutation>;
export type SetPrimaryContactMutationOptions = Apollo.BaseMutationOptions<SetPrimaryContactMutation, SetPrimaryContactMutationVariables>;
export const AuthenticateClinicDrChronoIntegrationDocument = gql`
    mutation AuthenticateClinicDrChronoIntegration($input: AuthenticateClinicDrChronoIntegrationInput!) {
  authenticateClinicDrChronoIntegration(input: $input) {
    id
    integrations {
      drChrono {
        isActive
      }
    }
  }
}
    `;
export type AuthenticateClinicDrChronoIntegrationMutationFn = Apollo.MutationFunction<AuthenticateClinicDrChronoIntegrationMutation, AuthenticateClinicDrChronoIntegrationMutationVariables>;

/**
 * __useAuthenticateClinicDrChronoIntegrationMutation__
 *
 * To run a mutation, you first call `useAuthenticateClinicDrChronoIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthenticateClinicDrChronoIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authenticateClinicDrChronoIntegrationMutation, { data, loading, error }] = useAuthenticateClinicDrChronoIntegrationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAuthenticateClinicDrChronoIntegrationMutation(baseOptions?: Apollo.MutationHookOptions<AuthenticateClinicDrChronoIntegrationMutation, AuthenticateClinicDrChronoIntegrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AuthenticateClinicDrChronoIntegrationMutation, AuthenticateClinicDrChronoIntegrationMutationVariables>(AuthenticateClinicDrChronoIntegrationDocument, options);
      }
export type AuthenticateClinicDrChronoIntegrationMutationHookResult = ReturnType<typeof useAuthenticateClinicDrChronoIntegrationMutation>;
export type AuthenticateClinicDrChronoIntegrationMutationResult = Apollo.MutationResult<AuthenticateClinicDrChronoIntegrationMutation>;
export type AuthenticateClinicDrChronoIntegrationMutationOptions = Apollo.BaseMutationOptions<AuthenticateClinicDrChronoIntegrationMutation, AuthenticateClinicDrChronoIntegrationMutationVariables>;
export const ConfigureClinicDrChronoIntegrationDocument = gql`
    mutation ConfigureClinicDrChronoIntegration($input: ConfigureClinicDrChronoIntegrationInput!, $clinicId: String!) {
  configureClinicDrChronoIntegration(input: $input) {
    id
    integrations {
      drChrono {
        config(clinicId: $clinicId) {
          clientId
          clientSecret
        }
        isActive
      }
    }
  }
}
    `;
export type ConfigureClinicDrChronoIntegrationMutationFn = Apollo.MutationFunction<ConfigureClinicDrChronoIntegrationMutation, ConfigureClinicDrChronoIntegrationMutationVariables>;

/**
 * __useConfigureClinicDrChronoIntegrationMutation__
 *
 * To run a mutation, you first call `useConfigureClinicDrChronoIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfigureClinicDrChronoIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [configureClinicDrChronoIntegrationMutation, { data, loading, error }] = useConfigureClinicDrChronoIntegrationMutation({
 *   variables: {
 *      input: // value for 'input'
 *      clinicId: // value for 'clinicId'
 *   },
 * });
 */
export function useConfigureClinicDrChronoIntegrationMutation(baseOptions?: Apollo.MutationHookOptions<ConfigureClinicDrChronoIntegrationMutation, ConfigureClinicDrChronoIntegrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConfigureClinicDrChronoIntegrationMutation, ConfigureClinicDrChronoIntegrationMutationVariables>(ConfigureClinicDrChronoIntegrationDocument, options);
      }
export type ConfigureClinicDrChronoIntegrationMutationHookResult = ReturnType<typeof useConfigureClinicDrChronoIntegrationMutation>;
export type ConfigureClinicDrChronoIntegrationMutationResult = Apollo.MutationResult<ConfigureClinicDrChronoIntegrationMutation>;
export type ConfigureClinicDrChronoIntegrationMutationOptions = Apollo.BaseMutationOptions<ConfigureClinicDrChronoIntegrationMutation, ConfigureClinicDrChronoIntegrationMutationVariables>;
export const CustomizeClinicDrChronoIntegrationDocument = gql`
    mutation CustomizeClinicDrChronoIntegration($input: CustomizeClinicDrChronoIntegrationInput!) {
  customizeClinicDrChronoIntegration(input: $input) {
    id
    integrations {
      drChrono {
        customization {
          primaryButtonBgColor
        }
      }
    }
  }
}
    `;
export type CustomizeClinicDrChronoIntegrationMutationFn = Apollo.MutationFunction<CustomizeClinicDrChronoIntegrationMutation, CustomizeClinicDrChronoIntegrationMutationVariables>;

/**
 * __useCustomizeClinicDrChronoIntegrationMutation__
 *
 * To run a mutation, you first call `useCustomizeClinicDrChronoIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomizeClinicDrChronoIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customizeClinicDrChronoIntegrationMutation, { data, loading, error }] = useCustomizeClinicDrChronoIntegrationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCustomizeClinicDrChronoIntegrationMutation(baseOptions?: Apollo.MutationHookOptions<CustomizeClinicDrChronoIntegrationMutation, CustomizeClinicDrChronoIntegrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CustomizeClinicDrChronoIntegrationMutation, CustomizeClinicDrChronoIntegrationMutationVariables>(CustomizeClinicDrChronoIntegrationDocument, options);
      }
export type CustomizeClinicDrChronoIntegrationMutationHookResult = ReturnType<typeof useCustomizeClinicDrChronoIntegrationMutation>;
export type CustomizeClinicDrChronoIntegrationMutationResult = Apollo.MutationResult<CustomizeClinicDrChronoIntegrationMutation>;
export type CustomizeClinicDrChronoIntegrationMutationOptions = Apollo.BaseMutationOptions<CustomizeClinicDrChronoIntegrationMutation, CustomizeClinicDrChronoIntegrationMutationVariables>;
export const DisableClinicDrChronoIntegrationDocument = gql`
    mutation DisableClinicDrChronoIntegration($input: DisableClinicDrChronoIntegrationInput!, $clinicId: String!) {
  disableClinicDrChronoIntegration(input: $input) {
    id
    integrations {
      drChrono {
        config(clinicId: $clinicId) {
          clientId
          clientSecret
        }
        isActive
      }
    }
  }
}
    `;
export type DisableClinicDrChronoIntegrationMutationFn = Apollo.MutationFunction<DisableClinicDrChronoIntegrationMutation, DisableClinicDrChronoIntegrationMutationVariables>;

/**
 * __useDisableClinicDrChronoIntegrationMutation__
 *
 * To run a mutation, you first call `useDisableClinicDrChronoIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisableClinicDrChronoIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disableClinicDrChronoIntegrationMutation, { data, loading, error }] = useDisableClinicDrChronoIntegrationMutation({
 *   variables: {
 *      input: // value for 'input'
 *      clinicId: // value for 'clinicId'
 *   },
 * });
 */
export function useDisableClinicDrChronoIntegrationMutation(baseOptions?: Apollo.MutationHookOptions<DisableClinicDrChronoIntegrationMutation, DisableClinicDrChronoIntegrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DisableClinicDrChronoIntegrationMutation, DisableClinicDrChronoIntegrationMutationVariables>(DisableClinicDrChronoIntegrationDocument, options);
      }
export type DisableClinicDrChronoIntegrationMutationHookResult = ReturnType<typeof useDisableClinicDrChronoIntegrationMutation>;
export type DisableClinicDrChronoIntegrationMutationResult = Apollo.MutationResult<DisableClinicDrChronoIntegrationMutation>;
export type DisableClinicDrChronoIntegrationMutationOptions = Apollo.BaseMutationOptions<DisableClinicDrChronoIntegrationMutation, DisableClinicDrChronoIntegrationMutationVariables>;
export const CreateJobDocument = gql`
    mutation CreateJob($input: CreateJobInput!) {
  createJob(input: $input) {
    ...JobFields
  }
}
    ${JobFieldsFragmentDoc}`;
export type CreateJobMutationFn = Apollo.MutationFunction<CreateJobMutation, CreateJobMutationVariables>;

/**
 * __useCreateJobMutation__
 *
 * To run a mutation, you first call `useCreateJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createJobMutation, { data, loading, error }] = useCreateJobMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateJobMutation(baseOptions?: Apollo.MutationHookOptions<CreateJobMutation, CreateJobMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateJobMutation, CreateJobMutationVariables>(CreateJobDocument, options);
      }
export type CreateJobMutationHookResult = ReturnType<typeof useCreateJobMutation>;
export type CreateJobMutationResult = Apollo.MutationResult<CreateJobMutation>;
export type CreateJobMutationOptions = Apollo.BaseMutationOptions<CreateJobMutation, CreateJobMutationVariables>;
export const DeleteJobDocument = gql`
    mutation DeleteJob($input: DeleteJobInput!) {
  deleteJob(input: $input) {
    ...JobFields
  }
}
    ${JobFieldsFragmentDoc}`;
export type DeleteJobMutationFn = Apollo.MutationFunction<DeleteJobMutation, DeleteJobMutationVariables>;

/**
 * __useDeleteJobMutation__
 *
 * To run a mutation, you first call `useDeleteJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteJobMutation, { data, loading, error }] = useDeleteJobMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteJobMutation(baseOptions?: Apollo.MutationHookOptions<DeleteJobMutation, DeleteJobMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteJobMutation, DeleteJobMutationVariables>(DeleteJobDocument, options);
      }
export type DeleteJobMutationHookResult = ReturnType<typeof useDeleteJobMutation>;
export type DeleteJobMutationResult = Apollo.MutationResult<DeleteJobMutation>;
export type DeleteJobMutationOptions = Apollo.BaseMutationOptions<DeleteJobMutation, DeleteJobMutationVariables>;
export const EditJobDocument = gql`
    mutation EditJob($input: EditJobInput!) {
  editJob(input: $input) {
    ...JobFields
  }
}
    ${JobFieldsFragmentDoc}`;
export type EditJobMutationFn = Apollo.MutationFunction<EditJobMutation, EditJobMutationVariables>;

/**
 * __useEditJobMutation__
 *
 * To run a mutation, you first call `useEditJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editJobMutation, { data, loading, error }] = useEditJobMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditJobMutation(baseOptions?: Apollo.MutationHookOptions<EditJobMutation, EditJobMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditJobMutation, EditJobMutationVariables>(EditJobDocument, options);
      }
export type EditJobMutationHookResult = ReturnType<typeof useEditJobMutation>;
export type EditJobMutationResult = Apollo.MutationResult<EditJobMutation>;
export type EditJobMutationOptions = Apollo.BaseMutationOptions<EditJobMutation, EditJobMutationVariables>;
export const ApplyToJobDocument = gql`
    mutation ApplyToJob($input: ApplyToJobInput!) {
  applyToJob(input: $input) {
    id
    jobId
  }
}
    `;
export type ApplyToJobMutationFn = Apollo.MutationFunction<ApplyToJobMutation, ApplyToJobMutationVariables>;

/**
 * __useApplyToJobMutation__
 *
 * To run a mutation, you first call `useApplyToJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApplyToJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [applyToJobMutation, { data, loading, error }] = useApplyToJobMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useApplyToJobMutation(baseOptions?: Apollo.MutationHookOptions<ApplyToJobMutation, ApplyToJobMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApplyToJobMutation, ApplyToJobMutationVariables>(ApplyToJobDocument, options);
      }
export type ApplyToJobMutationHookResult = ReturnType<typeof useApplyToJobMutation>;
export type ApplyToJobMutationResult = Apollo.MutationResult<ApplyToJobMutation>;
export type ApplyToJobMutationOptions = Apollo.BaseMutationOptions<ApplyToJobMutation, ApplyToJobMutationVariables>;
export const CreateJobApplicationRulingDecisionEventDocument = gql`
    mutation CreateJobApplicationRulingDecisionEvent($input: CreateJobApplicationRulingDecisionEventInput!) {
  createJobApplicationRulingDecisionEvent(input: $input) {
    id
    latestRuling {
      id
      decision
      decisionReset
    }
    rulingEvents {
      createdAt
      decision
      decisionReset
      id
      createdById
      createdBy {
        email
        id
        profile {
          displayName @client
          firstName
          lastName
          userId
        }
      }
    }
  }
}
    `;
export type CreateJobApplicationRulingDecisionEventMutationFn = Apollo.MutationFunction<CreateJobApplicationRulingDecisionEventMutation, CreateJobApplicationRulingDecisionEventMutationVariables>;

/**
 * __useCreateJobApplicationRulingDecisionEventMutation__
 *
 * To run a mutation, you first call `useCreateJobApplicationRulingDecisionEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateJobApplicationRulingDecisionEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createJobApplicationRulingDecisionEventMutation, { data, loading, error }] = useCreateJobApplicationRulingDecisionEventMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateJobApplicationRulingDecisionEventMutation(baseOptions?: Apollo.MutationHookOptions<CreateJobApplicationRulingDecisionEventMutation, CreateJobApplicationRulingDecisionEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateJobApplicationRulingDecisionEventMutation, CreateJobApplicationRulingDecisionEventMutationVariables>(CreateJobApplicationRulingDecisionEventDocument, options);
      }
export type CreateJobApplicationRulingDecisionEventMutationHookResult = ReturnType<typeof useCreateJobApplicationRulingDecisionEventMutation>;
export type CreateJobApplicationRulingDecisionEventMutationResult = Apollo.MutationResult<CreateJobApplicationRulingDecisionEventMutation>;
export type CreateJobApplicationRulingDecisionEventMutationOptions = Apollo.BaseMutationOptions<CreateJobApplicationRulingDecisionEventMutation, CreateJobApplicationRulingDecisionEventMutationVariables>;
export const CreateJobApplicationRulingDecisionResetEventDocument = gql`
    mutation CreateJobApplicationRulingDecisionResetEvent($input: CreateJobApplicationRulingDecisionResetEventInput!) {
  createJobApplicationRulingDecisionResetEvent(input: $input) {
    id
    latestRuling {
      id
      decision
      decisionReset
    }
    rulingEvents {
      createdAt
      decision
      decisionReset
      id
      createdById
      createdBy {
        email
        id
        profile {
          displayName @client
          firstName
          lastName
          userId
        }
      }
    }
  }
}
    `;
export type CreateJobApplicationRulingDecisionResetEventMutationFn = Apollo.MutationFunction<CreateJobApplicationRulingDecisionResetEventMutation, CreateJobApplicationRulingDecisionResetEventMutationVariables>;

/**
 * __useCreateJobApplicationRulingDecisionResetEventMutation__
 *
 * To run a mutation, you first call `useCreateJobApplicationRulingDecisionResetEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateJobApplicationRulingDecisionResetEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createJobApplicationRulingDecisionResetEventMutation, { data, loading, error }] = useCreateJobApplicationRulingDecisionResetEventMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateJobApplicationRulingDecisionResetEventMutation(baseOptions?: Apollo.MutationHookOptions<CreateJobApplicationRulingDecisionResetEventMutation, CreateJobApplicationRulingDecisionResetEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateJobApplicationRulingDecisionResetEventMutation, CreateJobApplicationRulingDecisionResetEventMutationVariables>(CreateJobApplicationRulingDecisionResetEventDocument, options);
      }
export type CreateJobApplicationRulingDecisionResetEventMutationHookResult = ReturnType<typeof useCreateJobApplicationRulingDecisionResetEventMutation>;
export type CreateJobApplicationRulingDecisionResetEventMutationResult = Apollo.MutationResult<CreateJobApplicationRulingDecisionResetEventMutation>;
export type CreateJobApplicationRulingDecisionResetEventMutationOptions = Apollo.BaseMutationOptions<CreateJobApplicationRulingDecisionResetEventMutation, CreateJobApplicationRulingDecisionResetEventMutationVariables>;
export const CreateJobSuggestionDocument = gql`
    mutation CreateJobSuggestion($input: CreateJobSuggestionInput!) {
  createJobSuggestion(input: $input) {
    ...JobSuggestionFields
  }
}
    ${JobSuggestionFieldsFragmentDoc}`;
export type CreateJobSuggestionMutationFn = Apollo.MutationFunction<CreateJobSuggestionMutation, CreateJobSuggestionMutationVariables>;

/**
 * __useCreateJobSuggestionMutation__
 *
 * To run a mutation, you first call `useCreateJobSuggestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateJobSuggestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createJobSuggestionMutation, { data, loading, error }] = useCreateJobSuggestionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateJobSuggestionMutation(baseOptions?: Apollo.MutationHookOptions<CreateJobSuggestionMutation, CreateJobSuggestionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateJobSuggestionMutation, CreateJobSuggestionMutationVariables>(CreateJobSuggestionDocument, options);
      }
export type CreateJobSuggestionMutationHookResult = ReturnType<typeof useCreateJobSuggestionMutation>;
export type CreateJobSuggestionMutationResult = Apollo.MutationResult<CreateJobSuggestionMutation>;
export type CreateJobSuggestionMutationOptions = Apollo.BaseMutationOptions<CreateJobSuggestionMutation, CreateJobSuggestionMutationVariables>;
export const CreateSharingTokenDocument = gql`
    mutation CreateSharingToken($input: CreateSharingTokenInput!) {
  createSharingToken(input: $input) {
    ...SharingTokenFields
  }
}
    ${SharingTokenFieldsFragmentDoc}`;
export type CreateSharingTokenMutationFn = Apollo.MutationFunction<CreateSharingTokenMutation, CreateSharingTokenMutationVariables>;

/**
 * __useCreateSharingTokenMutation__
 *
 * To run a mutation, you first call `useCreateSharingTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSharingTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSharingTokenMutation, { data, loading, error }] = useCreateSharingTokenMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSharingTokenMutation(baseOptions?: Apollo.MutationHookOptions<CreateSharingTokenMutation, CreateSharingTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSharingTokenMutation, CreateSharingTokenMutationVariables>(CreateSharingTokenDocument, options);
      }
export type CreateSharingTokenMutationHookResult = ReturnType<typeof useCreateSharingTokenMutation>;
export type CreateSharingTokenMutationResult = Apollo.MutationResult<CreateSharingTokenMutation>;
export type CreateSharingTokenMutationOptions = Apollo.BaseMutationOptions<CreateSharingTokenMutation, CreateSharingTokenMutationVariables>;
export const DeleteSharingTokenDocument = gql`
    mutation DeleteSharingToken($input: DeleteSharingTokenInput!) {
  deleteSharingToken(input: $input)
}
    `;
export type DeleteSharingTokenMutationFn = Apollo.MutationFunction<DeleteSharingTokenMutation, DeleteSharingTokenMutationVariables>;

/**
 * __useDeleteSharingTokenMutation__
 *
 * To run a mutation, you first call `useDeleteSharingTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSharingTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSharingTokenMutation, { data, loading, error }] = useDeleteSharingTokenMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteSharingTokenMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSharingTokenMutation, DeleteSharingTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSharingTokenMutation, DeleteSharingTokenMutationVariables>(DeleteSharingTokenDocument, options);
      }
export type DeleteSharingTokenMutationHookResult = ReturnType<typeof useDeleteSharingTokenMutation>;
export type DeleteSharingTokenMutationResult = Apollo.MutationResult<DeleteSharingTokenMutation>;
export type DeleteSharingTokenMutationOptions = Apollo.BaseMutationOptions<DeleteSharingTokenMutation, DeleteSharingTokenMutationVariables>;
export const EditUserProfileDocument = gql`
    mutation EditUserProfile($input: EditUserProfileInput!) {
  editUserProfile(input: $input) {
    ...UserFields
    profile {
      ...UserProfileFields
    }
    tasks
  }
}
    ${UserFieldsFragmentDoc}
${UserProfileFieldsFragmentDoc}`;
export type EditUserProfileMutationFn = Apollo.MutationFunction<EditUserProfileMutation, EditUserProfileMutationVariables>;

/**
 * __useEditUserProfileMutation__
 *
 * To run a mutation, you first call `useEditUserProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditUserProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editUserProfileMutation, { data, loading, error }] = useEditUserProfileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditUserProfileMutation(baseOptions?: Apollo.MutationHookOptions<EditUserProfileMutation, EditUserProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditUserProfileMutation, EditUserProfileMutationVariables>(EditUserProfileDocument, options);
      }
export type EditUserProfileMutationHookResult = ReturnType<typeof useEditUserProfileMutation>;
export type EditUserProfileMutationResult = Apollo.MutationResult<EditUserProfileMutation>;
export type EditUserProfileMutationOptions = Apollo.BaseMutationOptions<EditUserProfileMutation, EditUserProfileMutationVariables>;
export const SetJoinedPlatformInterestDocument = gql`
    mutation SetJoinedPlatformInterest($input: SetJoinedPlatformInterestInput!) {
  setJoinedPlatformInterest(input: $input) {
    id
    profile {
      joinedPlatformInterestDocument {
        joinedPlatformInterest
        joinedPlatformInterestOther
      }
      userId
    }
  }
}
    `;
export type SetJoinedPlatformInterestMutationFn = Apollo.MutationFunction<SetJoinedPlatformInterestMutation, SetJoinedPlatformInterestMutationVariables>;

/**
 * __useSetJoinedPlatformInterestMutation__
 *
 * To run a mutation, you first call `useSetJoinedPlatformInterestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetJoinedPlatformInterestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setJoinedPlatformInterestMutation, { data, loading, error }] = useSetJoinedPlatformInterestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetJoinedPlatformInterestMutation(baseOptions?: Apollo.MutationHookOptions<SetJoinedPlatformInterestMutation, SetJoinedPlatformInterestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetJoinedPlatformInterestMutation, SetJoinedPlatformInterestMutationVariables>(SetJoinedPlatformInterestDocument, options);
      }
export type SetJoinedPlatformInterestMutationHookResult = ReturnType<typeof useSetJoinedPlatformInterestMutation>;
export type SetJoinedPlatformInterestMutationResult = Apollo.MutationResult<SetJoinedPlatformInterestMutation>;
export type SetJoinedPlatformInterestMutationOptions = Apollo.BaseMutationOptions<SetJoinedPlatformInterestMutation, SetJoinedPlatformInterestMutationVariables>;
export const UploadCvDocument = gql`
    mutation UploadCV($input: UploadCVInput!) {
  uploadCV(input: $input) {
    ...UserFields
    profile {
      ...UserProfileFields
    }
    tasks
  }
}
    ${UserFieldsFragmentDoc}
${UserProfileFieldsFragmentDoc}`;
export type UploadCvMutationFn = Apollo.MutationFunction<UploadCvMutation, UploadCvMutationVariables>;

/**
 * __useUploadCvMutation__
 *
 * To run a mutation, you first call `useUploadCvMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadCvMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadCvMutation, { data, loading, error }] = useUploadCvMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUploadCvMutation(baseOptions?: Apollo.MutationHookOptions<UploadCvMutation, UploadCvMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadCvMutation, UploadCvMutationVariables>(UploadCvDocument, options);
      }
export type UploadCvMutationHookResult = ReturnType<typeof useUploadCvMutation>;
export type UploadCvMutationResult = Apollo.MutationResult<UploadCvMutation>;
export type UploadCvMutationOptions = Apollo.BaseMutationOptions<UploadCvMutation, UploadCvMutationVariables>;
export const RemoveCvDocument = gql`
    mutation RemoveCV {
  removeCV {
    ...UserFields
    profile {
      ...UserProfileFields
    }
    tasks
  }
}
    ${UserFieldsFragmentDoc}
${UserProfileFieldsFragmentDoc}`;
export type RemoveCvMutationFn = Apollo.MutationFunction<RemoveCvMutation, RemoveCvMutationVariables>;

/**
 * __useRemoveCvMutation__
 *
 * To run a mutation, you first call `useRemoveCvMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveCvMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeCvMutation, { data, loading, error }] = useRemoveCvMutation({
 *   variables: {
 *   },
 * });
 */
export function useRemoveCvMutation(baseOptions?: Apollo.MutationHookOptions<RemoveCvMutation, RemoveCvMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveCvMutation, RemoveCvMutationVariables>(RemoveCvDocument, options);
      }
export type RemoveCvMutationHookResult = ReturnType<typeof useRemoveCvMutation>;
export type RemoveCvMutationResult = Apollo.MutationResult<RemoveCvMutation>;
export type RemoveCvMutationOptions = Apollo.BaseMutationOptions<RemoveCvMutation, RemoveCvMutationVariables>;
export const UploadUserProfileImageDocument = gql`
    mutation UploadUserProfileImage($input: UploadUserProfileImageInput!) {
  uploadUserProfileImage(input: $input) {
    ...UserFields
    profile {
      ...UserProfileFields
    }
    tasks
  }
}
    ${UserFieldsFragmentDoc}
${UserProfileFieldsFragmentDoc}`;
export type UploadUserProfileImageMutationFn = Apollo.MutationFunction<UploadUserProfileImageMutation, UploadUserProfileImageMutationVariables>;

/**
 * __useUploadUserProfileImageMutation__
 *
 * To run a mutation, you first call `useUploadUserProfileImageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadUserProfileImageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadUserProfileImageMutation, { data, loading, error }] = useUploadUserProfileImageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUploadUserProfileImageMutation(baseOptions?: Apollo.MutationHookOptions<UploadUserProfileImageMutation, UploadUserProfileImageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadUserProfileImageMutation, UploadUserProfileImageMutationVariables>(UploadUserProfileImageDocument, options);
      }
export type UploadUserProfileImageMutationHookResult = ReturnType<typeof useUploadUserProfileImageMutation>;
export type UploadUserProfileImageMutationResult = Apollo.MutationResult<UploadUserProfileImageMutation>;
export type UploadUserProfileImageMutationOptions = Apollo.BaseMutationOptions<UploadUserProfileImageMutation, UploadUserProfileImageMutationVariables>;
export const RemoveUserProfileImageDocument = gql`
    mutation RemoveUserProfileImage {
  removeUserProfileImage {
    ...UserFields
    profile {
      ...UserProfileFields
    }
    tasks
  }
}
    ${UserFieldsFragmentDoc}
${UserProfileFieldsFragmentDoc}`;
export type RemoveUserProfileImageMutationFn = Apollo.MutationFunction<RemoveUserProfileImageMutation, RemoveUserProfileImageMutationVariables>;

/**
 * __useRemoveUserProfileImageMutation__
 *
 * To run a mutation, you first call `useRemoveUserProfileImageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveUserProfileImageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeUserProfileImageMutation, { data, loading, error }] = useRemoveUserProfileImageMutation({
 *   variables: {
 *   },
 * });
 */
export function useRemoveUserProfileImageMutation(baseOptions?: Apollo.MutationHookOptions<RemoveUserProfileImageMutation, RemoveUserProfileImageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveUserProfileImageMutation, RemoveUserProfileImageMutationVariables>(RemoveUserProfileImageDocument, options);
      }
export type RemoveUserProfileImageMutationHookResult = ReturnType<typeof useRemoveUserProfileImageMutation>;
export type RemoveUserProfileImageMutationResult = Apollo.MutationResult<RemoveUserProfileImageMutation>;
export type RemoveUserProfileImageMutationOptions = Apollo.BaseMutationOptions<RemoveUserProfileImageMutation, RemoveUserProfileImageMutationVariables>;
export const RequestCvDownloadDocument = gql`
    mutation RequestCVDownload($input: RequestCVDownloadInput!) {
  requestCVDownload(input: $input)
}
    `;
export type RequestCvDownloadMutationFn = Apollo.MutationFunction<RequestCvDownloadMutation, RequestCvDownloadMutationVariables>;

/**
 * __useRequestCvDownloadMutation__
 *
 * To run a mutation, you first call `useRequestCvDownloadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestCvDownloadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestCvDownloadMutation, { data, loading, error }] = useRequestCvDownloadMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRequestCvDownloadMutation(baseOptions?: Apollo.MutationHookOptions<RequestCvDownloadMutation, RequestCvDownloadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestCvDownloadMutation, RequestCvDownloadMutationVariables>(RequestCvDownloadDocument, options);
      }
export type RequestCvDownloadMutationHookResult = ReturnType<typeof useRequestCvDownloadMutation>;
export type RequestCvDownloadMutationResult = Apollo.MutationResult<RequestCvDownloadMutation>;
export type RequestCvDownloadMutationOptions = Apollo.BaseMutationOptions<RequestCvDownloadMutation, RequestCvDownloadMutationVariables>;
export const ServerLogInDocument = gql`
    mutation ServerLogIn($input: LogInInput!) {
  logIn(input: $input) {
    token
    userId
  }
}
    `;
export type ServerLogInMutationFn = Apollo.MutationFunction<ServerLogInMutation, ServerLogInMutationVariables>;

/**
 * __useServerLogInMutation__
 *
 * To run a mutation, you first call `useServerLogInMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useServerLogInMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [serverLogInMutation, { data, loading, error }] = useServerLogInMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useServerLogInMutation(baseOptions?: Apollo.MutationHookOptions<ServerLogInMutation, ServerLogInMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ServerLogInMutation, ServerLogInMutationVariables>(ServerLogInDocument, options);
      }
export type ServerLogInMutationHookResult = ReturnType<typeof useServerLogInMutation>;
export type ServerLogInMutationResult = Apollo.MutationResult<ServerLogInMutation>;
export type ServerLogInMutationOptions = Apollo.BaseMutationOptions<ServerLogInMutation, ServerLogInMutationVariables>;
export const ServerSignUpDocument = gql`
    mutation ServerSignUp($input: SignUpInput!, $userProfileInput: EditUserProfileInput) {
  signUp(input: $input, userProfileInput: $userProfileInput) {
    token
    userId
  }
}
    `;
export type ServerSignUpMutationFn = Apollo.MutationFunction<ServerSignUpMutation, ServerSignUpMutationVariables>;

/**
 * __useServerSignUpMutation__
 *
 * To run a mutation, you first call `useServerSignUpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useServerSignUpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [serverSignUpMutation, { data, loading, error }] = useServerSignUpMutation({
 *   variables: {
 *      input: // value for 'input'
 *      userProfileInput: // value for 'userProfileInput'
 *   },
 * });
 */
export function useServerSignUpMutation(baseOptions?: Apollo.MutationHookOptions<ServerSignUpMutation, ServerSignUpMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ServerSignUpMutation, ServerSignUpMutationVariables>(ServerSignUpDocument, options);
      }
export type ServerSignUpMutationHookResult = ReturnType<typeof useServerSignUpMutation>;
export type ServerSignUpMutationResult = Apollo.MutationResult<ServerSignUpMutation>;
export type ServerSignUpMutationOptions = Apollo.BaseMutationOptions<ServerSignUpMutation, ServerSignUpMutationVariables>;
export const RequestPasswordResetDocument = gql`
    mutation RequestPasswordReset($input: RequestPasswordResetInput!) {
  requestPasswordReset(input: $input)
}
    `;
export type RequestPasswordResetMutationFn = Apollo.MutationFunction<RequestPasswordResetMutation, RequestPasswordResetMutationVariables>;

/**
 * __useRequestPasswordResetMutation__
 *
 * To run a mutation, you first call `useRequestPasswordResetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestPasswordResetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestPasswordResetMutation, { data, loading, error }] = useRequestPasswordResetMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRequestPasswordResetMutation(baseOptions?: Apollo.MutationHookOptions<RequestPasswordResetMutation, RequestPasswordResetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestPasswordResetMutation, RequestPasswordResetMutationVariables>(RequestPasswordResetDocument, options);
      }
export type RequestPasswordResetMutationHookResult = ReturnType<typeof useRequestPasswordResetMutation>;
export type RequestPasswordResetMutationResult = Apollo.MutationResult<RequestPasswordResetMutation>;
export type RequestPasswordResetMutationOptions = Apollo.BaseMutationOptions<RequestPasswordResetMutation, RequestPasswordResetMutationVariables>;
export const ResetPasswordDocument = gql`
    mutation ResetPassword($input: ResetPasswordInput!) {
  resetPassword(input: $input)
}
    `;
export type ResetPasswordMutationFn = Apollo.MutationFunction<ResetPasswordMutation, ResetPasswordMutationVariables>;

/**
 * __useResetPasswordMutation__
 *
 * To run a mutation, you first call `useResetPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetPasswordMutation, { data, loading, error }] = useResetPasswordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useResetPasswordMutation(baseOptions?: Apollo.MutationHookOptions<ResetPasswordMutation, ResetPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetPasswordMutation, ResetPasswordMutationVariables>(ResetPasswordDocument, options);
      }
export type ResetPasswordMutationHookResult = ReturnType<typeof useResetPasswordMutation>;
export type ResetPasswordMutationResult = Apollo.MutationResult<ResetPasswordMutation>;
export type ResetPasswordMutationOptions = Apollo.BaseMutationOptions<ResetPasswordMutation, ResetPasswordMutationVariables>;
export const SignUpAndApplyDocument = gql`
    mutation SignUpAndApply($signUpInput: SignUpInput!, $userProfileInput: EditUserProfileInput!, $cv: Upload!, $statesLicensedIn: [String!], $applyToJobInput: ApplyToJobInput!) {
  signUpAndApply(
    signUpInput: $signUpInput
    userProfileInput: $userProfileInput
    cv: $cv
    statesLicensedIn: $statesLicensedIn
    applyToJobInput: $applyToJobInput
  ) {
    user {
      token
      userId
    }
    jobApplication {
      id
    }
    userProfile {
      userId
      licenses {
        ...LicenseFields
      }
    }
  }
}
    ${LicenseFieldsFragmentDoc}`;
export type SignUpAndApplyMutationFn = Apollo.MutationFunction<SignUpAndApplyMutation, SignUpAndApplyMutationVariables>;

/**
 * __useSignUpAndApplyMutation__
 *
 * To run a mutation, you first call `useSignUpAndApplyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignUpAndApplyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signUpAndApplyMutation, { data, loading, error }] = useSignUpAndApplyMutation({
 *   variables: {
 *      signUpInput: // value for 'signUpInput'
 *      userProfileInput: // value for 'userProfileInput'
 *      cv: // value for 'cv'
 *      statesLicensedIn: // value for 'statesLicensedIn'
 *      applyToJobInput: // value for 'applyToJobInput'
 *   },
 * });
 */
export function useSignUpAndApplyMutation(baseOptions?: Apollo.MutationHookOptions<SignUpAndApplyMutation, SignUpAndApplyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SignUpAndApplyMutation, SignUpAndApplyMutationVariables>(SignUpAndApplyDocument, options);
      }
export type SignUpAndApplyMutationHookResult = ReturnType<typeof useSignUpAndApplyMutation>;
export type SignUpAndApplyMutationResult = Apollo.MutationResult<SignUpAndApplyMutation>;
export type SignUpAndApplyMutationOptions = Apollo.BaseMutationOptions<SignUpAndApplyMutation, SignUpAndApplyMutationVariables>;
export const SetNetworkStatusDocument = gql`
    mutation SetNetworkStatus($input: SetUserNetworkStatusInput!) {
  setUserNetworkStatus(input: $input) {
    ...UserFields
    profile {
      ...UserProfileFields
    }
  }
}
    ${UserFieldsFragmentDoc}
${UserProfileFieldsFragmentDoc}`;
export type SetNetworkStatusMutationFn = Apollo.MutationFunction<SetNetworkStatusMutation, SetNetworkStatusMutationVariables>;

/**
 * __useSetNetworkStatusMutation__
 *
 * To run a mutation, you first call `useSetNetworkStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetNetworkStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setNetworkStatusMutation, { data, loading, error }] = useSetNetworkStatusMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetNetworkStatusMutation(baseOptions?: Apollo.MutationHookOptions<SetNetworkStatusMutation, SetNetworkStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetNetworkStatusMutation, SetNetworkStatusMutationVariables>(SetNetworkStatusDocument, options);
      }
export type SetNetworkStatusMutationHookResult = ReturnType<typeof useSetNetworkStatusMutation>;
export type SetNetworkStatusMutationResult = Apollo.MutationResult<SetNetworkStatusMutation>;
export type SetNetworkStatusMutationOptions = Apollo.BaseMutationOptions<SetNetworkStatusMutation, SetNetworkStatusMutationVariables>;
export const NonAdminUserExistsDocument = gql`
    query NonAdminUserExists($email: String!) {
  nonAdminUserExists(email: $email)
}
    `;

/**
 * __useNonAdminUserExistsQuery__
 *
 * To run a query within a React component, call `useNonAdminUserExistsQuery` and pass it any options that fit your needs.
 * When your component renders, `useNonAdminUserExistsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNonAdminUserExistsQuery({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useNonAdminUserExistsQuery(baseOptions: Apollo.QueryHookOptions<NonAdminUserExistsQuery, NonAdminUserExistsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NonAdminUserExistsQuery, NonAdminUserExistsQueryVariables>(NonAdminUserExistsDocument, options);
      }
export function useNonAdminUserExistsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NonAdminUserExistsQuery, NonAdminUserExistsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NonAdminUserExistsQuery, NonAdminUserExistsQueryVariables>(NonAdminUserExistsDocument, options);
        }
export type NonAdminUserExistsQueryHookResult = ReturnType<typeof useNonAdminUserExistsQuery>;
export type NonAdminUserExistsLazyQueryHookResult = ReturnType<typeof useNonAdminUserExistsLazyQuery>;
export type NonAdminUserExistsQueryResult = Apollo.QueryResult<NonAdminUserExistsQuery, NonAdminUserExistsQueryVariables>;
export const AdminAdminUsersDocument = gql`
    query AdminAdminUsers {
  adminAdminUsers {
    id
    email
    profile {
      displayName @client
      firstName
      lastName
      userId
    }
  }
}
    `;

/**
 * __useAdminAdminUsersQuery__
 *
 * To run a query within a React component, call `useAdminAdminUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminAdminUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminAdminUsersQuery({
 *   variables: {
 *   },
 * });
 */
export function useAdminAdminUsersQuery(baseOptions?: Apollo.QueryHookOptions<AdminAdminUsersQuery, AdminAdminUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminAdminUsersQuery, AdminAdminUsersQueryVariables>(AdminAdminUsersDocument, options);
      }
export function useAdminAdminUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminAdminUsersQuery, AdminAdminUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminAdminUsersQuery, AdminAdminUsersQueryVariables>(AdminAdminUsersDocument, options);
        }
export type AdminAdminUsersQueryHookResult = ReturnType<typeof useAdminAdminUsersQuery>;
export type AdminAdminUsersLazyQueryHookResult = ReturnType<typeof useAdminAdminUsersLazyQuery>;
export type AdminAdminUsersQueryResult = Apollo.QueryResult<AdminAdminUsersQuery, AdminAdminUsersQueryVariables>;
export const AdminStatsDocument = gql`
    query AdminStats($rangeStart: DateTime!, $rangeEnd: DateTime!) {
  adminStats(rangeStart: $rangeStart, rangeEnd: $rangeEnd) {
    clinics {
      id
      createdAt
      name
    }
    jobs {
      id
      createdAt
      clinicId
      title
    }
    users {
      id
      createdAt
      profile {
        firstName
        lastName
        userId
      }
      role
    }
  }
}
    `;

/**
 * __useAdminStatsQuery__
 *
 * To run a query within a React component, call `useAdminStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminStatsQuery({
 *   variables: {
 *      rangeStart: // value for 'rangeStart'
 *      rangeEnd: // value for 'rangeEnd'
 *   },
 * });
 */
export function useAdminStatsQuery(baseOptions: Apollo.QueryHookOptions<AdminStatsQuery, AdminStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminStatsQuery, AdminStatsQueryVariables>(AdminStatsDocument, options);
      }
export function useAdminStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminStatsQuery, AdminStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminStatsQuery, AdminStatsQueryVariables>(AdminStatsDocument, options);
        }
export type AdminStatsQueryHookResult = ReturnType<typeof useAdminStatsQuery>;
export type AdminStatsLazyQueryHookResult = ReturnType<typeof useAdminStatsLazyQuery>;
export type AdminStatsQueryResult = Apollo.QueryResult<AdminStatsQuery, AdminStatsQueryVariables>;
export const AdminUserDocument = gql`
    query AdminUser($userId: String!) {
  adminUser(userId: $userId) {
    ...UserFields
    profile {
      ...UserProfileFields
      licenses {
        ...LicenseFields
      }
      missingFields
      utm
    }
    notes {
      ...UserNoteFields
    }
    clinicianAdvocate {
      id
      email
      profile {
        firstName
        lastName
        userId
      }
    }
    clinicianAdvocateId
    sharingTokens {
      ...SharingTokenFields
    }
    zohoRecruitUserId
    jobApplications {
      id
      jobId
      latestRuling {
        id
        decision
      }
      job {
        title
        clinicianType
        id
        specialties
        status
        clinicianAdvocate {
          profile {
            firstName
            lastName
            displayName @client
            userId
          }
        }
        clinic {
          id
          name
        }
      }
      sharableProfileToken {
        clientDescription
        createdAt
        createdById
        createdBy {
          id
          profile {
            firstName
            lastName
            displayName @client
            userId
          }
        }
        expiresAt
        token
      }
      utm
    }
    verifiedActiveLicenses {
      ...LicenseFields
    }
    jobSuggestions {
      clinicianAdvocateId
      createdAt
      id
      jobId
      job {
        id
        title
        clinic {
          id
          name
        }
      }
    }
  }
}
    ${UserFieldsFragmentDoc}
${UserProfileFieldsFragmentDoc}
${LicenseFieldsFragmentDoc}
${UserNoteFieldsFragmentDoc}
${SharingTokenFieldsFragmentDoc}`;

/**
 * __useAdminUserQuery__
 *
 * To run a query within a React component, call `useAdminUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminUserQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useAdminUserQuery(baseOptions: Apollo.QueryHookOptions<AdminUserQuery, AdminUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminUserQuery, AdminUserQueryVariables>(AdminUserDocument, options);
      }
export function useAdminUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminUserQuery, AdminUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminUserQuery, AdminUserQueryVariables>(AdminUserDocument, options);
        }
export type AdminUserQueryHookResult = ReturnType<typeof useAdminUserQuery>;
export type AdminUserLazyQueryHookResult = ReturnType<typeof useAdminUserLazyQuery>;
export type AdminUserQueryResult = Apollo.QueryResult<AdminUserQuery, AdminUserQueryVariables>;
export const CitiesDocument = gql`
    query Cities($stateId: String!) {
  cities(stateId: $stateId) {
    ...CityFields
  }
}
    ${CityFieldsFragmentDoc}`;

/**
 * __useCitiesQuery__
 *
 * To run a query within a React component, call `useCitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCitiesQuery({
 *   variables: {
 *      stateId: // value for 'stateId'
 *   },
 * });
 */
export function useCitiesQuery(baseOptions: Apollo.QueryHookOptions<CitiesQuery, CitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CitiesQuery, CitiesQueryVariables>(CitiesDocument, options);
      }
export function useCitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CitiesQuery, CitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CitiesQuery, CitiesQueryVariables>(CitiesDocument, options);
        }
export type CitiesQueryHookResult = ReturnType<typeof useCitiesQuery>;
export type CitiesLazyQueryHookResult = ReturnType<typeof useCitiesLazyQuery>;
export type CitiesQueryResult = Apollo.QueryResult<CitiesQuery, CitiesQueryVariables>;
export const ClinicDocument = gql`
    query Clinic($id: String!) {
  clinic(id: $id) {
    ...ClinicFields
    contacts {
      ...ClinicContactFields
    }
    jobs {
      applications {
        id
        latestRuling {
          id
          createdAt
          decision
        }
      }
      clinicianAdvocateId
      clinicianAdvocate {
        id
        email
        profile {
          displayName @client
          firstName
          lastName
          userId
        }
      }
      clinicContactId
      clinicContact {
        id
        email
        isDeleted
        name
        phone
      }
      clinicId
      clinicianType
      createdAt
      employmentType
      id
      isTelehealth
      salaryDetails
      specialties
      status
      suggestions {
        id
        createdAt
      }
      title
    }
  }
}
    ${ClinicFieldsFragmentDoc}
${ClinicContactFieldsFragmentDoc}`;

/**
 * __useClinicQuery__
 *
 * To run a query within a React component, call `useClinicQuery` and pass it any options that fit your needs.
 * When your component renders, `useClinicQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClinicQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useClinicQuery(baseOptions: Apollo.QueryHookOptions<ClinicQuery, ClinicQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClinicQuery, ClinicQueryVariables>(ClinicDocument, options);
      }
export function useClinicLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClinicQuery, ClinicQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClinicQuery, ClinicQueryVariables>(ClinicDocument, options);
        }
export type ClinicQueryHookResult = ReturnType<typeof useClinicQuery>;
export type ClinicLazyQueryHookResult = ReturnType<typeof useClinicLazyQuery>;
export type ClinicQueryResult = Apollo.QueryResult<ClinicQuery, ClinicQueryVariables>;
export const ClinicsDocument = gql`
    query Clinics {
  clinics {
    ...ClinicFields
  }
}
    ${ClinicFieldsFragmentDoc}`;

/**
 * __useClinicsQuery__
 *
 * To run a query within a React component, call `useClinicsQuery` and pass it any options that fit your needs.
 * When your component renders, `useClinicsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClinicsQuery({
 *   variables: {
 *   },
 * });
 */
export function useClinicsQuery(baseOptions?: Apollo.QueryHookOptions<ClinicsQuery, ClinicsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClinicsQuery, ClinicsQueryVariables>(ClinicsDocument, options);
      }
export function useClinicsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClinicsQuery, ClinicsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClinicsQuery, ClinicsQueryVariables>(ClinicsDocument, options);
        }
export type ClinicsQueryHookResult = ReturnType<typeof useClinicsQuery>;
export type ClinicsLazyQueryHookResult = ReturnType<typeof useClinicsLazyQuery>;
export type ClinicsQueryResult = Apollo.QueryResult<ClinicsQuery, ClinicsQueryVariables>;
export const ClinicIntegrationsDocument = gql`
    query ClinicIntegrations($clinicId: String!) {
  clinic(id: $clinicId) {
    id
    integrations {
      drChrono {
        config(clinicId: $clinicId) {
          clientId
          clientSecret
        }
        customization {
          primaryButtonBgColor
        }
        isActive
      }
    }
  }
}
    `;

/**
 * __useClinicIntegrationsQuery__
 *
 * To run a query within a React component, call `useClinicIntegrationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useClinicIntegrationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClinicIntegrationsQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *   },
 * });
 */
export function useClinicIntegrationsQuery(baseOptions: Apollo.QueryHookOptions<ClinicIntegrationsQuery, ClinicIntegrationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClinicIntegrationsQuery, ClinicIntegrationsQueryVariables>(ClinicIntegrationsDocument, options);
      }
export function useClinicIntegrationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClinicIntegrationsQuery, ClinicIntegrationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClinicIntegrationsQuery, ClinicIntegrationsQueryVariables>(ClinicIntegrationsDocument, options);
        }
export type ClinicIntegrationsQueryHookResult = ReturnType<typeof useClinicIntegrationsQuery>;
export type ClinicIntegrationsLazyQueryHookResult = ReturnType<typeof useClinicIntegrationsLazyQuery>;
export type ClinicIntegrationsQueryResult = Apollo.QueryResult<ClinicIntegrationsQuery, ClinicIntegrationsQueryVariables>;
export const ClinicIntegrationsDrChronoOfficesDocument = gql`
    query ClinicIntegrationsDrChronoOffices($clinicId: String!) {
  clinic(id: $clinicId) {
    id
    integrations {
      drChrono {
        offices(clinicId: $clinicId) {
          id
          name
        }
      }
    }
  }
}
    `;

/**
 * __useClinicIntegrationsDrChronoOfficesQuery__
 *
 * To run a query within a React component, call `useClinicIntegrationsDrChronoOfficesQuery` and pass it any options that fit your needs.
 * When your component renders, `useClinicIntegrationsDrChronoOfficesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClinicIntegrationsDrChronoOfficesQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *   },
 * });
 */
export function useClinicIntegrationsDrChronoOfficesQuery(baseOptions: Apollo.QueryHookOptions<ClinicIntegrationsDrChronoOfficesQuery, ClinicIntegrationsDrChronoOfficesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClinicIntegrationsDrChronoOfficesQuery, ClinicIntegrationsDrChronoOfficesQueryVariables>(ClinicIntegrationsDrChronoOfficesDocument, options);
      }
export function useClinicIntegrationsDrChronoOfficesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClinicIntegrationsDrChronoOfficesQuery, ClinicIntegrationsDrChronoOfficesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClinicIntegrationsDrChronoOfficesQuery, ClinicIntegrationsDrChronoOfficesQueryVariables>(ClinicIntegrationsDrChronoOfficesDocument, options);
        }
export type ClinicIntegrationsDrChronoOfficesQueryHookResult = ReturnType<typeof useClinicIntegrationsDrChronoOfficesQuery>;
export type ClinicIntegrationsDrChronoOfficesLazyQueryHookResult = ReturnType<typeof useClinicIntegrationsDrChronoOfficesLazyQuery>;
export type ClinicIntegrationsDrChronoOfficesQueryResult = Apollo.QueryResult<ClinicIntegrationsDrChronoOfficesQuery, ClinicIntegrationsDrChronoOfficesQueryVariables>;
export const ClinicAdminJobDocument = gql`
    query ClinicAdminJob($id: String!) {
  clinicAdminJob(id: $id) {
    ...JobFields
  }
}
    ${JobFieldsFragmentDoc}`;

/**
 * __useClinicAdminJobQuery__
 *
 * To run a query within a React component, call `useClinicAdminJobQuery` and pass it any options that fit your needs.
 * When your component renders, `useClinicAdminJobQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClinicAdminJobQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useClinicAdminJobQuery(baseOptions: Apollo.QueryHookOptions<ClinicAdminJobQuery, ClinicAdminJobQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClinicAdminJobQuery, ClinicAdminJobQueryVariables>(ClinicAdminJobDocument, options);
      }
export function useClinicAdminJobLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClinicAdminJobQuery, ClinicAdminJobQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClinicAdminJobQuery, ClinicAdminJobQueryVariables>(ClinicAdminJobDocument, options);
        }
export type ClinicAdminJobQueryHookResult = ReturnType<typeof useClinicAdminJobQuery>;
export type ClinicAdminJobLazyQueryHookResult = ReturnType<typeof useClinicAdminJobLazyQuery>;
export type ClinicAdminJobQueryResult = Apollo.QueryResult<ClinicAdminJobQuery, ClinicAdminJobQueryVariables>;
export const JobDocument = gql`
    query Job($id: String!) {
  job(id: $id) {
    aboutJob
    applicationDate
    applied
    clinicianType
    clinic {
      id
      name
    }
    clinicId
    createdAt
    description
    desiredCertifications
    desiredHours
    desiredTelehealthExperience
    employmentType
    emrProviders
    id
    interviewDetails
    isDeleted
    isTelehealth
    location
    minYearsExperience
    numberToFill
    numberToFillIsUnlimited
    onboardingDetails
    orientationDetails
    otherInfo
    payAndPerks
    preferredLicenseStateIds
    preferredLicenseStates {
      ...StateFields
    }
    requiredEquipment
    requiredLicenseStateIds
    requiredLicenseStates {
      ...StateFields
    }
    requirements
    responsibilities
    salaryDetails
    schedulingDetails
    shiftDetails
    specialties
    startAt
    state {
      ...StateFields
    }
    status
    title
    trainingLevel
    zohoUrl
  }
}
    ${StateFieldsFragmentDoc}`;

/**
 * __useJobQuery__
 *
 * To run a query within a React component, call `useJobQuery` and pass it any options that fit your needs.
 * When your component renders, `useJobQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJobQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useJobQuery(baseOptions: Apollo.QueryHookOptions<JobQuery, JobQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<JobQuery, JobQueryVariables>(JobDocument, options);
      }
export function useJobLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<JobQuery, JobQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<JobQuery, JobQueryVariables>(JobDocument, options);
        }
export type JobQueryHookResult = ReturnType<typeof useJobQuery>;
export type JobLazyQueryHookResult = ReturnType<typeof useJobLazyQuery>;
export type JobQueryResult = Apollo.QueryResult<JobQuery, JobQueryVariables>;
export const JobSuggestionsByUserIdDocument = gql`
    query JobSuggestionsByUserId($userId: String!) {
  jobSuggestionsByUserId(userId: $userId) {
    ...JobSuggestionFields
  }
}
    ${JobSuggestionFieldsFragmentDoc}`;

/**
 * __useJobSuggestionsByUserIdQuery__
 *
 * To run a query within a React component, call `useJobSuggestionsByUserIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useJobSuggestionsByUserIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJobSuggestionsByUserIdQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useJobSuggestionsByUserIdQuery(baseOptions: Apollo.QueryHookOptions<JobSuggestionsByUserIdQuery, JobSuggestionsByUserIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<JobSuggestionsByUserIdQuery, JobSuggestionsByUserIdQueryVariables>(JobSuggestionsByUserIdDocument, options);
      }
export function useJobSuggestionsByUserIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<JobSuggestionsByUserIdQuery, JobSuggestionsByUserIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<JobSuggestionsByUserIdQuery, JobSuggestionsByUserIdQueryVariables>(JobSuggestionsByUserIdDocument, options);
        }
export type JobSuggestionsByUserIdQueryHookResult = ReturnType<typeof useJobSuggestionsByUserIdQuery>;
export type JobSuggestionsByUserIdLazyQueryHookResult = ReturnType<typeof useJobSuggestionsByUserIdLazyQuery>;
export type JobSuggestionsByUserIdQueryResult = Apollo.QueryResult<JobSuggestionsByUserIdQuery, JobSuggestionsByUserIdQueryVariables>;
export const JobSuggestionsByJobIdDocument = gql`
    query JobSuggestionsByJobId($jobId: String!) {
  jobSuggestionsByJobId(jobId: $jobId) {
    ...JobSuggestionFields
  }
}
    ${JobSuggestionFieldsFragmentDoc}`;

/**
 * __useJobSuggestionsByJobIdQuery__
 *
 * To run a query within a React component, call `useJobSuggestionsByJobIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useJobSuggestionsByJobIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJobSuggestionsByJobIdQuery({
 *   variables: {
 *      jobId: // value for 'jobId'
 *   },
 * });
 */
export function useJobSuggestionsByJobIdQuery(baseOptions: Apollo.QueryHookOptions<JobSuggestionsByJobIdQuery, JobSuggestionsByJobIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<JobSuggestionsByJobIdQuery, JobSuggestionsByJobIdQueryVariables>(JobSuggestionsByJobIdDocument, options);
      }
export function useJobSuggestionsByJobIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<JobSuggestionsByJobIdQuery, JobSuggestionsByJobIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<JobSuggestionsByJobIdQuery, JobSuggestionsByJobIdQueryVariables>(JobSuggestionsByJobIdDocument, options);
        }
export type JobSuggestionsByJobIdQueryHookResult = ReturnType<typeof useJobSuggestionsByJobIdQuery>;
export type JobSuggestionsByJobIdLazyQueryHookResult = ReturnType<typeof useJobSuggestionsByJobIdLazyQuery>;
export type JobSuggestionsByJobIdQueryResult = Apollo.QueryResult<JobSuggestionsByJobIdQuery, JobSuggestionsByJobIdQueryVariables>;
export const StatesDocument = gql`
    query States {
  states {
    id
    name
    shortName
  }
}
    `;

/**
 * __useStatesQuery__
 *
 * To run a query within a React component, call `useStatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useStatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStatesQuery({
 *   variables: {
 *   },
 * });
 */
export function useStatesQuery(baseOptions?: Apollo.QueryHookOptions<StatesQuery, StatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StatesQuery, StatesQueryVariables>(StatesDocument, options);
      }
export function useStatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StatesQuery, StatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StatesQuery, StatesQueryVariables>(StatesDocument, options);
        }
export type StatesQueryHookResult = ReturnType<typeof useStatesQuery>;
export type StatesLazyQueryHookResult = ReturnType<typeof useStatesLazyQuery>;
export type StatesQueryResult = Apollo.QueryResult<StatesQuery, StatesQueryVariables>;
export const CurrentUserDocument = gql`
    query CurrentUser {
  currentUser {
    ...UserFields
    profile {
      ...UserProfileFields
      joinedPlatformInterestDocument {
        joinedPlatformInterest
        joinedPlatformInterestOther
      }
    }
    jobApplications {
      id
      jobId
      latestRuling {
        id
        createdAt
        decision
        decisionReset
      }
      createdAt
      job {
        title
        status
      }
    }
    jobSuggestions {
      ...JobSuggestionFields
    }
  }
}
    ${UserFieldsFragmentDoc}
${UserProfileFieldsFragmentDoc}
${JobSuggestionFieldsFragmentDoc}`;

/**
 * __useCurrentUserQuery__
 *
 * To run a query within a React component, call `useCurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentUserQuery(baseOptions?: Apollo.QueryHookOptions<CurrentUserQuery, CurrentUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentUserQuery, CurrentUserQueryVariables>(CurrentUserDocument, options);
      }
export function useCurrentUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentUserQuery, CurrentUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentUserQuery, CurrentUserQueryVariables>(CurrentUserDocument, options);
        }
export type CurrentUserQueryHookResult = ReturnType<typeof useCurrentUserQuery>;
export type CurrentUserLazyQueryHookResult = ReturnType<typeof useCurrentUserLazyQuery>;
export type CurrentUserQueryResult = Apollo.QueryResult<CurrentUserQuery, CurrentUserQueryVariables>;
export const CurrentUserTasksDocument = gql`
    query CurrentUserTasks {
  currentUser {
    id
    tasks
  }
}
    `;

/**
 * __useCurrentUserTasksQuery__
 *
 * To run a query within a React component, call `useCurrentUserTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentUserTasksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentUserTasksQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentUserTasksQuery(baseOptions?: Apollo.QueryHookOptions<CurrentUserTasksQuery, CurrentUserTasksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentUserTasksQuery, CurrentUserTasksQueryVariables>(CurrentUserTasksDocument, options);
      }
export function useCurrentUserTasksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentUserTasksQuery, CurrentUserTasksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentUserTasksQuery, CurrentUserTasksQueryVariables>(CurrentUserTasksDocument, options);
        }
export type CurrentUserTasksQueryHookResult = ReturnType<typeof useCurrentUserTasksQuery>;
export type CurrentUserTasksLazyQueryHookResult = ReturnType<typeof useCurrentUserTasksLazyQuery>;
export type CurrentUserTasksQueryResult = Apollo.QueryResult<CurrentUserTasksQuery, CurrentUserTasksQueryVariables>;
export const VerifyPasswordResetTokenDocument = gql`
    query VerifyPasswordResetToken($resetToken: String!) {
  verifyPasswordResetToken(resetToken: $resetToken) {
    ...UserFields
  }
}
    ${UserFieldsFragmentDoc}`;

/**
 * __useVerifyPasswordResetTokenQuery__
 *
 * To run a query within a React component, call `useVerifyPasswordResetTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useVerifyPasswordResetTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVerifyPasswordResetTokenQuery({
 *   variables: {
 *      resetToken: // value for 'resetToken'
 *   },
 * });
 */
export function useVerifyPasswordResetTokenQuery(baseOptions: Apollo.QueryHookOptions<VerifyPasswordResetTokenQuery, VerifyPasswordResetTokenQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VerifyPasswordResetTokenQuery, VerifyPasswordResetTokenQueryVariables>(VerifyPasswordResetTokenDocument, options);
      }
export function useVerifyPasswordResetTokenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VerifyPasswordResetTokenQuery, VerifyPasswordResetTokenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VerifyPasswordResetTokenQuery, VerifyPasswordResetTokenQueryVariables>(VerifyPasswordResetTokenDocument, options);
        }
export type VerifyPasswordResetTokenQueryHookResult = ReturnType<typeof useVerifyPasswordResetTokenQuery>;
export type VerifyPasswordResetTokenLazyQueryHookResult = ReturnType<typeof useVerifyPasswordResetTokenLazyQuery>;
export type VerifyPasswordResetTokenQueryResult = Apollo.QueryResult<VerifyPasswordResetTokenQuery, VerifyPasswordResetTokenQueryVariables>;

      export interface PossibleTypesResultData {
        possibleTypes: {
          [key: string]: string[]
        }
      }
      const result: PossibleTypesResultData = {
  "possibleTypes": {
    "AuditCommonActionPayload": [
      "AuditChangeProviderTypeActionPayload",
      "AuditDeleteUserActionPayload",
      "AuditInvalidateAllTokensActionPayload",
      "AuditInvalidateTokenActionPayload",
      "AuditJobApplicationSharableProfileTokenCreatedActionPayload",
      "AuditJobApplicationSharableProfileTokenDeletedActionPayload",
      "AuditJobApplicationSharableProfileTokenEditedActionPayload",
      "AuditLoginActionPayload",
      "AuditManageRolesActionPayload",
      "AuditSetUserNetworkStatusActionPayload",
      "AuditUserInvitationCreatedActionPayload",
      "AuditUserRegisterActionPayload"
    ],
    "AuditPayload": [
      "AuditChangeProviderTypeActionPayload",
      "AuditDeleteUserActionPayload",
      "AuditInvalidateAllTokensActionPayload",
      "AuditInvalidateTokenActionPayload",
      "AuditJobApplicationSharableProfileTokenCreatedActionPayload",
      "AuditJobApplicationSharableProfileTokenDeletedActionPayload",
      "AuditJobApplicationSharableProfileTokenEditedActionPayload",
      "AuditLoginActionPayload",
      "AuditManageRolesActionPayload",
      "AuditSetUserNetworkStatusActionPayload",
      "AuditUserInvitationCreatedActionPayload",
      "AuditUserRegisterActionPayload"
    ],
    "ClinicIntegration": [
      "ClinicDrChronoIntegration"
    ],
    "OffsetPaginatedQueryResult": [
      "OffsetPaginatedAuditActions",
      "OffsetPaginatedUsers"
    ],
    "ProfessionalContext": [
      "APPProfessionalContext",
      "ClinicProfessionalContext",
      "NurseProfessionalContext",
      "OtherProfessionalContext",
      "PhysicianProfessionalContext",
      "TherapistProfessionalContext"
    ],
    "SharableUserProfileResult": [
      "SharableUserProfile",
      "SharableUserProfileLinkExpired",
      "SharableUserProfileLinkNotFound"
    ],
    "VerifyUserInvitationTokenResult": [
      "UserInvitation",
      "UserInvitationExpired",
      "UserInvitationNotFound"
    ]
  }
};
      export default result;
    